import { NAVIGATION } from '../../../containers/App/constants';

const faqArticles = [
  {
    name: 'revendre-billets-trains',
    title: 'Revendre Billets Trains : Comment revendre son trajet ?',
    meta: {
      title: 'FAQ Revendre Billets Trains!',
      description:
        'Vous vous demandez comment revendre vos billets de train ? Sachez que c’est possible et surtout très simple ! On vous dit tout…',
    },
    category: ['service-apres-vente'],
    updatedDate: '25/06/2022',
    content: [
      {
        type: 'body',
        content:
          '<p>Quand on est un voyageur, on peut faire face à une situation embêtante : <strong>"Vous ne pouvez plus voyager, et vous voulez récupérer votre argent"</strong>. </p> <p>Dans ce cas, c’est possible, mais seulement quand vos billets peuvent être non remboursable.</p><p>Et si…nous vous disions qu’il est toujours possible de <strong>revendre son billet Ouigo</strong> ou bien <strong>revendre son billet SNCF</strong> (Ouigo et Eurostar uniquement) ?</p> <p>Eh oui ! Qui dit non remboursable ne dit pas forcément invendable. Découvrez toutes les informations utiles à connaître si vous vous demandez s’il est possible de <strong>revendre son billet de train<strong>.</p>',
      },
      {
        type: 'body',
        content:
          '<p>Aujourd’hui, il existe de nombreux <strong>sites internet revente de billets</strong>.</p><p>Cependant, ils ne sont pas tous très accueillants, et encore moins sécurisés.<br>Alors si vous cherchez un <strong>site de revente billet train sécurisé</strong>, nous vous recommandons notre partenaire PasseTonBillet !</p> <p>PasseTonBillet, c’est un site internet qui permet d’acheter et de revendre vos <strong>billets de Train Eurostar</strong>, <strong>Ouigo, Thalys</strong>... entre particuliers.</p><p>Sur ce site, vous pourrez non seulement <strong>revendre un ticket de train</strong>, mais aussi revendre votre <strong>billet festival ou parc d’attraction.</strong></p> <p>C’est aussi un site pratique quand on souhaite vendre ou acheter un <strong>billet de train dernière minute</strong> à prix mini!</p> <p>Pour en profiter, c’est ici : <a href="https://www.passetonbillet.fr/train" rel="nofollow"> www.passetonbillet.fr</a></p>',
      },
      {
        type: 'body',
        content:
          '<a href="https://www.passetonbillet.fr/train" rel="nofollow"><img src="/assets/FAQ/service-apres-vente-passe-ton-billet.png" style="max-width:100%"/></a>',
      },
      {
        type: 'subtitle',
        content: 'Revente bon d’achat : Où puis-je le revendre ?',
      },
      {
        type: 'body',
        content:
          '<p>Vous avez bénéficié d’un bon d’achat dit “Voucher” de la part d’un transporteur de train et ou de bus, et vous ne souhaitez pas l’utiliser ?</p> <p>Sachez que c’est plus compliqué de trouver un site pour <strong>revendre son bon d’achat</strong>. <br>De nombreux sites internet sont souvent des <strong>sites non sécurisés</strong> qui peuvent être des <strong>escroqueries</strong> <br> Mais pas d’inquiétudes !</p><p>Précédemment, nous avons mentionné notre partenaire PasseTonBillet pour vos <strong>reventes billet de train</strong>.<br>Mais saviez-vous que vous pouvez non seulement <strong>revendre un billet de train Thalys et Ouigo</strong>, mais aussi <strong>revendre vos bons d’achats</strong> inutilisés directement sur son site ?</p> <p>C’est le site parfait pour ceux qui ne veulent pas perdre d’argent après avoir <strong>annulé leur voyage en train.</strong> <p>',
        description:
          '<p>Revendre un Voucher, c’est par <a href="https://www.passetonbillet.fr/voucher>https://www.passetonbillet.fr/voucher">ici</a></p>',
      },
      {
        type: 'body',
        content:
          '<p>Alors, convaincu(es) par ce site internet ?</p><p>C’est toujours embêtant de perdre de l’argent quand on annule son voyage, et chez Tictactrip, on le comprend !</p><p>C’est pourquoi nous avons toujours une solution à vous proposer.<p>',
      },
    ],
    relatedQuestions: [],
  },
  {
    name: 'comment-contacter-tictactrip',
    title: 'Comment nous contacter ?',
    meta: {
      title:
        'Vous avez un souci ? Voici comment contacter Tictactrip et obtenir votre réponse !',
      description:
        "Vous venez d'effectuer une réservation et vous rencontrez un problème ? Vous souhaiteriez seulement avoir une information ? Découvrez comment contacter Tictactrip!",
    },
    category: ['tictactrip'],
    updatedDate: '25/02/2022',
    content: [
      {
        type: 'body',
        content:
          "<p>Vous avez un souci sur l'utilisation de notre site, un problème avec votre réservation ou bien une urgence dont vous devez nous faire part ? Pas de panique, nous sommes là pour vous aider !</p><p>Afin d'optimiser la <strong>communication</strong> entre nous, voici diverses informations utiles pour contacter directement <em>Tictactrip</em> en fonction de la raison pour laquelle vous souhaitez nous <strong>joindre</strong> !</p>",
      },

      {
        type: 'body',
        content: `Accéder à ma réservation : <a href="${NAVIGATION.LOGIN}">espace mes billets</a><br> Contacter le service client : <a href="${NAVIGATION.SUPPORT}">formulaire de contact</a><br>Partenariat : <a href="mailto:sales@tictactrip.eu">sales@tictactrip.eu</a><br>Relation presse : <a href="mailto:press@tictactrip.eu">press@tictactrip.eu</a>`,
      },
      {
        type: 'img',
        content: 'tictactrip_ordinateur-contact-email-coordonnees.jpg',
        alt: 'ordinateur contact email coordonnées tictactrip',
      },

      {
        type: 'title',
        content: 'Pourquoi nous contacter',
      },
      {
        type: 'body',
        content:
          '<p>En tant qu’<strong>agence en ligne</strong> nous savons que ça peut être un véritable casse-tête pour trouver des coordonnées téléphoniques ou encore être certain d’obtenir une réponse à sa demande.<br>Nous pouvons déjà vous rassurer sur le fait que toutes les demandes écrites par mail, sur les réseaux sociaux ou via le formulaire de contact sont <strong>traitées</strong> au maximum <strong>sous 24 heures</strong>. Mais bien souvent vous obtiendrez une réponse dans les heures qui suivent. Et même le week-end !</p><p>Vous pouvez également trouver la réponse à votre question en vous rendant sur la page <strong>FAQ dédiée</strong> à votre recherche. En effet, nos FAQ ont pour but de vous fournir les informations que vous recherchez et ce, le plus rapidement et efficacement possible car nous pensons chez <em>Tictactrip</em> que votre temps est précieux !</p>',
      },
      {
        type: 'title',
        content: 'Une demande client',
      },
      {
        type: 'body',
        content: `<p>Vous souhaitez annuler un trajet, vous rencontrez un souci, ou encore vous avez une question à propos de votre réservation ?<br>Le plus simple est de nous contacter via notre <a href="${NAVIGATION.SUPPORT}">formulaire de support</a>. Notre équipe traite toutes vos demandes dans la joie et la bonne humeur. Vous recevez automatiquement un message confirmant que votre demande a bien été envoyée. Dans l’attente de la résolution de celle-ci ne faite pas de demande en doublon, ne tentez pas de réserver un nouveau billet ou autres. Attendez que nous vous apportions une solution avant de faire quoi que ce soit<br>Si votre demande est <strong>urgente</strong>, il suffira d’appuyer sur <q> urgent </q>, lorsque vous recevrez le mail automatique de confirmation de votre demande.</p><p>Vous pouvez également nous contacter en appuyant sur le bouton <q> contact </q> en haut à droite puis sélectionner <q> service client </q>. Cela vous ouvrira directement un formulaire à remplir.</p><p>Enfin, si vous le souhaitez, nous avons mis un numéro à disposition sur nos horaires d’ouverture afin de pouvoir vous apporter une assistance supplémentaire. Vous le trouverez en haut de notre page.</p>`,
      },
      {
        type: 'title',
        content: 'Une demande professionnelle',
      },
      {
        type: 'body',
        content:
          '<p>Peu importe l’<strong>entreprise</strong> que vous êtes, si vous vous posez des questions pour un éventuel projet de <strong>partenariat</strong> ou toute autre proposition, vous pouvez nous contacter sur l’adresse mail suivante : <a href="mailto:sales@tictactrip.eu">sales@tictactrip.eu</a>. Nous serons ravis d’étudier les différentes possibilités envisageables.</p><p>Offices de tourisme ? Stations de ski ? Festivals ? Vous pouvez également faire la demande pour intégrer un de nos <strong>widgets</strong> sur votre site en vous rendant sur <a href="https://www.tictactrip.eu/partners">cette page.</a></p></p>Pour tout ce qui est relatif à la <strong>relation presse</strong> ou à la communication, veuillez nous contacter via notre adresse mail : <a href="mailto:press@tictactrip.eu">press@tictactrip.eu</a></p><p>À savoir que tous les mails de <strong>publicités</strong> et <strong>spams</strong> ne sont pas ouverts</p>.',
      },
      {
        type: 'title',
        content: 'Autre contact et réseaux sociaux',
      },
      {
        type: 'body',
        content:
          '<p>Nous avons également une adresse mail dédiée pour toutes les autres demandes non mentionnées plus haut :<a href="mailto:contact@tictactrip.eu">contact@tictactrip.eu</a>.</p><p>Enfin, vous l\'avez sûrement remarqué, <em>Tictactrip</em> est très présent sur les réseaux sociaux  et notamment :<ul><li><a href="https://www.facebook.com/tictactrip/">Facebook Tictactrip</a>,</li><li><a href="https://x.com/tictactrip">Twitter Tictactrip</a>,</li><li><a href="https://www.instagram.com/tictactrip.eu/">Instagram Tictactrip</a>.</li></ul></p><p>Notre community manager se fera alors un plaisir de répondre à vos messages sur les réseaux sociaux et de vous orienter au mieux en fonction de vos besoins !</p><p>Vous avez désormais toutes les clés en main pour nous contacter et vous adresser directement au service adéquat et de la meilleure des façons en fonction de votre problème !</p><p>Au plaisir d\'échanger avec vous sur vos besoins.</p>',
      },
    ],
    relatedQuestions: [],
  },
  {
    name: 'intermodalite-multimodalite-transports-combines',
    title: 'Lexique : Intermodalité, multimodalité et transports combinés',
    meta: {
      title:
        'Lexique mobilité : Intermodalité, multimodalité et transports combinés',
      description:
        "On s'y perd vite avec tous ces nouveaux termes sur la mobilité de demain... On vous explique tous ces termes d'intermodalité, multimodalité et autres dans cette page lexique !",
    },
    category: ['tictactrip'],
    updatedDate: '03/02/2020',
    content: [
      {
        type: 'body',
        content: `<p>Vous êtes un peu perdu avec tous ces termes nouveaux qui arrivent avec l"émergence de nouvelles technologies et de <strong>nouvelles façons de se déplacer </strong>?</p>
<p>Ne vous inquiétez pas, <em>Tictactrip</em>, pionnier dans <strong>l"intermodalité pour le transport de voyageurs</strong> est là pour vous !</p>
<p>Découvrons ensemble les définitions de ces termes avant d"en arriver à la description concrète du service inédit de <em>Tictactrip</em> !</p>`,
      },
      {
        type: 'title',
        content: 'Intermodalité, définition',
      },
      {
        type: 'body',
        content:
          '<p>Eh bien oui avant toute chose il faudrait penser à définir ces termes !</p>',
      },
      {
        type: 'subtitle',
        content: "Qu'est-ce que l'intermodalité ?",
      },
      {
        type: 'body',
        content: `<p>Le <strong>concept d"intermodalité</strong> n"est pas nouveau ! En effet, il était d"actualité depuis longtemps dans le secteur du transport de marchandises. Sa nouveauté, c"est donc son application au <strong>transport de personnes</strong>.</p>
<p>Le concept est alors tout simple à comprendre et <em>Wikipédia</em> l"explique au mieux en disant que :</p>
<p>« <em>L'intermodalité est l'utilisation de plusieurs modes de transport au cours d'un même déplacement</em>.».</p>
<p>Ce nouveau concept incitant alors à l"utilisation de différents types de transports en commun lors d"un même déplacement, permet à la fois d"arriver aisément à sa destination finale, ce qui n"est souvent pas le cas en utilisant qu"un seul type de transport, mais aussi de moins polluer ! Ce dernier point est d"ailleurs l"un des enjeux pour lesquels <em>Tictactrip</em> souhaite encore développer ses services !</p>
<p>Pour votre trajet, choisissez une combinaison de bus 🚌 et de train 🚄 ou encore de train vers la montagne 🚞 et de navette 🚎 pour monter en station de ski !</p>
<p>Alors, vous avez compris le principe de l"intermodalité ? Découvrons alors ensemble les différences avec la multimodalité.</p>`,
      },
      {
        type: 'title',
        content: 'Multimodalité, définition',
      },
      {
        type: 'body',
        content:
          '<p>Il est maintenant question de <strong>multimodalité</strong>, toujours plus de nouveaux termes complexes…</p>',
      },
      {
        type: 'subtitle',
        content: "Qu'est-ce que la multimodalité ?",
      },
      {
        type: 'body',
        content: `<p>Commençons avec la <strong>définition de multimodalité</strong> que nous donne l"Encyclopédie du net, <em>Wikipédia</em> : </p>
<p>"<em>La multimodalité désigne la présence de plusieurs modes de transport différents entre deux lieux</em>."</p>
<p>La multimodalité se caractérise alors par le fait que l"on vous laisse le choix ! Effectivement, vous avez le choix entre différents modes de transports pour un même trajet. Cependant, pour effectuer ce-dit trajet, vous n"aurez la possibilité que de choisir un unique type de transport. C'est d'ailleurs là que les <strong>comparateurs de transports</strong> comme <em>Tictactrip</em> vous sont d'une grande utilité ! C"est bien là que réside toute la différence avec le principe d"intermodalité qui vous offre la possibilité d"utiliser à votre avantage les réseaux de transports pour optimiser votre trajet en les combinants ! Vous nous suivez toujours ? Tant mieux ! </p>
<p>Pour un trajet, vous êtes plus covoiturage 🚗, bus 🚌 ou train 🚄 ?</p>
<p>Selon nous, rien ne peut mieux imager ces deux principes; de multimodalité et d"intermodalité, que le site et le service de <em>Tictactrip</em>.</p>`,
      },
      {
        type: 'title',
        content: 'Le service Tictactrip, comparateur intermodal',
      },
      {
        type: 'body',
        content: `<p><em>Tictactrip</em>, qui s"est lancé en 2016, a pour but : à la fois de <strong>désenclaver les territoires français et européens</strong>, mais aussi de <strong>développer le transport éco-responsable</strong> tout en permettant aux voyageurs de <strong>se déplacer aux meilleurs prix 💰 et pour les meilleures durées de trajets</strong> ⏱ !</p>
<p>Mais comment le site <em>Tictactrip</em> met il en avant les principes de multimodalité et d"intermodalité ?</p>
<p>Eh bien c"est tout simple, <em>Tictactrip</em> est avant tout un <strong>comparateur de transports terrestres</strong>. De ce fait, nous vous comparons, pour un même trajet, les offres de bus, train et covoiturage : c"est le côté <strong>multimodal</strong> !</p>
<p>Et, à côté de ces comparaisons, vous pouvez découvrir notre onglet spécial : « combiné » ! Celui-ci utilise notre algorithme de combinaisons intelligentes afin de vous proposer des trajets combinant différents mode de transport : C'est le coté intermodal !</p>
<p>Afin que vous compreniez mieux de quoi il est question, voici le service proposé par le site <em>Tictactrip</em> en image :</p>`,
      },
      {
        type: 'img',
        content:
          'Lexique - intermodalite multimodalite transport combines - service comparateur tictactrip.png',
      },
      {
        type: 'body',
        content: `<p>Sur cette image, qui montre le site <em>Tictactrip</em> en action, vous avez nombres d"informations pour le trajet que vous avez sélectionné.</p>
<p>Il s"agit du trajet que vous avez choisi de comparer sur notre site. C"est pour ce trajet que vous trouverez les comparaisons des types de transports : bus, train et covoiturage, ainsi que nos propositions de trajets combinés. Découvrons ensemble les différentes focntionnalités de notre outil de comparaison de transports !
<ul>
<li>Vous pouvez voir les différents onglets, par type de transport. Sur ceux-ci, se trouvent deux informations : le prix le moins cher que nous ayons trouvé ainsi que le temps de trajet allant avec.  Si vous cliquez dessus, s"afficheront les informations et propositions de trajets pour ce type de transport unique ! Sur cette image, aucun train ni bus ne fais le trajet dans sa totalité, c'est pourquoi il n'y a pas de résultats. </li>
<li>Aussi, il y a également un onglet « combiné ». Comme pour les autres, il y est indiqué le prix le moins cher que nous ayons trouvé en combinant les différents types de transport et le temps de trajet qui correspond. Si vous cliquez dessus, s"afficheront, comme sur l"image, les propositions de trajets combinés. Vous pouvez donc découvrir que pour ce trajet en exemple, nous avons décidé de vous proposer une combinaison d"un train TGV OuiGo depuis Lille jusqu'à Lyon, puis d"un bus Altibus de Lyon jusqu"à votre station de ski préférée de Méribel les Allues. 🎿 </li></ul></p>
<p>Alors, convaincu(es) par l"efficacité et l"utilité de notre service et des possibilités qu"il vous offre ? N"hésitez pas à le découvrir et à l"utiliser vous-même, mais attention, de si petits prix pour voyager ça rend vite addict !</p>`,
      },
    ],
    relatedQuestions: [],
  },
  {
    name: 'bons-plans-sncf',
    title: 'Les bons plans SNCF',
    meta: {
      title: 'Les bons plans SNCF',
      description: 'Les bons plans SNCF',
    },
    category: ['paiement'],
    updatedDate: '17/03/2020',
    content: [
      {
        type: 'body',
        content:
          '<p> Vous êtes un grand voyageur et adepte du train pour vos déplacements en Europe ?\nTictactrip vous conseille de <strong>souscrire à l’une des offres bons plans SNCF </strong>pour profiter de nombreux avantages sur vos futurs voyages !\nSuivez ce guide pour choisir la formule la plus adaptée à vos habitudes de voyage.</p>',
      },
      {
        type: 'title',
        content: 'Les cartes de réductions',
      },
      {
        type: 'body',
        content:
          '<p> Ce sont les options les plus susceptibles de vous correspondre si vous prenez le train régulièrement.\n\nÀ date, la SNCF propose <strong>4 types de cartes de réductions</strong> pour tous les types de voyageurs :<ul><li><p>Voyageurs de 12 à 27 ans inclus : <strong>Carte Avantage Jeune</strong> (anciennement Carte Jeune SNCF) ;</p></li><li><p>Voyageurs de 60 ans et plus : <strong>Carte Avantage Senior</strong> (anciennement Carte Senior+ SNCF) ;</p></li><li><p>Voyageurs de 28 à 59 ans inclus sans enfants : <strong>Carte Avantage Week-end</strong> (anciennement Carte Week-end SNCF) ;</p></li><li><p>Voyageurs de 28 à 59 ans inclus avec enfants : <strong>Carte Avantage Famille</strong> (anciennement Carte Enfant+ SNCF).</p></li></ul>\nVous pouvez souscrire à la carte correspondant à votre situation, peu importe laquelle, pour <strong>49€</strong>.\nToutes sont valables tous les jours de l’année pour une période d’<strong>un an</strong> à compter de la date d’achat.\n\nChacune vous offre les bons plans SNCF suivants :<ul><li><p>-30% sur les trajets en INTERCITÉS et en TGV (dont certains en Europe), et ce même sur les billets Prem’s ;</p></li><li><p>de -25% à -50% sur les TER ;</p></li><li><p>des prix avantageux et exclusifs de dernière minute ;</p></li><li><p>-15% sur certains services au bar, sur vos bagages et sur les locations de voitures AVIS.</p></li></ul>\n\nAvantages particuliers :<ul><li><p>les <strong>Cartes Avantage Senior et Avantage Famille</strong> proposent aussi -60% sur les billets de jusqu’à 3 enfants accompagnateurs de 4 à 11 ans (en plus des bons plans SNCF cités ci-dessus).</p></li><li><p>la <strong>Carte Avantage Week-end</strong> propose également de faire bénéficier un accompagnant de votre réduction (en plus des bons pans SNCF cités ci-dessus).</p></li></ul></p>',
      },
      {
        type: 'subtitle',
        content: 'Vous êtes porteur d’une ancienne carte SNCF ?',
      },
      {
        type: 'body',
        content:
          '<p>Aucun problème : vous continuez à bénéficier des mêmes avantages de votre carte jusqu’à sa date d’expiration 👍</p>',
      },
      {
        type: 'subtitle',
        content: 'Pas sûr d’amortir le coût de votre carte ?',
      },
      {
        type: 'body',
        content:
          '<p> Vérifiez la rentabilité de celle qui vous intéresse en entrant vos trajets à venir et voyez en combien de déplacements vous pourrez l’amortir ci-dessous : <ul><li><a href="https://www.oui.sncf/train/carte-abonnement-train/avantage-jeune" target="_blank">Carte Avantage Jeune</a></li><li><a href="https://www.oui.sncf/train/carte-abonnement-train/avantage-senior" target="_blank">Carte Avantage Senior</a></li><li><a href="https://www.oui.sncf/train/carte-abonnement-train/avantage-week-end" target="_blank"> Carte Avantage Week-end </a></li><li><a href="https://www.oui.sncf/train/carte-abonnement-train/avantage-famille" target="_blank">Carte Avantage Famille</a></li></ul></p>',
      },
      {
        type: 'title',
        content: 'Les abonnements',
      },
      {
        type: 'subtitle',
        content: 'L’Abonnement TGVmax',
      },
      {
        type: 'body',
        content:
          '<ul> <li> <p>Critères d’éligibilité : voyageurs de 16 à 27 ans inclus</p> </li> <li> <p>Prix : <strong>79€</strong></p> </li> <li> <p>Validité : <strong>1 mois</strong> à compter de la date d’achat, engagement de 3 mois</p> </li> <li> <p>Avantages :</p> <ul> <li> <p> billets de TGV et INTERCITÉS à 0€ ; </p> </li> <li> <p> possibilité de réserver jusqu’à 30 jours avant le départ ; </p> </li> <li> <p> possibilité de réserver jusqu’à 6 billets en même temps ; </p> </li> <li> <p> l’assistant OUIbot pour vous alerter de la disponibilité des billets qui vous intéressent et les réserver pour vous ; </p> </li> <li> <p> des avantages au wagon bar. </p> </li> </ul> </li> </ul> ',
      },
      {
        type: 'subtitle',
        content: 'La Carte Liberté (anciennement Abonnement Fréquence)',
      },
      {
        type: 'body',
        content:
          '<ul> <li> <p>Critères d’éligibilité : aucun, mais cette offre est généralement plus adaptée aux voyageurs d’affaires ou effectuant <strong>plus de 4 aller-retour</strong> dans l’année.</p> </li> <li> <p>Prix : <strong>399€</strong></p> </li> <li> <p>Validité : <strong>1 an</strong> à compter de la date d’achat</p> </li> <li> <p>Avantages :</p> <ol> <li> <p>Sur les trains <strong>INTERCITÉS</strong> et les <strong>TGV INOUI</strong> (dont certains en Europe) :</p> <ul> <li> <p>des petits prix uniques et donnés en avance sur vos billets ;</p> </li> <li> <p>des réductions en 1ère et en 2nde classes en exclusivité ;</p> </li> <li> <p>l’échange et le remboursement sans frais jusqu’à 30 minutes après le départ du train.</p> </li> </ul> </li> <li> <p>Sur les <strong>TER</strong> :</p> <ul> <li> <p>de 25% à 50% de réduction sur vos billets.</p> </li> </ul> </li> <li> <p>Et <strong>en plus</strong> :</p> <ul> <li> <p>des réductions et bons plans SNCF sur les locations de voitures AVIS et les taxis pour aller ou repartir de la gare.</p> </li> <li> <p>20€ de réduction sur l’abonnement annuel si vous souscrivez via votre entreprise. </p> </li> <li> <p>l’échange et le remboursement sans frais jusqu’à 30 minutes après le départ du train.</p> </li> </ul> </li> </ol></ul> ',
      },
      {
        type: 'subtitle',
        content: 'Le Forfait SNCF',
      },
      {
        type: 'body',
        content:
          '<ul> <li> <p>Critères d’éligibilité : aucun, mais cette offre est généralement plus adaptée aux voyageurs effectuant un <strong>trajet spécifique très fréquemment</strong>.</p> </li> <li> <p>3 formules :</p> <ol> <li> <p><strong>Forfait court</strong> : abonnement à la semaine ou au mois sur un trajet au choix.</p> </li> <li> <p><strong>Optiforfait</strong> : abonnement annuel sur un trajet s’effectuant en train INTERCITÉ ou TER.</p> </li> <li> <p><strong>Mon forfait annuel</strong> : abonnement annuel sur un trajet s’effectuant en TGV INOUI.</p> </li> </ol> </li> <li> <p>Avantages :</p> <ul> <li> <p>choix de la durée de forfait qui vous convient le mieux ;</p> </li> <li> <p>des billets à <strong>1,50€ maximum</strong> et réservables en avance.</p> </li> </ul> </li> </ul> ',
      },
      {
        type: 'subtitle',
        content: 'Pas sûr d’amortir le coût de votre abonnement ?',
      },
      {
        type: 'body',
        content:
          '<p> Vérifiez la rentabilité de votre abonnement en entrant vos trajets à venir et voyez en combien de déplacements vous pourrez l’amortir ci-dessous : <ul><li><p><a href="https://www.oui.sncf/train/carte-abonnement-train/avantage-jeune">Abonnement TGVmax</a> (à comparer avec la Carte Avantage Jeune)</p></li><li><a href="https://www.oui.sncf/train/carte-abonnement-train/liberte">Carte Liberté</a></li></ul></p>',
      },
      {
        type: 'title',
        content:
          'Comment profiter des bons plans SNCF de votre carte ou de votre abonnement en réservant sur Tictactrip ?',
      },
      {
        type: 'body',
        content:
          '<p>Rassurez-vous, c’est très simple !</p> <p>Il vous suffit de suivre les étapes suivantes au moment de votre réservation :</p> <ol> <li> <p>Rendez-vous sur le site <a href="https://www.tictactrip.eu">https://www.tictactrip.eu.</a> </p> </li> <li> <p>Entrez vos gares ainsi que vos dates de départ et d’arrivée dans l’encart de gauche « Quel est votre trajet ».</p> </li> <li> <p>Dans l’encart de droite « Dîtes-nous qui voyage », choisissez entre Jeune (0-27), Adulte (28-59) et Senior (60+) selon votre situation.</p> </li> <li> <p>Juste en dessous, dans le menu déroulant <strong>« Carte de réduction »</strong>, sélectionnez la carte ou l’abonnement donc vous êtes porteur.</p> </li> <li> <p>Cliquez sur le <strong>bouton « Validez ce passager »</strong> dans l’encart de droite, répétez l’opération si vous voyagez à plusieurs, puis sur le bouton « Rechercher » dans l’encart de gauche.</p> </li> </ol> <p>Et voilà, vos avantages et bons plans SNCF sont directement pris en compte dans les résultats de votre recherche 🙂️️</p> <p>Vous trouverez ci-dessous un exemple imagé dans le cas d’un porteur de Carte Avantage Jeune :</p> ',
      },
      {
        type: 'img',
        content: 'FAQ Bons plans SNCF - carte de reduction.jpg',
      },
      {
        type: 'body',
        content:
          '<p>En plus de toutes les cartes et abonnements bons plans SNCF détaillés dans les sections précédentes, le menu déroulant « Carte de réduction » vous permet de saisir bien d’autres cas particuliers comme :</p> <ul> <li> <p>Bébé place distincte ;</p> </li> <li> <p>Famille nombreuse 30%, 40%, 50% ou 75% ;</p> </li> <li> <p>Abonnement demi-tarif ;</p> </li> <li> <p>Abonnement Général (AG) 1e ou 2e classe ;</p> </li> <li> <p>Carte militaire 1e et 2e classe ;</p> </li> <li> <p>Carte famille militaire ;</p> </li> <li> <p>Thalys premium pass ;</p> </li> <li> <p>Thalys Frequent Pass ;</p> </li> <li> <p>Thalys ThePass Weekend.</p> </li> </ul> <p> <strong>Vous ne trouvez toujours pas votre carte ou abonnement bons plans SNCF ?</strong> Contactez-nous via le chat Messenger de notre page Facebook Tictactrip, et nous arrangerons cela pour vous 🤗 </p> ',
      },
      {
        type: 'title',
        content: 'Bonus : le programme de fidélité ',
      },
      {
        type: 'body',
        content:
          '<p> Vous avez calculé : vous ne voyagez pas assez pour rentabiliser une carte ou un abonnement bons plans SNCF ? ' +
          'Tictactrip a encore une dernière carte dans sa manche : le <strong>programme de fidélité Voyageur SNCF</strong>. ' +
          'Totalement gratuit, il suffit simplement de remplir ce formulaire pour cumuler des points et être récompensé 🎁 </p> ',
      },
    ],
    relatedQuestions: ['explication-3d-secure', 'problemes-de-paiement-debite'],
  },
  {
    name: 'compagnies-transport-annulation-remboursement-coronavirus',
    title: 'Compagnies de transport : annulations et remboursement COVID-19',
    meta: {
      title:
        'Circuation des transports, annulation et remboursement des compagnies partenaires de Tictactrip suite à la crise sanitaire',
      description:
        "Suite aux annonces gouvernementales de reconfinement le week-end et de couvre-feu vous devez annuler votre transport ou savoir si celui-ci circule. Trouvez toutes les informations de circulation, d'échange et de remboursement selon les compagnies partenaires de Tictactrip",
    },
    category: ['conditions-de-voyage-tarifs-compagnies'],
    updatedDate: '25/08/2021',
    content: [
      {
        type: 'body',
        content:
          "<p>Depuis le 20 juin 2021, le couvre-feu a été levé en France.</p><p>Cela annonce donc la reprise des déplacements en totale liberté. Cependant les compagnies de transport ont quand même dû s'adapter à la situation et faire preuve d'une certaine souplesse parfois.<br>Mais, qu’en est-il des politiques d’annulation et de remboursement de vos compagnies de transports maintenant que les déplacements redeviennent à la normale ? On vous dit tout !</p>",
      },
      {
        type: 'img',
        content:
          'Conditions et Tarifs annulation-remboursement-compagnies-transport-coronavirus.jpg',
        alt: 'Conditions et Tarifs annulation-remboursement-compagnies-transport-coronavirus',
        imgSizePercent: 70,
      },
      {
        type: 'title',
        content:
          'Les compagnies de transport qui ne circulent toujours pas après la période de confinement',
      },
      {
        type: 'body',
        content:
          "<p>Pour certaines de ces compagnies, il était préférable d'arrêter leur desserte. Depuis l'arrêt du couvre-feu, elles ont pu renprendre du service.</p>",
      },
      {
        type: 'subtitle',
        content: 'La compagnie Bus Blablacar',
      },
      {
        type: 'body',
        content:
          '<p>Pour vous protéger, la compagnie de bus <em>Blablacar</em> a suspendu  ses lignes de bus depuis le <strong>du 02 Novembre 2020</strong>. La reprise prist effet depuis le mois de mai.</p><p>Il faut bien entendu respecter les mesures de sécurité et les gestes barrières à bord. Le port du masque étant obligatoire et le pass sanitaire également.',
      },
      {
        type: 'subtitle',
        content: 'La compagnie Izy',
      },
      {
        type: 'body',
        content:
          "<p>Afin d’assurer une sécurité maximale pour ses voyageurs, la compagnie de train low cost Izy avait également décidé de suspendre la circulation de ses trains depuis le 07 décembre 2020.<br> La reprise s'est faite dès le mois de mai avec toutes les mesures sanitaires en vigueur.</p>",
      },
      {
        type: 'title',
        content:
          ' Les compagnies de transport qui circulent pendant la période de confinement',
      },
      {
        type: 'body',
        content:
          '<p>Pour les autres compagnies, il s’agit de retrouver l’offre de transport initial en garantissant la sécurité des usagers. Cela vous permettra de vous déplacer dans les meilleures conditions possibles.</p>',
      },
      {
        type: 'subtitle',
        content: 'La compagnie Flixbus',
      },
      {
        type: 'body',
        content:
          "<p>Depuis le 17 décembre le trafic a repris entièrement pour la compagnie Flixbus. Vous pouvez dès à présent vous déplacer dans toute la France et l’Europe dans le respect de mesures sanitaires strictes.<br> Pour les voyages à l'étranger n'oubliez pas de consulter les informations sanitaires d'accès dans le pays d'arrivée. Vous trouverez plus d’informations sur <a href='[https://www.flixbus.fr/informations-reseau-et-securite](https://www.flixbus.fr/informations-reseau-et-securite)'>cette page</a>.<br> Il est possible d'annuler son billet selon les conditions habituelles de <em>Flixbus</em>, avec des frais d'annulation entre 29 jours et la date du départ.</p>",
      },
      {
        type: 'subtitle',
        content: 'La compagnie SNCF',
      },
      {
        type: 'body',
        content:
          "<p>La <em>SNCF</em> comprenant les trains TGV INOUI, INTERCITÉS et OUIGO a retrouvé son offre de train complète. De même, l’annulation et l'échange sans frais jusqu'à la date du départ n'est plus possible depuis le 12/09/21. Toutes les conditions de voyage sont celles du billet.</p><p>Concernant les billets Ouigo, ils ne sont plus annulables mais restent échangeables moyennant 10€.</p>",
      },
      {
        type: 'subtitle',
        content: 'La compagnie Eurostar',
      },
      {
        type: 'body',
        content:
          '<p>Il est toujours possible de se rendre au Royaume-Uni mais il faut bien vérifier les informations et les autorisations de déplacement vers le Royaume-Uni sur le <a href="[https://uk.ambafrance.org/Conditions-de-deplacement-entre-la-France-et-le-Royaume-Uni](https://uk.ambafrance.org/Conditions-de-deplacement-entre-la-France-et-le-Royaume-Uni)">site du gouvernement</a>.<br>Les billets sont tous flexibles afin de faciliter les procédures d‘échange et de remboursement.<br>Il faut par ailleurs se munir d’un pass sanitaire et remplir tous les formulaires obligatoires selon sa situation.</p>',
      },
      {
        type: 'subtitle',
        content: 'La compagnie Thalys',
      },
      {
        type: 'body',
        content: `<p>Des mesures exceptionnelles ont été mises en place chez <em>Thalys</em> afin de garantir votre sécurité.<br>Seul les billets ayant une tarification spécifiques sont échangeables ou remboursables. Vous retrouverez toutes les informations relatives au traffic <a href="[https://www.thalys.com/be/fr/situation-sanitaire-coronavirus-mesures-commerciales-exceptionnelles](https://www.thalys.com/be/fr/situation-sanitaire-coronavirus-mesures-commerciales-exceptionnelles)"> juste ici</a>.<br>En cas d’annulation ou demande de remboursement veuillez <a href="${NAVIGATION.SUPPORT}">nous contacter</a>.</p>`,
      },
      {
        type: 'subtitle',
        content: 'La compagnie Lyria',
      },
      {
        type: 'body',
        content: `<p>La circulation des trains <em>Lyria</em> a également entièrement repris.<br>L’annulation de votre billet est possible selon plusieurs conditions. Le plan de transport et les conditions actualisées sont disponibles sur  <a href="[https://www.tgv-lyria.com/fr/fr/timetables-and-fares/traffic-information](https://www.tgv-lyria.com/fr/fr/timetables-and-fares/traffic-information)">ce site</a>.<br>Pour la gestion de l’après-vente contactez encore une fois l’équipe support via <a href="${NAVIGATION.SUPPORT}">ce formulaire</a>.</p>`,
      },
      {
        type: 'subtitle',
        content: 'Prenez soin de vous !',
      },
      {
        type: 'body',
        content:
          "<p>Durant cette période, nous insistons sur le fait de respecter les gestes barrières. N'oubliez pas votre pass sanitaire pour monter à bord des transports.<br> Nous y arriverons tous ensemble ! Nous espérons tout autant que vous recommencerez à voyager comme avant, et de manière éco-responsable bien sûr !<br>Nous restons à votre écoute et à votre disposition pour toute demande d’assistance.</p>",
      },
    ],
    relatedQuestions: [
      'politique-annulation-remboursement-billet',
      'pass-sanitaire-voyages',
    ],
  },
  {
    name: 'comment-reserver-billet-enfant',
    title: 'Comment réserver un billet enfant ?',
    meta: {
      title: 'Comment réserver un billet enfant sur Tictactrip ?',
      description:
        'Vous souhaitez savoir s’il est possible de réserver un billet enfant sur Tictactrip et comment réserver un billet enfant ? C’est tout simple !',
    },
    category: ['recherche-reservation-billets'],
    updatedDate: '19/03/2020',
    content: [
      {
        type: 'body',
        content:
          '<p>Réserver un billet pour votre enfant peut-être, sur certains sites, un réel casse-tête, on en est bien conscient chez Tictactrip ! C’est pourquoi nous avons cherché à vous faciliter au maximum cette tâche ! Pour réserver votre billet train enfant, rien de plus simple, suivez le guide !',
      },
      {
        type: 'img',
        content: 'recherche-reservation-billets_billet-train-enfant.png',
      },
      {
        type: 'title',
        content: 'Réserver un billet enfant, dans quels cas ?',
      },
      {
        type: 'body',
        content:
          '<p>Tout d’abord, il faut savoir qu’en fonction de la compagnie qui dessert le trajet que vous souhaitez réserver, il n’y aura pas forcément de différenciation entre un billet enfant et un billet adulte et même parfois senior. Tout dépendra donc bien de la compagnie de transport partenaire chez qui vous vous apprêtez à effectuer votre réservation de billets de bus ou train.</p><p>Cependant, pour vous faciliter la démarche et vous éviter de devoir aller sur nos pages d’informations sur nos compagnies partenaire pour savoir s’il existe des billets de train enfant par exemple, nous avons fait en sorte que vous puissiez choisir l’âge des passagers qui voyagent, dès votre recherche de trajets. Ainsi, vous aurez directement les prix actualisés en fonctions des types de billets existant chez la compagnie ! Sympa non ? Mais là vous me dites "Mais comment réserver mon billet de train enfant ?". Nous n’avons qu’une chose à vous dire : lisez la suite, on vous explique tout par étapes !</p>',
      },
      {
        type: 'title',
        content: 'Les étapes pour réserver votre billet enfant sur Tictactrip',
      },
      {
        type: 'body',
        content:
          '<p>Aller c’est parti, voici les étapes simples pour que vous réserviez le billet de votre enfant pour votre voyage qui s’annonce !</p>',
      },
      {
        type: 'subtitle',
        content: 'Étape 1, choisissez votre trajet',
      },
      {
        type: 'body',
        content:
          '<p>Eh oui, avant de se lancer dans une réservation, il faut connaître son trajet vous vous en doutez bien ! Une fois cela fait, vous n’avez plus qu’à le rentrer dans notre moteur de recherche comme ci-dessous :</p>',
      },
      {
        type: 'img',
        content: 'recherche-reservation-billets_billet-train-enfant-etape1.jpg',
      },
      {
        type: 'body',
        content:
          '<p>Dans ces encadrés en rouge, vous pouvez donc voir votre trajet résumé. Vous pourrez ensuite choisir votre date de départ aller et potentiellement votre date de retour. Mais où remplir les champs quant aux passagers et à votre enfant qui voyage ?</p>',
      },
      {
        type: 'subtitle',
        content: 'Étape 2, qui voyage ?',
      },
      {
        type: 'body',
        content:
          '<p>Ça y est, nous y sommes déjà ! Nous ne vous avions pas dit que ça irait vite ?!</p><p>En fait, il vous faudra seulement indiquer qui voyage comme sur cette image ci-dessous une nouvelle fois :</p>',
      },
      {
        type: 'img',
        content:
          'recherche-reservation-billets_billet-de-train-enfant-etape2.jpg',
      },
      {
        type: 'body',
        content:
          '<p>Vous pouvez alors voir, encadrés en rouge, les parties importantes. Vous voyez bien que sur cette image, seul un adulte voyage. Pour modifier cela, vous n’aura qu’a cliqué juste à droite. Autrement, si vous souhaitez rajouter des passagers, rien de plus simple : il vous faut cliquer sur "+ Ajouter un autre passager". Voilà alors ce qu’il s’affichera :</p>',
      },
      {
        type: 'img',
        content:
          'recherche-reservation-billets_billet-de-bus-enfant-etape3.jpg',
      },
      {
        type: 'body',
        content:
          '<p>Enfin, sur cette image, vous avez toutes les informations qui vous sot demandées pour l’ajout d’un nouveau passager : sa tranche d’âge, puis son âge précis et enfin s’il possède ou non une carte de réduction appropriée. Si oui, n’hésitez pas à la saisir dans le menu déroulant qui s’affichera à vous.</p><p> Et voilà, c’est déjà fini, vous venez de sélectionner un passager enfant sur notre site en trois clics. Il ne vous reste plus qu’à rechercher votre trajet, à comparer et choisir les offres qui vous intéressent avant de réserver et payer votre trajet et donc votre billet enfant !</p><p>Nous vous souhaitons un agréable voyage en famille !</p>',
      },
    ],
    relatedQuestions: [
      'voyageur-handicape-mobilite-reduite-reservation-billet',
    ],
  },
  {
    name: 'voyageur-handicape-mobilite-reduite-reservation-billet',
    title:
      'Voyageur handicapé ou à mobilité réduite, puis-je réserver mes billets sur Tictactrip ?',
    meta: {
      title:
        'FAQ pour voyageur handicapé et à mobilité réduite  - Toutes les réponses à vos questions !',
      description:
        'Vous êtes un voyageur handicapé ou en avez un dans votre entourage et vous souhaitez savoir s’il est possible de réserver un billet ? On vous dit tout !',
    },
    category: ['recherche-reservation-billets'],
    updatedDate: '19/03/2020',
    content: [
      {
        type: 'body',
        content:
          '<p>Réserver un billet pour un voyageur handicapé et/ou à mobilité réduite peut-être un véritable casse-tête et on le sait très bien chez Tictactrip ! C’est pourquoi nous avons décidé de vous faciliter vos démarches en créant cette FAQ qui vous est spécialement dédiée, car on pense que tout le monde à le droit de voyager aussi facilement !</p>',
      },
      {
        type: 'img',
        content: 'recherche-reservation-billets_fauteuil-roulant-icone.png',
        imgSizePercent: 40,
      },
      {
        type: 'title',
        content: 'Comment réserver un billet pour un voyageur handicapé ?',
      },
      {
        type: 'body',
        content:
          '<p>Eh bien vous allez être déçu, il n’est pas encore possible de réserver de A à Z un billet pour un voyageur handicapé ou un voyageur à mobilité réduite, mais c’est dans nos projets (c’est seulement complexe à mettre en place au début...)</p><p>En effet, c’est compliqué car même pour les compagnies, les modalités sont différentes pour réserver votre billet. La plupart du temps, il vous faudra faire au cas par cas en fonction de la compagnie que vous choisirez pour votre voyage. Il vous faudra seulement réserver votre billet normalement, puis par la suite téléphoner au numéro spécifique pour effectuer ce type de requête et alors pouvoir jouir du service d’aide à la mobilité mis en place par la compagnie. Voici quelques exemples en fonction des compagnies.</p>',
      },
      {
        type: 'subtitle',
        content:
          'Un trajet pour voyageur handicapé avec les trains OuiGo de la SNCF',
      },
      {
        type: 'body',
        content:
          '<p>Les trains <em>OuiGo</em>  de la <em>SNCF</em> mentionnent bien, et vous vous en doutez, que les voyageurs en situation de handicap et personnes à mobilité réduite peuvent assurément voyager avec leur compagnie de train.</p><p>Pour se faire cependant et avoir droit au service Accès + mis en place par la SNCF, il faudra que, après avoir réservé votre billet, vous remplissiez le formulaire de demande de ce service au moins 48h avant votre départ. Pour remplir ce formulaire en question, rendez-vous juste ici : <a href="https://www.ouigo.com/contact?objet=HDC" target="_blank">https://www.ouigo.com/contact?objet=HDC</a>. C’est simple et rapide, vous voyez ! En plus, vous aurez accès au service Accès + qui vous propose un accueil en gare et tout un processus pour s’occuper de vous au mieux si vous en avez besoin ! Plutôt sympa non ?</p>',
      },
      {
        type: 'subtitle',
        content:
          'La réservation et l’accès aux Personnes à Mobilité Réduite pour les bus BlaBlaBus',
      },
      {
        type: 'body',
        content:
          '<p>Eh oui, les bus BlaBlaBus s’adaptent également à vous pour vous permettre de voyage à prix minis ! Que vous soyez en situation de handicap ou que vous possédiez une mobilité réduite, vous pourrez monter à bord de votre bus BlaBlaBus sans encombre ! </p><p>Attention cependant à respecter une condition nécessaire : vous devrez informer les équipes BlaBlaBus de votre handicap dès votre réservation. En efet, cela permettra aux équipes de la compagnie d’optimiser au mieux votre voyage avec eux ! Pour se faire, vous pourrez leur adresser un message à la suite de votre réservation. Également, n’oubliez pas de les appeler au <strong>01 71 53 01 80</strong>, au moins 36h avant votre trajet, afin de convenir d’un point de rendez-vous en gare pour que le personnel puisse s’occuper de vous aisément ! Nous vous souhaitons un agréable voyage !</p>',
      },
      {
        type: 'title',
        content:
          'Mais où trouver toutes ces informations par compagnie de transport ?',
      },
      {
        type: 'body',
        content:
          '<p>Vous l’aurez compris, les politiques sur l’accès et la réservation de billet pour les personnes à mobilité réduite varient en fonction des compagnies... Heureusement pour vous, nous vous avons déjà par le passé, créé des pages dédiée à chacune de nos compagnies et ces informations s’y trouvent sur chacunes d’elles ! Si vous voulez alors en savoir plus sur la politique d’accès des bus Flixbus aux PMR, rendez-vous directement sur notre page <a href="https://www.tictactrip.eu/company/bus/flixbus" target="_blank">www.tictactrip.eu/company/bus/flixbus</a>. Pour retrouver notre liste de compagnies et leurs pages dédiées, deux options : rechercher "Tictactrip + NOM COMPAGNIE" ou bien vous rendre sur notre site, dans notre onglet bus, train ou covoiturage et cliquer sur le lien de la compagnie qui vous intéresse !</p>On espère en tout cas vous avoir aidé au mieux une nouvelle fois, c’était un plaisir ! Nous vous souhaitons un très bon voyage !</p>',
      },
    ],
    relatedQuestions: ['comment-reserver-billet-enfant'],
  },
  {
    name: 'politique-annulation-remboursement-billet',
    title: "Politique d'annulation et de remboursement des billets",
    meta: {
      title:
        'FAQ pour le remboursement et annulation billet de train et bus - Toutes nos réponses !',
      description:
        'Vous avez des questions relatives au remboursement et annulation billet de train et bus ? On répond à tout !',
    },
    category: ['service-apres-vente'],
    updatedDate: '20/03/2022',
    content: [
      {
        type: 'body',
        content:
          "<p>Quelles que soient les raisons qui peuvent vous pousser, voyageurs, à annuler votre trajet en transport et/ou demander le remboursement, il est préférable de savoir où s'adresser, on est bien d'accord !</p><p> Mais qu'en est-il alors de notre politique de remboursement et d'annulation et de celles de nos compagnies partenaires ?<br> En effet, selon le transporteur vous pourrez annuler ou non votre billet. De même, vous serez parfois obligé de contacter le service client car en tant qu’agence de voyage nous devons gérer certaines de vos réservations. Pour d’autres cas, vous pourrez annuler par vous-même vos billets.<br> Quoi qu'il en soit, une fois arrivé au bas de cette page, vous aurez toutes les réponses à vos questions. C'est parti !</p>",
      },
      {
        type: 'img',
        content: 'remboursement-annulation-billet-train_Billet.jpg',
        alt: 'remboursement annulation billet train',
      },
      {
        type: 'title',
        content: 'Les compagnies dont le billet est annulable',
      },
      {
        type: 'body',
        content:
          '<p>Pour l’ensemble des compagnies mentionnées ci-dessous, les billets peuvent être <strong>annulés</strong> par vos soins ou par nous. Le <strong>remboursement</strong> se fera alors par <strong>virement bancaire</strong> ou <strong>bon d’achat</strong>. En cas de doute sur la procédure vous pouvez toujours contacter notre équipe <strong>service client</strong>.</p><p>Attention, pour pouvoir obtenir un remboursement quand les conditions le permettent, il faudra nous avoir fait la demande de remboursement au maximum <strong>vingt-quatre heures avant</strong> le départ de votre transport. Passé ce délai nous ne garantissons pas le remboursement.</p>',
      },
      {
        type: 'subtitle',
        content: 'Flixbus',
      },
      {
        type: 'body',
        content:
          '<p>Pour une <strong>annulation</strong> de billet <em>Flixbus</em>, il faut que vous nous contactiez en nous précisant le numéro de votre commande. Cela peut se faire grâce au bouton <q>contact</q> en haut à droite de la page d’accueil.<br>Vous avez la possibilité d’annuler partiellement ou entièrement la réservation <strong>jusqu’à 15 minutes</strong> avant votre départ. Flixbus rembourse uniquement en <strong>bon d’achat</strong> utilisable jusqu’à un an après la demande.</p><p>L’annulation est gratuite et sans frais à plus de 30 jours du départ. Elle est ensuite de 1 à 5 euros par passager selon le moment auquel vous annulez votre billet.</p><p>À noter que si vous n’avez pas réservé votre billet Flixbus sur notre site Tictactrip, nous ne pourrons pas avoir accès à vos informations de réservation.</p>',
      },
      {
        type: 'subtitle',
        content: 'Bus Blablacar',
      },
      {
        type: 'body',
        content:
          '<p>Comme pour <em>Flixbus</em>, vous pouvez annuler votre trajet <em>Bus Blablacar</em> en nous contactant ou tout simplement en vous rendant sur le site Bus Blablacar et en renseignant votre numéro de réservation inscrit sur votre billet.<br>Vous avez <strong>jusqu’à 30 min</strong> avant le départ du bus pour annuler votre billet. Vous recevrez alors un bon d’achat à utiliser pour une prochaine réservation et valable sur une période d’un an.</p>',
      },
      {
        type: 'subtitle',
        content: 'SNCF',
      },
      {
        type: 'body',
        content: `<p>Pour l’<strong>annulation</strong> de votre voyage d’une des compagnies suivantes appartenant au groupe <em>SNCF</em> :<ul><li><p><em>TGV INOUI</em></p></li><li><p><em>TER</em></p></li><li><p><em>Lyria</em></p></li><li><p><em>Thalys</em></p></li><li><em>Eurostar</em></p></li></ul></p><p>Il faut faire une <strong>demande de support</strong> à travers notre <a href="${NAVIGATION.SUPPORT}">formulaire de contact</a>. Nous prendrons contact avec vous par mail.<br>À noter que tous les billets de train ne sont pas remboursables. Cela dépend des <strong>conditions</strong> propres à chaque billet. Nous vous communiquerons toujours le <strong>montant des frais</strong> s’il y en a avant de procéder au <strong>remboursement</strong>.<br>Celui-ci se fera par <strong>virement</strong> sur le compte bancaire où la transaction a été effectuée.</p><p>Concernant les billets de <em>TER</em>, la procédure est plus <strong>longue</strong> car nous devons faire la demande auprès de la <em>SNCF</em>. Selon le type de billet vous pouvez prétendre ou non à un remboursement. Ces demandes sont traitées <strong>au cas par cas</strong> mais nous vous tenons informés de l’avancée de votre dossier.</p> `,
      },
      {
        type: 'subtitle',
        content: 'Altibus',
      },
      {
        type: 'body',
        content:
          '<p>Si vous devez annuler un billet de navette <em>Altibus</em>, veuillez contacter notre service client qui s’en chargera avec plaisir. Chacun des <strong>transporteurs</strong> à ses propres <strong>conditions</strong> que vous pouvez consulter <a href=https://www.altibus.com/conditions-generales-de-vente/>ici</a> selon la provenance et la destination de la navette.<br>Nous vous informerons des conditions et du montant du remboursement de votre billet.</p>',
      },
      {
        type: 'title',
        content: "Les compagnies dont le billet n'est pas annulable.",
      },
      {
        type: 'body',
        content:
          '<p>Pour les quelques compagnies notées ci-dessous les billets ne sont malheureusement pas annulables. Mais d’autres solutions s’offrent tout de même à vous.</p>',
      },
      {
        type: 'subtitle',
        content: 'OUIGO',
      },
      {
        type: 'body',
        content:
          "<p>En tant que compagnie <strong>low-cost</strong>, <em>OUIGO</em> ne permet pas l’annulation et le remboursement de votre billet car le prix de celui est déjà relativement bas.<br>Vous pouvez cependant le <strong>modifier</strong> ou <strong>l’échanger</strong>. Toutes les modalités sont disponibles sur notre page FAQ <q> je souhaite échanger mon billet </q>.</p><p>Cependant, les billets peuvent parfois être remboursables comme lors de la crise sanitaire où les conditons d'annulation ont été assouplies.</p>",
      },
      {
        type: 'subtitle',
        content: 'IZY',
      },
      {
        type: 'body',
        content:
          "<p>La compagnie <em>IZY</em> de nos voisins belges est également low-cost. Comme pour la compagnie ci-dessus, la garantie d'un prix bas passe par un <strong>non-remboursement</strong> de vos billets.<br>Vous pourrez tout de même obtenir un <strong>dédommagement</strong> de votre billet en cas de retard, de grève ou d’annulation de votre train.</p><Si vous ne souhaitez/pouvez plus voyager, votre billet sera tout simplement perdu !</p>",
      },

      {
        type: 'subtitle',
        content: 'Navette Beauvais',
      },
      {
        type: 'body',
        content:
          "<p>La compagnie de bus <em>Navette Beauvais</em> vous permettant de rejoindre <strong>l'aéroport de Beauvais</strong> en un temps record et à moindre coût depuis la Porte Maillot à Paris n'est pas remboursable.<br>Cependant, si vous avez un imprévu, vos billets ne sont pas perdus. En effet, ils sont <strong>valables un an</strong> et dans la mesure où ils ne sont pas nominatifs, ils peuvent être cédés à une tierce personne. Tout n'est pas perdu !</p>",
      },
      {
        type: 'subtitle',
        content: 'Autres compagnies',
      },
      {
        type: 'body',
        content:
          "<p>Pour les compagnies ci-dessous, les billets ne sont pas remboursables et l'échange n'est pas possible non plus. Même en cas d'imprévu lié à des problèmes de santé ou professionnels vous ne pourrez prétendre à aucun remboursement<ul><li><p>La compagnie de bus britannique <em>National Express</em></p></li><li><p>Les bus de la compagnie espagnole <em>Alsa</em></p></li></ul></p><p</p><p>Vous connaissez désormais notre politique d’annulation et de remboursement de billets achetés sur notre site. Par ailleurs, pour toute demande d'annulation, sachez que les frais de service ne sont pas remboursables. Ils sont remboursables si la compagnie a annulé votre billet de manière exceptionnelle comme lors d'une grève par exemple.<br>Pour toute information supplémentaire vous pouvez toujours nous contacter, nous vous répondrons avec plaisir.</p>",
      },
    ],
    relatedQuestions: [
      'changement-nom-billet',
      'echanger-mes-billets',
      'compagnies-transport-annulation-remboursement-coronavirus',
    ],
  },
  {
    name: 'problemes-de-paiement-debite',
    title:
      'Problèmes de paiement, comment être sûr que je n’ai pas été débité ?',
    meta: {
      title: 'Tous vos problèmes de paiement ont une solution - Nos réponses !',
      description:
        'Vous avez eu des problèmes de paiement lors de votre réservation ? Pas de panique on vous dit tout !',
    },
    category: ['paiement'],
    updatedDate: '24/03/2020',
    content: [
      {
        type: 'body',
        content:
          "<p>On le sait très bien, voir qu'il y a eu une erreur sur le paiement de votre réservation de billets de train, bus ou covoiturage peut être perturbant et faire peur. Dans de tels cas, on se demande souvent si ce n'est pas une arnaque en ligne et si le paiement a bel et bien été débité de notre compte bancaire ou s'il y a réellement eu une erreur... C'est pourquoi nous souhaitons vous rassurer sur vos problèmes de paiement sur la plateforme Tictactrip.</p>Nous ne sommes pas une arnaque en ligne, mais bien une agence de voyage certifiée. Autrement, 95% du temps, lorsque s'affiche le message \"une erreur est survenue sur votre réservation\", le paiement à été bloqué et n'a pas eu lieu. Mais pourquoi ont lieu ces problèmes lors de votre réservation ? Comment faire pour en être sûr ? On vous dit tout !</p>",
      },

      {
        type: 'img',
        content: 'problemes-de-paiement-debite_problemes-paiement-en-ligne.jpg',
        imgSizePercent: 60,
      },

      {
        type: 'title',
        content:
          "Pourquoi y a t'il un problème de paiement sur ma réservation de billets ?",
      },
      {
        type: 'body',
        content:
          "<p>Il peut y avoir plusieurs raisons à un problème de paiement et donc une erreur sur votre réservation. Cette erreur aura comme répercussion que votre réservation ne sera pas validée et vous ne recevrez donc aucun billet pour votre trajet. Quelles peuvent alors être ces raisons ?</p><p>Voici les différentes raisons d'erreur de paiement possible : <ul><li><p>Votre établissement bancaire a refusé le paiement par carte bancaire sur internet. Cela peut être du à une limite de plafond atteinte sur votre compte bancaire, un manque de fonds ou bien d'autres raisons. Pour y remédier, il vous faudra contacter votre établissement bancaire ou vous rendre sur votre application mobile.</p></li><li><p>Le 3D Secure ne s'affiche pas à cause de votre établissement bancaire.</p></li><li><p>Le code du 3D Secure est expiré (délai trop long).</p></li><li><p>Les renseignements de votre carte bancaire sont erronés (mauvais cryptogramme, mauvaise date d'expiration...).</p></li><li><p>Et bien d'autres raisons techniques...</p></li></ul></p>Quoi qu'il en soit, la plupart du temps, vous n'aurez que peu d'options de solution, on y arrive !</p>",
      },
      {
        type: 'title',
        content:
          'Comment connaître la raison du problème de paiement et y remédier ?',
      },
      {
        type: 'body',
        content:
          "<p>Encore une fois, c'est tout simple de trouver la raison de l'erreur liée à votre réservation et d'y remédier. Pour se faire il vous suffit de cliquer sur le bouton \"une erreur est survenue, contacter le support\". Cela vous permettra de nous faire parvenir une demande d'assistance et nos spécialistes SAV transport vous donneront la réponse dans les meilleurs délais avec, bien sûr, l'assurance que vous n'avez pas été débité sur votre compte bancaire. Pour savoir comment contacter le support, nous vous invitons à découvrir notre autre FAQ dédiée : <a href=\"https://www.tictactrip.eu/faq/comment-contacter-tictactrip\" target=\"_blank\">Comment nous contacter</a>.</p><p>Aussi, il vous suffira de suivre vos relevé de compte bancaire afin de vérifier qu'aucune transaction vers nous n'a été effectué. C'est d'ailleurs le meilleur moyen de surveiller ce débit potentiel (bien que très peu probable).</p><p>Vous avez désormais toutes les cartes en main pour savoir ce qu'il s'est passé et savoir si vous avez raison de vous inquiéter si vos billets ne vous sont pas parvenu et si vous avez été débité sans raison. Pour toute autre interrogation, nous vous invitons à découvrir nos réponses à vos questions dans nos autres FAQ ou à nous contacter directement.</p>",
      },
    ],
    relatedQuestions: ['explication-3d-secure', 'bons-plans-sncf'],
  },
  {
    name: 'explication-3d-secure',
    title: 'Qu’est ce que c’est la vérification 3D Secure Visa/Mastercard ?',
    meta: {
      title:
        'Le paiement sécurisé par vérification 3D Secure Visa/Mastercard !',
      description:
        'Vous vous posez des questions par rapport à la sécurité du paiement par 3D Secure Visa/Mastercard ? On vous dit tout !',
    },
    category: ['paiement'],
    updatedDate: '24/03/2020',
    content: [
      {
        type: 'body',
        content:
          "<p>Effectivement, vous avez raison d'être prudent lorsque vous payez en ligne car nous ne sommes que rarement sûrs à 100% que les sites sur lesquels nous payons sont fiables. De plus, on le remarque et on en entend de plus en plus parler, les hackers et autres fraudeurs du web se multiplient pour tenter de vous dérober vos informations bancaires, pour les revendre ensuite ou les utiliser à mauvais essient... C'est pourquoi, les entreprises développent aussi chaque jour des techniques plus poussées pour sécuriser vos informations personnelles de ce type. Un bon moyen de sécuriser ces paiements en ligne est le 3D Secure. Mais qu'est ce que c'est ? Vous aurez toutes les informations que vous souhaitiez une fois arrivé en bas de cette page !</p>",
      },
      {
        type: 'img',
        content: 'explication-3d-secure_carte.jpg',
        imgSizePercent: 60,
      },
      {
        type: 'title',
        content: 'Le 3D secure - Explications',
      },
      {
        type: 'subtitle',
        content: 'Le 3D Secure - Définition',
      },
      {
        type: 'body',
        content:
          '<p>Le 3D Secure, est un protocole de paiement sécurisé, comme nous vous le disions précédemment, créé dans le bu de faciliter la sécurisation de vos données personnelles de paiement sur internet. Grâce à lui, vous pouvez ête sûr à 100% que personne d\'autre que vous ne peut payer sur internet.</p><p>Ce 3D Secure a été développé par les deux grands groupes de cartes bancaires : Visa et Mastercard. Il est d\'ailleurs utilisé aujourd\'hui sous deux appellations différentes en rapport à ces deux groupes : "Verified by Visa" et "Mastercard SecureCorde". </p>',
      },
      {
        type: 'subtitle',
        content: 'Le 3D Secure - Fonctionnement',
      },
      {
        type: 'body',
        content:
          "<p>Mais reste à savoir comment fonctionne ce 3D Secure et qu'est ce qui fait que vous pouvez vous y fier. Le 3D Secure Visa et Mastercard est un protocole d'authentification permettant la sécurisation des paiements sur le web. Il implique que vous deviez faire une petite démarche supplémentaire lorsque vous souhaitez faire un achat en ligne : vous devrez \"authentifier votre intention d'ahat\". Mais comment cela est-il mis en place ?</p><p>Tout simplement, lorsque vous aurez activé cette fonctionnalité, vous recevrez au moment de tout paiement en ligne, une demande d'authentification sur votre application bancaire afin de vérifier qu'il s'agisse bien de vous. Une fois authentifié sur l'application et une fois la confirmation validée par vos soins, le paiement peut avoir lieu. Il est aussi possible d'associer votre numéro de téléphone mobile et de recevoir un code dessus plutôt que de devoir vous connecter à votre application mobile. À vous de choisir, en fonction de votre établissement bancaire.</p>",
      },
      {
        type: 'title',
        content:
          '3D Secure Visa et Mastercard - Application au site de Tictactrip ?',
      },
      {
        type: 'body',
        content:
          "<p>Vous êtes prudent et vous vous demandez si notre site Tictactrip prend en compte ce 3D Secure pour sécuriser vos paiement lorsque vous souhaitez réserver des billets de trains ou bus pour votre prochain trajet ? Eh bien oui ! Nous avons introduit le 3D Secure sur notre site car nous souhaitons vous proposer le meilleur service possible et que nous ayons une véritable relation de confiance ensemble. Vos données personelles et confidentielles sont par ailleurs l'une de nos priorités absolues comme nous pouvons le rappeler dans notre politique de gestion de vos données personnelles.</p>",
      },

      {
        type: 'img',
        content: 'explication-3d-secure_paiement-tictactrip.png',
      },
      {
        type: 'body',
        content:
          "<p>Sur cette image, vous pouvez voir l'étape du paiement sur le site Tictactrip. La confirmation 3D Secure Visa ou Mastercard arrive directement après cette étape où vous rentrez vos informations bancaires. Voila (ci-dessous) comment apparaîtra cette étape de sécurisation 3D Secure.</p>",
      },
      {
        type: 'img',
        content: 'explication-3d-secure_mastercard.jpg',
      },
      {
        type: 'body',
        content:
          "<p>On espère vous avoir éclairé au mieux sur ce processus de sécurisation de vos données bancaires et que vous êtes fin prêt à réserver vos voyages à venir avec nous ! En plus, on vous propose des prix si bas, que c'est une aubaine !</p>",
      },
    ],
    relatedQuestions: ['problemes-de-paiement-debite', 'bons-plans-sncf'],
  },
  {
    name: 'imprimer-billet-train-bus',
    title: 'Dois-je imprimer billet de bus et/ou train ?',
    meta: {
      title:
        'Imprimer billet train et bus, une nécessité ? - Toutes nos réponses !',
      description:
        "Vous ne savez pas s'il est nécessaire d'imprimer billet de bus et de train pour votre voyage ? On vous répond !",
    },
    category: ['recherche-reservation-billets'],
    updatedDate: '25/03/2020',
    content: [
      {
        type: 'body',
        content:
          "<p>Aujourd'hui il est courant d'être perdu par rapport au besoin ou non d'imprimer billet de train et de bus avant votre départ. Mais cela ne doit pas être un frein ni un sujet de stress pour votre voyage, d'aucune manière ! C'est pourquoi nous allons vous donner toutes les informations nécessaires au bon déroulement de votre voyage et notamment si vous devez imprimer ou non votre billet de transport.</p>",
      },

      {
        type: 'img',
        content: 'remboursement-annulation-billet-train_Billet.jpg',
        imgSizePercent: 60,
      },

      {
        type: 'title',
        content: 'Billet de transport imprimé VS e-billet',
      },
      {
        type: 'subtitle',
        content: 'Le billet imprimé',
      },
      {
        type: 'body',
        content:
          "<p>Le billet imprimé est le modèle \"old school\" du billet de transport mais fait encore ses preuves aujourd'hui ! En effet, il est utilisé depuis des années et des années (des décennies même) et est encore d'actualité. C'est la preuve qu'il ne risque pas de disparaître de sitôt. Et pourtant ! Aujourd'hui, alors que les débats se penchent de plus en plus sur les moyens de préserver la planète, notre utilisation massive du papier apparaît de plus en plus néfaste et remplaçable. Peut-être que le billet imprimé finira finalement d'ici peu à la poubelle au profit de l'e-billet, qui sait ?! Le billet papier peut-être égaré, mais si l'on est pas tête en l'air, il n'y a aucune raison de le perdre. C'est une \"sécurité\" que de l'avoir sur soi pour son trajet !</p>",
      },
      {
        type: 'subtitle',
        content: 'Le billet dématérialisé = e-billet',
      },
      {
        type: 'body',
        content:
          "<p>Le billet dématérialisé, que l'on peut obtenir très simplement sur son smartphone est une révolution du billet de transport de nos jours. Il permet justement d'éviter l'impression de billets papier qui finissent par polluer. De plus, nos générations actuelles ont tendance à avoir leur smartphone greffé à eux. Aucune chance d'oublier votre billet de ce fait ! Le seul risque qui pourrait subsister c'est la panne de batterie sur votre téléphone portable... Mais heureusement, des prises sont prévues en gare la plupart du temps. Donc 0 raison de ne pas avoir votre e-billet ! L'autre avantage de l'e-billet, c'est qu'il n'y a pas besoin de le poinçonner comme il faut le faire pour le billet papier. C'est un petit gain de temps utile pour les personnes pressées.</p>",
      },
      {
        type: 'title',
        content: "Alors, est-il nécessaire d'avoir un billet imprimé ?",
      },
      {
        type: 'body',
        content:
          '<p>La réponse est NON, il n\'est plus nécessaire aujourd\'hui d\'avoir votre billet sous format papier, la plupart du temps. En effet, certaines compagnies peuvent ne pas s\'être mis aux goûts du jours pour tous leurs trajets... Pour connaitre leur politique sur ce sujet de l\'impression papier des billets, nous vous invitons à vous rendre sur les pages de nos compagnies partenaires où vous trouverez toutes les informations nécessaires : <ul><li><p><a href="https://www.tictactrip.eu/company/bus/flixbus" target="_blank">Flixbus</a></p></li><li><p><a href="https://www.tictactrip.eu/company/carpooling/blablacar/blablabus" target="_blank">BlaBlaBus</a></p></li><li><p><a href="https://www.tictactrip.eu/company/train/sncf/ouigo" target="_blank">OuiGo</a></p></li><li><p><a href="https://www.tictactrip.eu/company/train/sncf/inoui" target="_blank">InOui</a></p></li><li><p><a href="https://www.tictactrip.eu/company/train/thalys" target="_blank">Thalys</a></p></li><li><p><a href="https://www.tictactrip.eu/company/train/sncf" target="_blank">SNCF</a></p></li><li><p><a href="https://www.tictactrip.eu/company/shuttle/ski/altibus" target="_blank">Altibus</a></p></li></ul></p><p>Cependant, <strong>vérifiez bien d\'avoir votre billet</strong> au moins sous une forme: e-billet ou billet papier. Aussi, si vous êtes de nature stressée, rien ne vous empêche de l\'avoir sur vous sous ces deux formes. Chez Tictactrip cependant, nous privilégions le e-billet qui est bien plus responsable de l\'environnement.</p><p>Enfin, vous recevrez vos billets par mail une fois réservés. Vous aurez alors le choix de les enregistrer sur votre smartphone et/ou de les imprimer directement sous forme papier. Le choix est votre !</p><p>On espère vous avoir informé au mieux et nous vous souhaitons un agrébale voyage.</p>',
      },
    ],
    relatedQuestions: [],
  },
  {
    name: 'reserver-sur-tictactrip',
    title: 'Pourquoi réserver ses billets chez Tictactrip ?',
    meta: {
      title:
        "Un déplacement de programmé ? N'hésitez plus et passez directement sur Tictactrip pour réserver votre meilleur trajet !",
    },
    category: ['tictactrip'],
    updatedDate: '28/10/2021',
    content: [
      {
        type: 'body',
        content:
          '<p>Très bonne question ! Il est vrai que <em>Tictactrip</em> ne vous propose pas à la vente ses propres billets, mais ceux des transporteurs avec qui nous sommes partenaires, comme <em>Ouigo</em>, <em>Flixbus</em>, ou encore <em>Bus Blablacar</em>..</p><p><em>Tictactrip</em> est la première plateforme de réservation pour tous <strong>trajets interurbains & éco-responsables</strong> : trains, bus, covoiturage & combinés. Tictactrip optmise ainsi la desserte des lieux isolés (comme les villages de montagne), le prix et le temps de son trajet. Tout en maîtrisant son bilan carbone.</p><p>Mais ce n’est pas tout ! <em>Tictactrip</em> est <strong>leader de l’intermodalité terrestre</strong>, c’est-à-dire la combinaison de différents moyens de transports terrestres sur un même trajet.</p>',
      },

      {
        type: 'title',
        content: 'Le fonctionnement de notre site',
      },
      {
        type: 'body',
        content:
          '<p>Admettons que vous souhaitiez rendre visite à votre grand-mère vivant à Orléans, et ce, depuis Nice. Indiquez vos dates d’aller et de retour sur <a href="https://www.tictactrip.eu">tictactrip.eu</a> et lancez votre recherche.</p><p>Vous constaterez que notre plateforme vous propose plusieurs alternatives dont :<ul><li><p>l’option la moins chère : un trajet combinant un Ouigo Nice-Paris avec un Bus Blablacar Paris-Orléans</p></li><li><p>l’option la plus rapide : un trajet en Ouigo Nice-Paris avec une escale puis un TGV Paris-Orléans.</p></li></ul></p>',
      },
      {
        type: 'img',
        content: 'resultats-recherche-nice-orleans.png',
        alt: 'résultat recherche nice orleans',
      },

      {
        type: 'body',
        content:
          "<p>Vous êtes ensuite libre de choisir l’alternative qui vous convient le mieux. À noter tout de même qu’en fonction des dates et horaires choisis, <strong>l’alternative la plus rapide peut parfois également être la moins onéreuse</strong>.<br> Il est très facile de vous rendre compte de cela en modifiant simplement les dates de votre recherche. Notre algorithme de comparaison de billets de train, bus et covoiturage se chargera ensuite du reste.</p><p>Aussi, chez Tictactrip nous nous sommes donné comme but de vous permettre d'accéder à une offre de mobilité où que vous soyez ! En effet, nous avons à coeur de désenclaver les territoires isolés et donc d'offrir à tous, des possibilités de mobilité.<br> Nous avançons très bien dans notre projet et celui-ci se développe encore mieux que prévu. Nous devrions être en mesure bientôt de vous proposer des transports depuis chez vous, un rêve qui s'accomplit non ?!</p>",
      },
    ],
    relatedQuestions: [
      'comment-contacter-tictactrip',
      'politique-annulation-remboursement-billet',
    ],
  },
  {
    name: 'desabonnement-newsletter-tictactrip',
    title: 'Comment se désabonner facilement des newsletter Tictactrip ?',
    meta: {
      title: 'Comment se désabonner facilement de la Newsletter ?',
      description:
        'Vous vous apprêtez à réserver vos billets de tansports et vous tomber par hasard sur le site de Tictactrip. Voici pourquoi vous devez réserver votre trajet sur notre site !',
    },
    category: ['tictactrip'],
    updatedDate: '09/04/2020',
    content: [
      {
        type: 'body',
        content:
          '<p>Vous ne souhaitez plus recevoir les bons plans voyage, actualités et informations importantes de la part de <em>Tictactrip</em> ? Tout d’abord, réfléchissez-y une nouvelle fois : vous risquez de passer à côté des billets aux prix les plus intéressants et de ne pas être au courant lorsque nous sortirons de nouveaux articles pratiques ou inspirations voyage …</p><p>Votre décision est prise, vous souhaitez bel et bien vous désabonner de nos bons plans voyage ? Pour cela, il vous suffit de suivre ces étapes.</p>',
      },

      {
        type: 'title',
        content:
          'Quelles sont les étapes pour se désabonner de la newsletter ?',
      },

      {
        type: 'body',
        content:
          '<p>Pour vous désabonner de notre newsletter, c\'est tout simple. Il vous suffit de : <ol><li><p>Ouvrez n’importe laquelle de nos newsletters dans votre boîte mail.</p></li><li><p>Rendez-vous tout au bas de l’email, et cliquez sur le bouton « <strong>Se désabonner</strong> ».</p></li><li><p>Vous êtes alors redirigé sur une autre page sur laquelle vous pouvez confirmer votre désabonnement.</p></li></ol></p><p><strong>N.B.</strong> : il se peut que cette <strong>procédure prenne quelques jours avant d’être effective</strong>. Ne soyez donc pas surpris si vous recevez l’une de nos newsletters très peu de temps après votre désabonnement, celui aura tout de même bien été pris en compte.</p><p>Et n’oubliez pas : <strong>ce n’est qu’un au revoir</strong>. Si toutefois vous souhaiteriez vous réinscrire à nos bons plans voyage, nous serons ravis de vous accueillir à nouveau au sein de notre communauté de Tictactrippeurs ! Pour cela, rendez-vous simplement au bas de notre <a href="https://www.tictactrip.eu" target="_blank">page d’accueil</a>.</p>',
      },

      {
        type: 'img',
        content:
          'tictactrip_comment-se-desabonner-de-la-newsletter-tictactrip.jpg',
      },
    ],
    relatedQuestions: [
      'comment-contacter-tictactrip',
      'compagnies-transport-annulation-remboursement-coronavirus',
    ],
  },
  {
    name: 'reserver-billet-autre-personne',
    title: 'Puis-je réserver un billet pour quelqu’un d’autre ?',
    meta: {
      title: "Réserver un billet pour quelqu'un d'autre ?",
      description:
        "Vous avez trouver une superbe offre de billets sur Tictactrip mais vous vous demander si vous pouvez réserver un billet de train pour quelqu'un d'autre ?",
    },
    category: ['recherche-reservation-billets'],
    updatedDate: '10/04/2020',
    content: [
      {
        type: 'body',
        content:
          "<p>Ça y est, vous êtes tombé sur une offre de billet de transport en OR sur le site de Tictactrip, mais vous vous demandez désormais s'il vous est possible de réserver un billet de train pour quelqu'un d'autre (ou de bus, ou de covoiturage) ? Pas de panique, voici notre réponse !</p>",
      },

      {
        type: 'title',
        content: "Comment réserver un billet pour quelqu'un d'autre ?",
      },

      {
        type: 'body',
        content:
          "<p>Tout d'abord, sachez que nous vous offrons bien évidemment la possibilité de réserver le billet de votre ami, de votre conjoint ou encore de membres de votre famille ! Pour réserver un billet pour quelqu'un d'autre que vous, la démarche est très simple ! Voici les étapes à suivre :</p><ol><li><p>Dans un premier temps il vous faudra renseigner, lors de votre recherche sur notre site <a href=\"https://www.tictactrip.eu\" target=\"_blank\">tictactrip.eu</a>, le nombre de passagers pour lesquels vous recherchez un billet. Cela permettra à notre moteur de recherche interne de ne pas vous proposer des trajets ne disposant que d'une seule place par exemple.</p></li><li><p>Ensuite, une fois votre trajet choisi parmi nos propositions et nos comparaisons d'offres, vous accéderez à une page \"informations voyageurs\" où il vous sera demandé de remplir quelques cases sur les personnes voyageant. C'est à cette étape que vous pourrez ajouter le nom et le prénom de la/les personnes pour qui vous aller réserver un billet. Également, il vous faudra nous fournir leur date de naissance et leur adresse email afin que nous puissions leur communiquer éventuellement leurs billets de transport (c'est vous qui choisirez qui recevra les billets).</p></li></ol><p>Et voilà, c'est déjà fini, il ne vous reste plus qu'à procéder au paiement afin de réserver vos billets !</p><p>Attention cependant : les billets sont nominatifs. Pour voyager, vous devrez être munis de votre billet nominatif ainsi que de votre pièce d'identité.</p>",
      },

      {
        type: 'img',
        content:
          'recherche-reservation-billets_reserver-un-billet-de-train-pour-autre-personne.jpg',
      },

      {
        type: 'body',
        content:
          "<p>Voilà, on espère avoir pu vous aider au mieux pour réserver un billet pour quelqu'un d'autre que vous. Vous trouverez juste ci-dessous, d'autres réponses à des questions qui ont été posées suite à celle-ci. Pour tout problème auquel nous n'aurions pas répondu dans nos pages FAQ, nous vous invitons à nous contacter directement ! Bon voyage.</p>",
      },
    ],
    relatedQuestions: [
      'comment-reserver-billet-enfant',
      'imprimer-billet-train-bus',
    ],
  },
  {
    name: 'probleme-recherche-de-trajet',
    title:
      'Un problème sur votre recherche de trajet ? Voici la solution simple et rapide !',
    meta: {
      title: 'Un problème sur votre recherche de trajet ?',
      description:
        'Vous tentez en vain d"effectuer une recherche sur notre site mais cela ne fonctionne pas ? Découvrez comment solutionner votre problème simplement !',
    },
    category: ['recherche-reservation-billets'],
    updatedDate: '10/04/2020',
    content: [
      {
        type: 'body',
        content:
          "<p>Vous avez décidé de partir en vacances ou bien en séjour et vous avez eu la bonne idée d'utiliser le site de <em>Tictactrip</em> pour trouver les billets les moins chers du marché mais là CATASTROPHE, il y a un problème sur votre recherche de trajet ?! Pas de panique, voici les solutions pour vous !</p>",
      },

      {
        type: 'img',
        content:
          'recherche-reservation-billets_probleme-delai-recherche-tictactrip.jpg',
      },

      {
        type: 'title',
        content:
          'Les potentielles sources de problèmes sur votre recherche de trajet et leurs solutions',
      },

      {
        type: 'body',
        content:
          "<p>À tout problème, il y a forcément une solution. Découvrez alors tout de suite les différents problèmes que vous pouvez rencontrer et qui vous empêche d'effectuer votre recherche et bien sûr, leurs solutions !</p>",
      },
      {
        type: 'subtitle',
        content: 'Problème de délais dans votre recherche',
      },

      {
        type: 'body',
        content:
          "<p>Qu'est ce que l'on peut bien entendre par \"problème de délais dans votre recherche \"? Eh bien pour répondre tout simplement, il suffit d'étudier l'image ci-dessus. Le problème survient en fait lorsque vous avez bel et bien effectué une recherche et que vous comparez désormais les prix des offres. Sauf que celles-ci peuvent fluctuer en fonction des compagnies de transports qui font évoluer leur prix... Nous actualisons alors ces prix et cette fenêtre arrive sur votre écran. Il vous suffit donc de rafraîchir votre page web pour trouver les prix actualisés. Certains peuvent alors avoir beaucoup changé, ou bien pas du tout. En tout cas, nous nous excusons pour ce désagrément... Mais au moins, vous n'aurez aucune mauvaise surprise au moment du paiement !</p>",
      },

      {
        type: 'subtitle',
        content: "Votre ville d'arrivée ou de départ n'est pas desservie",
      },

      {
        type: 'body',
        content:
          "<p>Il est effectivement possible que la ville de départ ou bien la ville d'arrivée que vous ayez sélectionné ne soit pas encore gérée dans la base de donnée de Tictactrip. Cependant, si elle est présente dans notre moteur de recherche, c'est qu'elle le sera bientôt ! Vous n'aurez alors qu'a réitérer votre recherche de trajet un peu plus tard.</p>",
      },

      {
        type: 'subtitle',
        content: 'Problème de maintenance sur le site de Tictactrip',
      },

      {
        type: 'body',
        content:
          "<p>Comme tout bon site internet ou application mobile, le site de Tictactrip est en perpétuelle évolution pour vous servir au mieux. C'est pourquoi il peut nous arriver d'y effectuer des sortes de mises à jour. Le site sera alors inutilisable pendant une courte période. Cela peut se traduire par une page blanche, une page qui ne charge pas ou encore une recherche qui charge indéfiniement. Pas de panique cependant, il vous suffira d'actualiser la page un peu plus tard dans votre journée et notre site devrait fonctionner de nouveau ! À savoir que ce type de \"panne momentanée\" n'est que très peu fréquent. Nous faisons tout pour vous fournir la meilleure expérience et le meilleur service possible.</p>",
      },

      {
        type: 'subtitle',
        content:
          'Aucune compagnie de transport partenaire ne propose ce trajet pour le moment',
      },

      {
        type: 'body',
        content:
          "<p>Eh oui, malheureusement cette situation peut exister... Tictactrip a d'ailleurs été fondé dans ce but de désenclaver les territoires isolés. C'est pour cela que nous travaillons et souhaitons intégrer à notre comparateur, le maximum de compagnies de transport possible, afin que vous puissiez demain, trouver toutes sortes de trajets depuis chez vous, même dans un lieu isolé. Cependant, nous ne sommes encore qu'au début de l'aventure <em>Tictactrip</em>, nous arriverons bientôt vers chez vous, c'est promis !</p>",
      },

      {
        type: 'subtitle',
        content: 'Aucun résultat car votre date de voyage est trop lointaine',
      },

      {
        type: 'body',
        content:
          "<p>En effet, attention cher voyageur, vous ne pourrez pas réserver vos trajets un an à l'avance ou plus encore. Pourquoi ? Eh bien tout simplement car nos compagnies de transports partenaires n'ont pas encore prévu ni communiqué de ce fait, les horaires et prix de ces futurs trajets. C'est très certainement pour cela que notre moteur de recherche ne trouve aucune offre de transport pour votre trajet sélectionné. Vous devrez alors attendre un petit peu pour trouver vos billets aux meilleurs prix. Aussi, vous pouvez toujours prendre des vacances un peu plus proche, c'est une belle option aussi !😄</p>",
      },

      {
        type: 'img',
        content: 'recherche-reservation-billets_trajet-trop-lointain.jpg',
      },

      {
        type: 'body',
        content:
          "<p>On espère avoir résolu votre problème concernant votre recherche de trajet. Si aucune de nos solutions ne s'est avérée efficace, vous pouvez toujours nous contacter. Nous nous ferons un plaisir de vous aider dans les meilleurs délais !</p>",
      },
    ],
    relatedQuestions: [
      'problemes-de-paiement-debite',
      'voyageur-handicape-mobilite-reduite-reservation-billet',
    ],
  },
  {
    name: 'calendrier-des-ventes',
    title:
      "Dates d'ouverture des ventes de billets SNCF, billets Flixbus et de toutes nos compagnies partenaires !",
    meta: {
      title: 'Découvrez le calendrier des offres de bus et de train !',
      description:
        "Vous cherchez à réserver votre bus, train ou covoiturage à l'avance mais sans y parvenir ? C'est peut-être car il n'y a pas encore d'offres... Découvrez quand les compagnies les proposeront !",
    },
    category: ['recherche-reservation-billets'],
    updatedDate: '10/05/2020',
    content: [
      {
        type: 'body',
        content:
          "<p>Savoir <strong>quand ouvrent les ventes de billets de vos compagnies de transport</strong> est un réel avantage dans votre recherche de billet. En effet, vous pourrez alors savoir quand réserver au plus tôt et même <strong>à partir de quand comparer les offres de transports</strong> ! Dans ce but, nous nous proposons de vous donner en général et par compagnie, le calendrier d'ouverture des ventes ! De ce fait, vous saurez quand réserver un billet SNCF, un billet Flixbus ou un billet de train et de bus de toute autre compagnie !</p>",
      },

      {
        type: 'title',
        content: "L'ouverture de la vente de billets de train",
      },

      {
        type: 'body',
        content:
          '<p>Découvrons sans plus attendre à quelle date ouvrent les ventes de vos billets de train.</p>',
      },

      {
        type: 'img',
        content:
          'recherche-reservation-billets_ouverture-ventes-billet-sncf-et-compagnies.jpg',
        imgSizePercent: 60,
      },

      {
        type: 'subtitle',
        content: 'Ouverture des ventes de billet SNCF',
      },

      {
        type: 'body',
        content:
          "<p>Chez la <em>SNCF</em>, l'information de l'ouverture de la vente de billet est très simple. En effet, afin de vous permettre de voyager simplement et de simplifier également votre <strong>réservation de billets SNCF</strong>, leurs offres sont disponibles sur leur site, mais aussi sur Tictactrip <strong>à partir de 4 mois à l'avance</strong>. Si vous comptez partir en voyage le 1er Septembre prochain, vous pourrez réserver votre billet à partir de début mai! <br>À noter, sont exclus les billets pour les périodes de Noel, des vacances d'été et des vacances d'hiver. Ces périodes sont soumises à conditions et nous vous informerons nous même dans notre newsletter, de l'ouverture de ces ventes ! En effet, la SNCF pratique une \"ouverture des ventes exceptionnelles du moment\", pour ces périodes à fortes demandes de voyages en transport. Enfin, lorsqu'il est question d'ouverture des ventes de billet SNCF, nous faisons référence aux : <ul><li><p>De billet Ouigo, qui sont réservables en général 8 mois à l'avance.</p></li><li><p>De billet Inoui.</p></li><li>Des billet Intercités et TER.</p></li><li>De billet TGV Max.</p></li></ul><br>Autrement dit, toutes les offres de billets de la SNCF. Pour celles sans particularités, le délai de 4 mois à l'avance est applicable.</p>",
      },

      {
        type: 'subtitle',
        content: "L'ouverture des ventes de billet Eurostar",
      },

      {
        type: 'body',
        content:
          "<p>Pour réserver votre billet Eurostar, vous pourrez vous y prendre <strong>6 mois à l'avance</strong> ! Cela vous laisse le temps d'organiser votre séjour et votre voyage tranquillement !<br>Attention cependant, les billets Eurostar ne sont pas remboursables. Soyez sûr de votre voyage avant de les réserver ! Aussi, si votre trajet en Eurostar implique d'autres trains de la SNCF par exemple pour une combinaison de transport, nous vous conseillons de tout réserver d'un coup sur Tictactrip. Aussi, il vous faudra attendre l'ouverture à la vente des billets SNCF.</p>",
      },

      {
        type: 'subtitle',
        content: "L'ouverture des ventes de billet Thalys",
      },

      {
        type: 'body',
        content:
          "<p>Chez Thalys, les billets de train sont <strong>réservables 4 mois à l'avance</strong>. Il y a par ailleurs exception pour certaines périodes de l'année, comme pour la SNCF. Pendant ces périodes, les billets seront réservables alors <strong>3 mois à l'avance</strong> comme par exemple pour celle comprise entre mi-décembre et mi janvier (les vacances de Noel).</p>",
      },

      {
        type: 'subtitle',
        content: "L'ouverture à la vente de billets Lyria",
      },

      {
        type: 'body',
        content:
          "<p>Pour la compagnie Lyria, il vous sera possible de réserver vos futurs billets de transport <strong>à partir de 4 mois à l'avance</strong>. Aussi, dans le cadre de travaux sur les voies ou de modifications d'horaires (suite à une crise comme le coronavirus par exemple) les dates d'ouverture des ventes peuvent être modifiées mais cela reste rare.<br>À savoir, les meilleurs billets en termes de temps de trajet et de prix des trajets forts prisés sont vendu généralement dans les deux semaines après ouverture à la vente. N'attendez pas et réservez dè que possible !</p>",
      },

      {
        type: 'subtitle',
        content: "L'ouverture des ventes de billet RENFE",
      },

      {
        type: 'body',
        content:
          "<p>Les offres de billets de la compagnie ferroviaire espagnole RENFE sont, la plupart du temps, <strong>accessibles et réservables 4 mois à l'avance</strong>, comme c'est le cas pour la SNCF. Vous aurez donc le temps de comparer et de réserver votre voyage vers l'Espagne !</p>",
      },

      {
        type: 'subtitle',
        content: "L'ouverture des ventes de billet Thello",
      },

      {
        type: 'body',
        content:
          "<p>Chez Thello, les billets sont disponibles à l'achat à une date très précise : <strong>1 mois et un jour avant la date du trajet</strong>. Autrement dit, si vous comptez voyager le 26 juin prochain, vous pourrez réserver à partir du 27 mai !</p>",
      },

      {
        type: 'subtitle',
        content: "L'ouverture des ventes de billet Trenitalia",
      },

      {
        type: 'body',
        content:
          "<p>Pour ce qui est de la compagnie ferroviaire italienne Trenitalia, les billets de train Trenitalia sont disponibles à l'achat à des dates différentes en fonction de :<ul><li><p>S'il s'agit d'un <strong>trajet national</strong> : auquel cas les réservations sont possibles <strong>3 mois à l'avance</strong>. Ces dates peuvent légèrement varié parfois, en fonction de la compagnie... quoi qu'il arrive, nous vous tiendrons informé dans notre newsletter !</p></li><li><p>S'il s'agit d'un <strong>trajet international</strong> : dans ce cas, les billets Trenitalia sont réservables <strong>4 mois à l'avance</strong> !</p></li></ul></p>",
      },

      {
        type: 'subtitle',
        content: "L'ouverture des ventes de billet Deutsche Bahn",
      },

      {
        type: 'body',
        content:
          "<p>La compagnie ferroviaire allemande est comme à l'image du pays, très pointilleuse et méticuleuse. Les billets Deutsche Bahn sont <strong>disponibles à l'achat 6 mois à l'avance</strong> ! Aussi, toutes les offres de la Deutsche Bahn ne nécessitent pas une réservation, vous pourrez donc acheter vos billets de train allemand jusqu'à la dernière minute sans encombre ! Aussi, nous vendons sur notre site aussi des billets Deutsche Bahn X SNCF, ceux-ci sont également réservable 6 mois à l'avance, pour votre plus grand confort !</p>",
      },

      {
        type: 'title',
        content: "L'ouverture des ventes des billets de bus",
      },

      {
        type: 'body',
        content:
          "<p>Eh oui, il existe aussi un calendrier d'ouverture des ventes pour vos compagnies de bus préférées ! Découvrez les sans plus atendre.</p>",
      },

      {
        type: 'subtitle',
        content: "L'ouverture des ventes de billet Flixbus",
      },

      {
        type: 'body',
        content:
          "<p>Chez <em>Flixbus</em>, il n'y a <strong>pas d'informations précises</strong> quant à l'ouverture des ventes de leurs billets Flixbus. Cependant, en règle générale, nous pouvons affirmer que leur offres de trajets apparaissent sur notre site <strong>entre 4 et 6 mois à l'avance</strong>. On le sait, c'est une fourchette assez conséquente mais il apparait que chez Flixbus ils font un peu comme il veulent... Vous n'aurez qu'à rechercher un trajet pour les dates que vous souhaitez sur notre site et s'il n'y a pas de résultats, c'est que ces offres ne sont pas encore ouvertes tout simplement !</p>",
      },

      {
        type: 'subtitle',
        content: "L'ouverture des ventes de billet BlaBlaBus",
      },

      {
        type: 'body',
        content:
          "<p>Aussi, pour la vente des billets de bus <em>BlaBlaBus</em>, on retrouve la même problématique que pour Flixbus. Les dates d'ouvertures des offres ne sont pas fixes et peuvent parfois <strong>varier entre 2 et 4 mois à l'avance</strong>. Pour avoir la réponse, il vous suffit une nouvelle fois de lancer une recherche de billets sur notre site. S'il n'y a aucun résultat c'est que les offres ne sont pas encore ouvertes et que les <strong>billets BlaBlaBus arriveront bientôt</strong>. Pour l'heure, il faut attendre ! Après tout, vu le prix des billets que l'on vous propose, ça vaut le coût d'attendre non ?</p><p>En tout cas, on espère vous avoir aidé au mieux et que vous comprenez désormais pourquoi aucun résultat ne s'affiche pour le moment lors de votre recherche de trajet ! Il suffit juste d'être encore patient un petit temps !",
      },
    ],
    relatedQuestions: [
      'problemes-de-paiement-debite',
      'probleme-recherche-de-trajet',
    ],
  },
  {
    name: 'utiliser-carte-reduction-sncf',
    title:
      'Comment utiliser une carte senior SNCF, une carte jeune SNCF ou tout autre carte de réduction ?',
    meta: {
      title: 'Utiliser simplement une carte de réduction SNCF sur Tictactrip ?',
      description:
        "Vous avez une carte de réduction SNCF, carte jeune SNCF ou encore carte Senior SNCF mais vous ne savez pas comment l'utiliser ? C'est tout simple !",
    },
    category: ['recherche-reservation-billets'],
    updatedDate: '09/05/2020',
    content: [
      {
        type: 'body',
        content:
          "<p>Malheureusement, nous ne validons et prenons en compte aucun code promo SNCF sur le site Tictactrip. Par contre, pour vous, nous acceptons les cartes reduction SNCF ! En effet, que vous ayez la carte senior SNCF, la carte jeune SNCF ou encore la carte voyageur SNCF, nous les acceptons toutes ! Découvrez tout simplement ici comment les utiliser sur notre site afin de profiter de vos réductions pour voyager et payer encore moins cher ! Attention, nous prenons aussi d'autres cartes de réduction. Pour les découvrir, il vous suffit de vous rendre sur notre autre page FAQ consacrée à ces cartes de réductions acceptées.</p>",
      },

      {
        type: 'title',
        content:
          'Les étapes pour utiliser une carte de réduction SNCF sur Tictactrip',
      },

      {
        type: 'body',
        content:
          '<p>Pour utiliser une carte de réduction sur Tictactrip, c\'est tout simple ! En effet, il vous suffit de suivre ces étapes : <ol><li><p>Rendez-vous sur le site de Tictactrip</span>.</p></li><li><p>Tapez le nom des villes de votre trajet ainsi que vos dates de départ et de retour dans l’encart de gauche « Quel est votre trajet ».</p></li><li><p>Dans l’encart de droite « Dîtes-nous qui voyage », choisissez entre Jeune (0-27), Adulte (28-59) et Senior (60+) suivant votre situation.</p></li><li><p>En dessous, dans le menu déroulant « Carte de réduction », sélectionnez la carte de réduction SNCF ou l’abonnement auquel vous avez souscrit, comme une carte jeune SNCF ou encore une carte senior SNCF !</p></li><li><p>Enfin, cliquez sur le bouton " Validez ce passager" dans l’encart de droite, répétez l’opération si vous voyagez à plusieurs, et cliquez sur le bouton " Rechercher" dans l’encart de gauche.</p></li></ol></p><p>Et voilà, votre carte réduction SNCF, votre carte jeun SNCF, votre carte Senior SNCF ou votre carte de réduction Student Agency seront directement prises en compte dans les résultats de votre recherche ! Vous aurez alors seulement besoin de disposer de votre carte de réduction effective lors de votre trajet, au risque deprendre une amende sinon... Ce serai bête de ne pas l\'avoir et de devoir payer une amende, bien que les prix des transports soient si peu chers sur Tictactrip !</p><p>Alors, on ne vous a pas menti, ajouter une carte de réduction SNCF sur Tictactrip c\'est ultra simple et rapide !',
      },

      {
        type: 'img',
        content: 'recherche-reservation-billets_utiliser-carte-reduction.jpg',
        imgAlt:
          'comment utiliser une carte de reduction SNCF,bons plans SNCF, avantages SNCF',
      },
    ],
    relatedQuestions: ['bons-plans-sncf', 'comment-reserver-billet-enfant'],
  },
  {
    name: 'moyens-de-paiement-tictactrip',
    title: 'Quels sont les moyens de paiement acceptés sur Tictactrip ?',
    meta: {
      title: 'Découvrez tous les moyens de paiement Tictactrip !',
      description:
        'Tictactrip veut simplifier votre mobilité ! Découvrez les moyens de paiement avec lesquels vous pouvez réserver votre trajet.',
    },
    category: ['paiement'],
    updatedDate: '10/09/2020',
    content: [
      {
        type: 'body',
        content:
          "<p>Vous avez trouvé votre billet de rêve sur le site de Tictactrip ? On parie que c'est une belle <strong>combinaison de transports</strong> en plus !</p>Mais là, petit souci, vous ne savez pas encore <strong>quels moyens de paiement sont valides sur le site de Tictactrip</strong>...</p>",
      },

      {
        type: 'title',
        content: "L'ensemble des moyens de paiement acceptés sur Tictactrip",
      },

      {
        type: 'body',
        content:
          "<p>Chez Tictactrip, le paiement de vos billets de train, de bus, de covoiturage et de combinaisons de transports peut être réalisé via : <ul><li><p>Carte Bleue,</p></li><li><p>Carte Visa,</p></li><li><p>Mastercard.</p></li></ul></p><p>En effet, <strong>tout autre type de paiement ne sera pas accepté</strong>. Nous n'acceptons donc pas les chèques, les espèces, le paiement en nature, les virements via Paypal, la technologie Apple Pay ou encore les Bons Voyages SNCF et Bons de caisse SNCF.</p>À noter également : certaines réservations de billets impliquent <strong>une redirection</strong> vers la page de paiement du transporteur directement. Les moyens de paiement peuvent alors différer de Tictactrip. Découvrez les <strong>moyens de paiement acceptés par la SNCF</strong>, <strong>Ouigo</strong> et toutes les autres compagnies !</p>",
      },

      {
        type: 'img',
        content: 'paiement_tableau-moyens-paiement-Tictactrip.jpg',
        alt: 'moyens de paiement acceptés sur le site Tictactrip comparateur de voyage',
        imgSizePercent: 50,
      },
      {
        type: 'title',
        content:
          "L'ensemble des moyens de paiement acceptés par les compagnies de transport",
      },
      {
        type: 'body',
        content:
          "<p>Pour chaque compagnie de transport, il existe des politiques différentes concernant les annulations, les remboursements... mais surtout concernant les moyens de paiement acceptés ! En effet, la plupart des transporteurs permettent les paiements par <strong>carte bancaire</strong> et <strong>VISA</strong>, qui sont aujourd'hui les plus répandus.</p><p>Cependant, nombres d'autres types de paiements existent comme :<ul><li><p>Les paiements via Lydia,</p></li><li><p>Les paiements via Paypal,</p></li><li><p>Les paiements avec des chèques vacances, qui sont uniquement acceptés par la SNCF en gare, </p></li><li><p>Les paiements par chèque,</p></li><li><p>Les paiements par carte bleue,</p></li><li><p>Les paiements par carte Visa et électron, </p></li><li><p>Les paiements Amex,</p></li><li><p>Les paiements Maestro,</p></li><li><p>ou enfin les paiements Apple Pay.</p></li></ul></p><p>Découvrez le tableau récapitulatif ci-dessous.</p>",
      },
      {
        type: 'img',
        content:
          'paiement_tableau-recapitulatif-moyens-paiement-acceptes-par-compagnie.jpg',
        alt: 'tableau récapitulatif des moyens de paiement acceptés par compagnie de transport',
      },
    ],
    relatedQuestions: ['explication-3d-secure', 'problemes-de-paiement-debite'],
  },
  {
    name: 'billet-non-recu',
    title: 'Paiement effectué et billets non reçus, pourquoi ?',
    meta: {
      title:
        'Billets non reçus après paiement - Toutes les explications et solutions !',
      description:
        'Vous avez procédé au paiement de vos billets sur Tictactrip mais vous ne les avez pas reçu ? Pas de panique, voici les solutions simples.',
    },
    category: ['service-apres-vente'],
    updatedDate: '11/09/2020',
    content: [
      {
        type: 'body',
        content:
          "<p>Alors comme ça un souci est survenu dans l'<strong>envoi de vos billets</strong> ? Pas de panique, vos billets sont bien en notre possession ! Découvrez les différents cas de figure en cas de billets non reçus et les solutions pour y remédier rapidement !</p>",
      },

      {
        type: 'title',
        content: 'Une erreur sur votre réservation de billets',
      },

      {
        type: 'body',
        content:
          "<p>Parfois, il arrive qu'une erreur survienne lors de votre réservation. Cette <strong>erreur sera alors indiquée sur la page du site Tictactrip</strong> où vous vous trouvez (comme indiqué sur l'image ci-dessous). Dans ce cas, il est recommandé de <strong>contacter directement le service client de Tictactrip</strong> afin de remédier à votre problème. L'erreur peut provenir de l'un de nos partenaires, ou bien de votre banque qui refuse la réservation... Quoi qu'il en soit, contactez-nous !</p>",
      },

      {
        type: 'img',
        content:
          'service-apres-vente_page-erreur-reservation-flixbus-billet-non-recu.jpg',
        alt: "page d'erreur sur la réservation flixbus billet non recu",
      },

      {
        type: 'title',
        content:
          'La compagnie de transport partenaire ne nous a pas communiqué votre billet',
      },

      {
        type: 'body',
        content:
          "<p>Si vous avez réservé un voyage en bus <em>Flixbus</em>, il se peut que vous ne receviez pas votre billet de bus malheureusement...</p><p>Effectivement, Flixbus est bien la seule compagnie partenaire de Tictactrip avec laquelle un tel problème est déjà arrivé même si cela reste très rare ! 😣</p><p>Si vous ne recevez pas votre billet Flixbus, n'hésitez pas à contacter le support de Tictactrip. Nous nous ferons un plaisir de récupérer votre billet et de vous l'envoyer par mail très rapidement.</p>",
      },

      {
        type: 'title',
        content: 'Conseils pour récupérer vos billets non reçus ',
      },

      {
        type: 'body',
        content:
          '<p>Chez Tictactrip, nous avons remarqué que <strong>5% du temps</strong>, les mails finissent <strong>dans les spams</strong>. Pensez donc à vérifier que votre billet de transport ne se trouve pas dans votre boite mail "Indésirables" ou Spams.</p><p>Quelques fois, l\'adresse e-mail que vous avez inscrite lors de votre commande pour la réception de vos billets, est erronée. Dans ce cas, si vous avez un doute, n\'hésitez pas à contacter notre support client en y ajoutant toutes les informations possibles concernant votre trajet. De ce fait, nous pourrons prendre en charge le plus rapidement possible votre demande. Ce sera un gain de temps pour vous comme pour nous ! Merci.</p>',
      },
    ],
    relatedQuestions: [
      'comment-contacter-tictactrip',
      'problemes-de-paiement-debite',
    ],
  },
  {
    name: 'paiement-billet-partenaire',
    title: 'Je n’ai pas payé tous mes billets, pourquoi ?',
    meta: {
      title:
        "Réservation incomplète, je n'ai pas réservé et payé tous les billets",
      description:
        "Vous souhaitez savoir pourquoi vous n'avez pas reçu vos billets et pourquoi vous ne les avez pas tous payé sur Tictactrip",
    },
    category: ['paiement'],
    updatedDate: '22/04/2021',
    content: [
      {
        type: 'body',
        content:
          "<p>Vous le savez, avec Tictactrip vous pouvez réserver vos billets de bus, train, covoiturage et de combinaisons de transports très facilement !</p><p>Tictactrip est d'ailleurs un pionnier dans ces combinaisons intelligentes de transports.</p><p>Dans votre cas, vous avez probablement tenté de <strong>réserver une combinaison</strong> de différents modes de transports ou compagnies de transports. C'est une très bonne initiative, votre trajet n'en sera que plus agréable !</p><p>Découvrez pourquoi l'un des billets n'a pas été réservé et payé lors de votre réservation sur le site Tictactrip. C'est tout simple en fait...</p>",
      },
      {
        type: 'title',
        content: "La raison de la non-réservation de l'un de vos billets",
      },
      {
        type: 'body',
        content:
          "<p>Tictactrip, né en 2016, est une plateforme de billets très récente. Aujourd'hui, toutes les compagnies de transports que nous avons en tant que partenaires, ne nous permettent pas la réservation et le paiement directement sur notre site.</p><p>C'est pourquoi, certaines compagnies comme BlaBlaCar que vous connaissez bien, ne sont pas réservables sur le site de Tictactrip.</p><p>Mais, pour vous permettre de profiter au mieux de nos combinaisons intelligentes de transports, nous avons souhaité inclure ces compagnies dans les propositions de trajets. Vous pourriez alors avoir un bus Flixbus + un covoiturage Blablacar.</p><p>Dans ce cas, le bus sera réservable directement sur Tictactrip et un bouton sur notre page web vous permettra de réserver simplement le <strong>billet Blablacar manquant</strong>.</p><p>Voici un exemple de trajet avec un covoiturage Blablacar et le bouton vous invitant à réserver le billet sur le site de Blablacar.</p>",
      },
      {
        type: 'img',
        content: 'paiement_billets-carte-de-credit-main-ordinateur-main.jpg',
        alt: 'paiement-billets-carte de crédit-main-ordinateur-main',
      },
      {
        type: 'title',
        content:
          'Conseils importants concernant les réservations de billet Tictactrip',
      },
      {
        type: 'body',
        content:
          "<p>Vous l'aurez compris, il se peut que ce ne soit pas nous qui nous occupions de votre billet. Si vous réservez sur le site de Blablacar par exemple, toutes les demandes relatives à votre billet se passeront avec le service client Blablacar. Mais si votre trajet <strong>combine bus Flixbus + covoiturage Blablacar</strong>, pour le billet Flixbus, il vous faudra vous adresser à nous.</p><p>Nous le savons, ce n'est pas encore optimal, nous travaillons d'arrache-pied pour vous offrir une solution adéquate !</p><p>Second petit conseil : <strong>vérifiez</strong> toujours d'avoir bien réservé la totalité de vos billets avant de quitter la page de confirmation de commande sur le site Tictactrip ! Si un bouton indique : \"Réservez chez ... (nom de la compagnie)\", pensez à bien cliquer dessus afin de réserver votre billet. Nous ne voudrions pas que votre voyage soit gâché par ce souci...</p><p>Enfin, il est à noter que le prix affiché sur notre site pour votre trajet est le prix total. Si vous ne payez qu'une partie de votre trajet sur notre site, vous ne paierez donc pas la totalité de la somme affichée.</p>",
      },
    ],
    relatedQuestions: ['problemes-de-paiement-debite,billet-non-recu'],
  },
  {
    name: 'changement-nom-billet',
    title: 'Je voudrais changer le nom sur mes billets, comment faire ?',
    meta: {
      title:
        'Changement de nom sur un billet Tictactrip : toutes les solutions !',
      description:
        "Vous venez d'acheter un billet mais il y a une faute de frappe à votre nom ? Ou vous souhaitez faire voyager quelqu'un d'autre ? Découvrez les solutions de changement de nom billet !",
    },
    category: ['service-apres-vente'],
    updatedDate: '19/09/2020',
    content: [
      {
        type: 'body',
        content:
          "<p>Les <strong>erreurs</strong> concernant les informations relatives aux achats de billets sont courantes. En effet, parfois, les dates choisies peuvent être erronées suite à une maladresse et parfois c'est le <strong>nom inscrit sur le billet qui pose problème</strong>. En effet, une étourderie, une faute de frappe ou alors la réservation d'un billet pour une autre personne que soi, peuvent être tant de raisons qui vous poussent à vouloir modifier le nom sur votre billet.</p><p>Il faut bien noter également que chez la plupart des compagnies de transport, les billets sont nominatifs. Cela signifie que <strong>seule la personne dont le nom est inscrit sur le billet pourra voyager</strong> avec ce dernier. Lors de contrôle, si ce n'est pas votre propre nom qui figure, vous pourriez être sanctionné et contraint de payer une amende. Faites donc bien attention. Vérifiez toujours vos billets avant de voyager !</p><p>Découvrons ensemble les démarches à suivre afin de réussir à modifier le nom présent sur votre billet, lorsque c'est possible !</p>",
      },
      {
        type: 'title',
        content:
          'Les cas où il vous est possible et rapide de modifier le nom sur votre billet',
      },
      {
        type: 'body',
        content:
          '<p>Heureusement pour vous, chez certaines compagnies, il est TRÈS simple de modifier le nom présent sur votre billet. C\'est notamment le cas de la compagnie <em>Flixbus</em>. <strong>Modifier le nom billet Flixbus</strong> est un jeu d\'enfant ! Il vous suffira uniquement de vous rendre sur votre espace Flixbus ici : <a href="https://shop.flixbus.fr/rebooking/login">https://shop.flixbus.fr/rebooking/login</a>.</p> Pour le moment, Flixbus est la seule compagnie partenaire de Tictactrip chez qui il est possible de modifier le nom inscrit sur votre billet.</p>Pensez donc à vérifier sur votre billet (en image ci-dessous), que ce soit bien le bon nom qui figure !</p>',
      },
      {
        type: 'img',
        content:
          'service-apres-vente_changement-nom-passager-billet-tictactrip.jpg',
        alt: 'billet flixbus nom passager changement de nom billet tictactrip',
      },
      {
        type: 'title',
        content:
          'Démarches pour la modification du nom de votre billet pour les autres compagnies',
      },
      {
        type: 'body',
        content:
          "<p>Malheureusement, chez toutes les autres compagnies, il vous sera <strong>impossible de modifier le nom</strong> ou faire modifier le nom inscrit sur votre billet.</p><p>De ce fait, le seul et unique moyen que vous aurez afin de modifier le nom de votre billet, sera de l'échanger et/ou, de l'annuler et de le réserver à nouveau.</p><p>Il ne vous est donc pas possible de <strong>modifier le nom de votre billet TER</strong>, de modifier le nom de votre billet Inoui ou encore BlaBlaBus.</p>Afin d'annuler et réserver à nouveau votre billet suite à votre erreur de nom, nous vous invitons à vous référer directement à notre FAQ dédiée : <a href=\"https://www.tictactrip.eu/faq/politique-annulation-remboursement-billet\">https://www.tictactrip.eu/faq/politique-annulation-remboursement-billet</a> ou a contacter directement notre support client afin d'obtenir l'annulation de votre billet.</p>",
      },
    ],
    relatedQuestions: [
      'reserver-billet-autre-personne',
      'imprimer-billet-train-bus',
    ],
  },
  {
    name: 'animal-compagnie-a-bord-du-train',
    title: "Est-il possible d'emmener un animal de compagnie à bord du train ?",
    meta: {
      title:
        'Découvrez les politiques des compagnies de train concernant les animaux domestique à bord',
      description:
        'Vous voulez voyager tout en emmenant votre animal de compagnie ? Découvrez à bord de quels trains votre animal de compagnie peut voyager !',
    },
    category: ['conditions-de-voyage-tarifs-compagnies'],
    updatedDate: '10/10/2020',
    content: [
      {
        type: 'body',
        content:
          "<p>Vous vous en doutez certainement, tous les transporteurs n'acceptent pas les animaux de compagnie à bord. Certaines compagnies de train auront une politique sévère concernant votre animal alors que d'autres seront plus laxistes.</p><p>Pensez bien à vous renseigner sur les conditions de voyages des animaux à bord des trains avant de réserver vos billets.</p>",
      },

      {
        type: 'title',
        content: 'Animaux à bord des trains Ouigo (France)',
      },

      {
        type: 'body',
        content:
          "<p>Chez Ouigo, la marque de TGV low cost de la SNCF, il vous sera possible d'emmener votre animal de compagnie. En effet, la politique de la compagnie de train vous permet d'emmener avec vous, jusqu'à deux animaux de compagnie par réservation. Attention cependant, il y a quelques règles à suivre concernant le voyage de vos animaux de compagnie à bord des trains Ouigo : <ul><li><p>Les petits animaux de compagnies qui pèsent jusquà 6kg doivent voyager dans une box aux mesures suivante : <strong>55 cm x 35 cm x 25 cm</strong>. Celle-ci doit être posée à vos pieds ou sur vous.</p></li><li>Les animaux plus grands, doivent être inscrits à bord du train. Vous devrez alors payer un <strong>billet animal de 30€</strong> par animal à bord du train Ouigo.</p></li></ul></p><p>Les billets pour animaux sont réservables directement auprès de la compagnie Ouigo.</p>",
      },

      {
        type: 'img',
        content:
          'conditions-de-voyage-tarifs-compagnies_chien allonge dans un train - animal train.jpg',
        alt: 'chien allonge dans un train - animal domestique à bord train',
      },

      {
        type: 'title',
        content: 'Animaux à bord des trains SNCF (France)',
      },

      {
        type: 'body',
        content:
          "<p>Chez la SNCF, la politique concernant l'accès à bord des animaux de compagnie est la même que pour sa marque Ouigo. En effet, l'objectif de la SNCF est de vous permettre de voyager sereinement. La compagnie de train française vous permet d'emmener avec vous, jusqu'à deux animaux de compagnie par réservation. Attention tout de même, il y a quelques conditions concernant le voyage de vos animaux de compagnie à bord des trains SNCF : <ul><li><p>Les animaux de compagnies de petite taille et qui pèsent jusquà 6kg voyageront obligatoirement dans une cage aux mesures suivante : 55 cm x 35 cm x 25 cm. Celle-ci doit être placée à vos pieds ou sur vos genoux.</p></li><li>Les animaux de plus grandes taille, doivent voyager à vos pieds et être muselés durant la totalité du voyage. Cela permet d'assurer la sécurité de l'ensemble des passaegers même si votre animal n'est pas agressif.</p></li><li><p>Enfin, les chiens d'aveugle voyage gratuitement et ne sont pas contraints d'être muselés durant le trajet.</p></li></ul></p><p>Les billets pour animaux sont réservables directement auprès de la SNCF.</p>",
      },

      {
        type: 'title',
        content:
          'Animaux à bord des trains Thalys (France, Allemagne, Pays-Bas, Belgique)',
      },

      {
        type: 'body',
        content:
          "<p>Chez Thalys, vous remarquerez les similitudes avec les conditions de voyages pour animaux appliquées par la SNCF. </p><p>Effectivement, les animaux de petite taille (toujours pesant moins de 6kg) devront voyager dans une cage aux dimensions maximales de  45 cm x 30 cm x 25 cm. </p><p>Pour les animaux plus grands, un billet spécial devra être acheter en amont du voyage. Pour réserver ce billet pour votre animal de compagnie, c'est auprès de la Deustche Bahn que la réservation aura lieu. Ces animaux devront être tenus en laisse et muselés durant la totalité du trajet.</p><p>Enfin, les chiens guide pour aveugle voyageront gratuitement à bord des trains Thalys. Ils n'auront pas besoin d'être muselé durant le trajet.</p>",
      },

      {
        type: 'title',
        content: 'Animaux à bord des trains TGV Lyria (France et Suisse)',
      },

      {
        type: 'body',
        content:
          "<p>Chez Lyria, la compagnie de train qui assure des liaisons entre la France et la Suisse, il vous sera possible de voyager avec vos animaux de compagnie. Pour votre trajet entre la France et la Suisse, votre animal devra cependant respecter quelques conditions de voyage : <ul><li><p>S'il pèse moins de 6kg, il devra voyager en cage, sur vos genoux ou sous vos pieds. La boîte dans laquelle il voyagera ne devra pas dépasser les mesures suivantes : 45 cm x 30 cm x 25 cm.</p></li><li><p>S'il pèse plus de 6kg, il devra voyager en position allongée sous vos pieds durant la totalité du trajet. Également, vous devrez tenir en laisse et museler votre animal afin d'assurer la sécurité de l'ensemble des passagers. Afin qu'ils voyagent sans souci, ces animaux doivent être muni d'un billet spécial, réservable auprès des guichets de la SNCF et/ou de la SBB.</p></li><li><p>Enfin, les chiens guide pour aveugles peuvent voyager gratuitement à bord des TGV Lyria. Ils ne sont pas nécessairement muselé durant le trajet.</p></li></ul></p>",
      },

      {
        type: 'title',
        content: 'Animaux à bord des trains Thello (France et Italie)',
      },

      {
        type: 'body',
        content:
          "<p>Chez Thello, la compagnie de train qui assure les <strong>liaisons entre la France et l'Italie</strong>, vous aurez la chance de voyager facilement avec votre animal de compagnie. En effet, les animaux de petite taille, pesant <strong>moins de 5kg</strong>,pourront <strong>voyager gratuitement</strong> dans une cage de transport.</p><p>Pour les animaux plus grands, allant de 5 à 50 kg, un seul animal est autorisé à voyager avec vous et ce, uniquement si vous avez réservé une cabine exclusive pour vous-même, votre famille et/ou vos amis. L'animal devra être tenu en laisse et muselé. Des frais supplémentaires de 50€ vous seront facturés. Voyez cela comme le billet de votre animal...</p><p><a href=\"https://www.thello.com/paris-venise/animaux/\">Plus d'informations</a>.</p>",
      },

      {
        type: 'title',
        content: 'Animaux à bord des trains Trenitalia (Italie)',
      },

      {
        type: 'body',
        content:
          "<p>La compagnie Trenitalia, c'est un peu la SNCF mais en Italie ! Sur leurs lignes ferroviaires, il vous sera possible d'emmener votre animal de compagnie à bord des trains pour lui faire découvrir l'Italie (et on espère qu'il va apprécier !).</p><p>Mais attention, pour permettre à votre animal de compagnie de monter à bord des trains Trenitalia, il faudra : <ul><li><p>Qu'il soit en cage aux dimensions maximum de <strong>70 cm x 30 cm x 50 cm</strong>, s'il s'agit d'un petit animal.</p></li><li><p>Qu'il soit munis d'un billet acheté rien que pour lui s'il s'agit d'un pus gros chien. Ce dernier devra voyager en étant tenu en laisse et en étant équipé d'une muselière. Pour toute information et/ou réserver le billet de votre animal, rendez-vous sur le site de Trenitalia.</p></li><li><p>Enfin, quel que soit l'animal de compagnie avec lequel vous voyagez, vous devrez être muni de son <strong>certificat d'enregistrement</strong> et de son <strong>carnet de santé</strong>. Ces documents peuvent être remplacés par un passeport pour animal de compagnie. S'il vous manque l'un de ces documents, vous ne pourrez malheureusement pas voyager et vous serez prié de quitter le train. Mieux vaudrait ne pas oublier (cela n'est pas valable pour les chiens guides) !</p><p>Plus d'informations sur le <a href=\"https://www.trenitalia.com/content/tcom/fr/services/le_transport_desanimauxdomestiques.html#:~:text=Les%20petits%20chiens%2C%20les%20chats,dont%20les%20dimensions%20doivent%20%C3%AAtre\">site de Trenitalia</a>.</p>",
      },

      {
        type: 'title',
        content: 'Animaux à bord des trains SNCB (Belgique)',
      },

      {
        type: 'body',
        content:
          "<p>Chez la SNCB, Société Nationale des Chemins de fer belges vous l'aurez compris, vous aurez la possibilité de voyager avec votre animal de compagnie.</p><p>En effet, les petits animaux de compagnie peuvent voyager gratuitement dans une caisse de voyage aux dimensions maximales de <strong>55 cm x 30 cm x 30 cm</strong>.</p><p>Les animaux plus grand quant à eux, peuvent voyager à conditions d'être munis d'un billet qui leur est propre. Ce billet est en fait un billet animal à prix réduit donc pas de panique quant au prix ! Votre animal devra alors être tenu en laisse et il est fortement conseillé de l'équiper d'une muselière. En effet, tout employé de la <em>SNCB</em> peut vous demander de lui mettre sa muselière. Pensez donc à l'avoir sur vous !</p><p>Pour réserver un billet animal, contactez directement la SNCB ou rendez-vous <a href=\"https://www.belgiantrain.be/fr/tickets-and-railcards/pet-ticket\">ICI</a>.</p>",
      },

      {
        type: 'title',
        content: 'Animaux à bord des trains SBB (Suisse)',
      },

      {
        type: 'body',
        content:
          '<p>À bord des trains de la <em>SBB</em> ou <em>CFF</em> en français, il vous sera permis de voyager avec votre animal de compagnie. Attention cependant, la compagnie suisse est assez stricte : <ul><li><p>Pour les petits animaux, ceux ne dépassant pas <strong>30cm de hauteur au garrot</strong>, ils pourront voyager gratuitement à partir du moment où ils sont placé dans un sac, un panier ou une cage de transport.</p></li><li><p>Pour les animaux de plus grande taille, vous devrez acheter un <strong>billet valide durant une journée</strong>. Ce billet est disponible à l\'achat en gare ou sur le <a href="https://www.sbb.ch/fr/horaire/conseils-voyageurs/chiens.html">site de la SBB</a>.</p></li></ul></p>',
      },

      {
        type: 'title',
        content: 'Animaux à bord des trains de la Renfe (Espagne)',
      },

      {
        type: 'body',
        content:
          "<p>Au sein des trains de la Renfe, la règlementation concernant le voyage de votre animal de compagnie est claire et simple : vous pouvez emmener votre animal de compagnie à bord des trains de la Renfe. Voici les quelques conditions au voyage de votre compagnon de route :<ul><li><p>Les chiens, chats et oiseaux sont autorisés et il n'y a aucune limite ni distinction concernant le poids</p></li><li><p>Votre animal de compagnie voyage gratuitement et sans billet réservé au préalable.</p></li><li><p>Aucune cage ou panier n'est nécessaire au voyage de votre animal, cependant il doit être tenu en laisse et porter une muselière.</p></li><li><p>Chaque personne ne peut voyager qu'avec un seul et unique animal de compagnie.</p></li></ul><p>Pour réserver votre billet Renfe, c'est <a href=\"https://www.renfe.com/es/fr\">ICI</a>.</p>",
      },

      {
        type: 'title',
        content:
          'Animaux à bord des trains Eurostar (France, Royaume-Uni, Belgique)',
      },

      {
        type: 'body',
        content:
          "<p>Mauvaise surprise chez <em>Eurostar</em> : il ne vous est pas possible de voyager avec votre animal de compagnie. Effectivement, seuls les chiens guides sont acceptés à bord des trains Eurostar et encore, il y a quelques conditions :<ul><li><p>Votre chien doit être accrédité par l'<em>Assistance Dogs</em> OU <em>The International Guide Dog Federation</em> OU <em>Assistance Dogs International</em>.</p></li><li><p>Vous devrez disposer des documents nécessaires pour prouver cette accréditation au départ ainsi qu'à l'arrivée.</p></li><li><p>Enfin, les chiens guides doivent avoir un billet Eurostar pour voyager. La réservation est possible en contactant directemment la compagnie Eurostar.</p></li></ul></p><p>Pour plus d'informations, rendez-vous <a href=\"https://www.eurostar.com/fr-fr/voyage/preparez-votre-voyage/chiens-assistance\">ICI</a>.</p>",
      },

      {
        type: 'title',
        content: 'Animaux à bord des trains Deutsche Bahn (Allemagne)',
      },

      {
        type: 'body',
        content:
          "<p>En Allemagne, si vous comptez voyager avec la compagnie ferroviaire <em>Deutsche Bahn</em>, sachez que vous aurez la possibilité d'emmener avec vous votre animal de compagnie !</p><p>Les petits animaux de compagnie, de la taille d'un chat au maximum, peuvent voyager gratuitement s'ils sont placés dans une cage de voyage, sous vos pieds, sur vos genoux ou au dessus de vous.</p><p>Les animaux de plus grande taille sont quant à eux obligés de posséder leur propre billet. Pas de panique, des billets spéciaux pour les animaux existent chez la Deutsche Bahn. Ces billets sont réservables uniquement auprès de la compagnie. Enfin, pour le voyage, les grands animaux de  compagnie doivent être tenus en laisse et muselés.</p><p>Enfin, bien évidemment, les chiens guides sont acceptés dans les trains de la compagnie ferroviaire allemande. Ces chiens voyagent gratuitement et n'ont pas besoin d'être muselés.</p>",
      },
    ],
    relatedQuestions: [
      'reserver-billet-autre-personne',
      'animal-compagnie-a-bord-du-bus',
    ],
  },
  {
    name: 'couvre-feu-train-sncf',
    title: 'Couvre-feu : quels changements pour mon train SNCF ?',
    meta: {
      title: 'Découvrez tous les changements SNCF liés au couvre-feu 2020',
      description:
        'Retrouvez toutes les informations relatives aux trains SNCF et aux changements applicables pour le couvre-feu 2020.',
    },
    category: ['conditions-de-voyage-tarifs-compagnies'],
    updatedDate: '18/10/2020',
    content: [
      {
        type: 'body',
        content:
          "<p>Le 14 octobre 2020, Mr Emmanuel Macron, Président de la République, a fait l'annonce d'un couvre-feu prenant effet de 21h à 6h pour toute la région Ile-de-France et pour les métropoles d’Aix-Marseille, Grenoble, Lille, Lyon, Montpellier, Rouen, Saint Etienne et Toulouse. Le couvre-feu débute le samedi 17 octobre pour une durée minimum de 4 semaines.</p><p>Au niveau des transports, nous attendions plus de précisions afin de savoir ce qu'il serait permis de faire ou non. Voici toutes les réponses aux questions que vous vous posez.</p>",
      },

      {
        type: 'img',
        content:
          'conditions-de-voyage-tarifs-compagnies_trajet en train SNCF masque - restrictions des train couvre-feu 2020.jpg',
        alt: 'trajet en train SNCF masque - restrictions des train couvre-feu 2020',
      },

      {
        type: 'title',
        content: 'La SNCF face au couvre-feu instauré',
      },

      {
        type: 'body',
        content:
          "<p>La SNCF a confirmé que ce couvre-feu n'impliquait aucune modification de circulation sur ses lignes ferroviaires. Les TGV InOui, OUIGO, Intercités, TER et l'ensemble des trains internationaux circuleront sans modification durant le week-end des 16, 17 et 18 octobre. Il en va de même pour les trajets en train ayant lieux durant les vacances de la Toussaint.</p><p>L'ensemble des mesures sanitaires prises par la SNCF comme le port du masque obligatoire durant les trajets et la désinfection quotidienne des trains sont bien entendu maintenues.</p><p>Pour permettre aux voyageurs de se retourner concernant leurs futurs trajets et à la suite des annonces gouvernementales, tous les billets SNCF sont échangeables et remboursables sans frais jusqu'au 4 janvier 2021.</p><p>De plus, le Gouvernement a annoncé qu'il y aurait des dérogations pour les raisons suivantes : <ul><li><p>pour se rendre chez le médecin, la pharmacie de garde ou l’hôpital,</p></li><li><p><strong>pour les déplacements en avion ou train</strong>,</p></li><li><p>pour raison professionnelle,</p></li><li><p>ainsi que pour se rendre auprès d’un proche dépendant ou pour sortir son animal de compagnie.</p></li></ul></p><p>Vous pouvez dès à présent remplir votre attestation de déplacement dérogatoire sur le site du Gouvernement <a href=\"https://www.gouvernement.fr/info-coronavirus\">www.gouvernement.fr/info-coronavirus</a>.</p><p><strong>ATTENTION</strong> : Pour les déplacements en train avec la SNCF, il est important de noter que vous devrez vous munir d’une attestation si l’heure de départ de votre train se situe sur les heures de couvre-feu. Autrement, dans les autres cas où l'heure du départ du train serait en dehors de la période de couvre-feu, l’attestation ne sera pas nécessaire, le billet faisant foi.</p>",
      },

      {
        type: 'subtitle',
        content:
          'Mon train part pendant la période de couvre-feu depuis une agglomération soumise au couvre-feu, puis-je le prendre ?',
      },

      {
        type: 'body',
        content:
          "<p><strong>OUI</strong> : vous pourrez vous rendre en gare afin de monter à bord de votre train au départ avant 06h ou après 21h. N'oubliez pas de vous munir de votre attestation dérogatoire disponible sur le site du gouvernement (en lien plus haut). </p>",
      },

      {
        type: 'subtitle',
        content:
          'Mon train part en-dehors de la période de couvre-feu mais arrive pendant le couvre-feu dans une zone soumise au couvre-feu, puis-je le prendre ?',
      },

      {
        type: 'body',
        content:
          "<p>Si votre trajet en train SNCF a débuté avant 21h, vous pouvez arriver en train après 21h dans l'une des neuf zones concernées par le couvre-feu sans aucun souci. Vous n'aurez pas besoin d'attestation. En effet, votre billet de train fera à lui tout seul office de dérogation. Après, ce n'est pas une raison pour traîner dans les rues !</p>",
      },

      {
        type: 'subtitle',
        content:
          'Est-il possible de traverser une zone concernée par le couvre-feu pour une correspondance entre deux trains ?',
      },

      {
        type: 'body',
        content:
          "<p>Puisqu'il s'agit d'une correspondance, le départ de votre deuxième train tombe parfaitement dans la période de couvre-feu... Mais pas de panique ! Vous pourrez traverser la zone concernée par le couvre-feu,à condition cependant que vous soyez muni de votre <strong>attestation dérogatoire de déplacement</strong>.</p>",
      },

      {
        type: 'subtitle',
        content: 'Comment savoir si je suis en zone de "couvre-feu" ?',
      },

      {
        type: 'body',
        content:
          "<p>Les trains SNCF circulent normalement sur le réseau ferroviaire français. Cependant, nous vous invitons à <strong>vérifier sur le site du Gouvernement</strong> si vos gares de départ et d'arrivée se situent ou non en zone de couvre-feu. Si tel est le cas, n'oubliez pas de remplir votre attestation dérogatoire de déplacement.</p>",
      },
    ],
    relatedQuestions: [
      'compagnies-transport-annulation-remboursement-coronavirus',
      'reserver-sur-tictactrip',
    ],
  },
  {
    name: 'animal-compagnie-a-bord-du-bus',
    title:
      'Est-il possible de faire voyager un animal de compagnie à bord du bus ?',
    meta: {
      title:
        'Découvrez les politiques des compagnies de bus relatives au voyage des animaux domestiques',
      description:
        'Vous souhaitez voyager avec votre animal de compagnie ? Découvrez à bord de quels bus votre animal de compagnie peut voyager !',
    },
    category: ['conditions-de-voyage-tarifs-compagnies'],
    updatedDate: '20/10/2020',
    content: [
      {
        type: 'body',
        content:
          "<p>Comme vous le savez, chez certains transporteurs, les animaux sont interdits. C'est le cas des trains Eurostar par exemple (à l'exception des chiens guide). Mais qu'en est-il de la politique relative aux animaux pour les compagnies de bus ? Découvrez toutes les conditions de voyage de votre animal domestique à bord d'un bus !</p>",
      },

      {
        type: 'img',
        content:
          'conditions-de-voyage-tarifs-compagnies_chien sur une valise - animal de compagnie bus.jpg',
        alt: 'chien sur une valise - animal de compagnie bus',
      },

      {
        type: 'title',
        content: 'Animaux à bord des bus Flixbus',
      },

      {
        type: 'body',
        content:
          "<p>À bord des bus Flixbus, aucun animal domestique n'est accepté. Flixbus insiste bien sur le fait qu'il s'agisse de mesures de sécurité afin de ne pas risquer de faire perdre le contrôle du bus au chauffeur. </p><p><strong>Seuls les chiens guides d'aveugles</strong> sont autorisés à voyager dans les bus Flixbus. Ils ont aussi le privilège de voyager gratuitement en Flixbus. Cependant, vous devrez bien penser à contacter Flixbus au minimum 36h à l'avance pour les informer de votre trajet avec chien guide.</p>",
      },

      {
        type: 'title',
        content: 'Animaux à bord des bus BlaBlaBus',
      },

      {
        type: 'body',
        content:
          "<p>Comme chez la plupart des compagnies d'autocar, il est interdit chez <em>BlaBlaBus</em> de voyager avec son animal domestique. Eh oui malheureusement, votre petit protégé devra rester seul en votre absence. Pensez à le confier à quelqu'un de confiance ou à recourrir à un pet-sitter : le baby-sitter pour animal domestique ! Vous trouverez aisément une bonne âme prête à vous rendre service.</p><p>Cependant, les chiens guides sont, tout comme chez Flixbus, autorisés à voyager à bord du bus BlaBlaBus. Pour voyager en Blablabus avec votre chien guide, pensez à respecter les conditions suivantes : <ul><li><p>Contactez le service client au plus tard 36h avant le départ de votre trajet aifn de les prévenir de la présence du chien-guide. Cela permettra aux équipes de <em>BlaBlaBus</em> de faire le nécessaire pour assurer le bon déroulement de votre trajet.</p></li><li><p>Le jour du trajet, pensez à bien vous munir de votre <strong>carte d'identité</strong> ainsi que de <strong>documents justifiant du handicap</strong> et de la présence requise du chien-guide à bord du bus. Une fois ce contrôle effectué, il est prévu que le capitaine de bord aide la personne souffrant de handicap et son compagnon à s'installer à bord du bus.</p></li></ul></p>",
      },

      {
        type: 'title',
        content: 'Animaux à bord des navettes Altibus',
      },

      {
        type: 'body',
        content:
          "<p>Avec Altibus, il vous est simple de rejoindre plus de 85 stations de ski en transports en commun ! Mais vous sera-t-il possible de partir à la montagne avec votre animal domestique ?</p><p>La réponse est OUI, c'est tout à fait possible ! D'après les conditions générales de transport de Transdev Haute-Savoie, les animaux de compagnie de petite taille peuvent voyager gratuitement dans les navettes Altibus à condition qu'ils soient placés dans une cage de transport ou un panier fermé et gardé sur vos genoux.</p><p>Pour les animaux plus grand, vous devrez leur réserver un billet au 1/2 tarif. Pour les animaux ne tenant pas dans un panier comme évoqué précédemment, ils devront être tenus en laisse et muselés. Autrement, l'accès à bord pourrait vous être refusé.</p><p>Enfin, les chiens-guide d'aveugle sont autorisé à voyager gratuitement dans les navettes Altibus de Haute-Savoie.</p>",
      },
    ],
    relatedQuestions: [
      'reserver-billet-autre-personne',
      'animal-compagnie-a-bord-du-train',
    ],
  },
  {
    name: 'billet-train-enfant',
    title: 'Enfants : quel billet de train acheter ?',
    meta: {
      title: 'Quel billet de train acheter pour votre enfant ?',
      description:
        'Découvrez les différents types de billets de train pour enfant, en fonction de la compagnie de transport avec laquelle vous voulez voyager !',
    },
    category: ['conditions-de-voyage-tarifs-compagnies'],
    updatedDate: '25/10/2020',
    content: [
      {
        type: 'body',
        content:
          "<p>Réserver un billet de train pour enfant semble au premier abord, une chose aisée. Mais ce n'est pas toujours le cas, malheureusement... C'est à croire que certaines compagnies font exprès de complexifier leurs offres pour que nos petits bambins ne voyagent pas... Bref, on a décidé de vous simplifier tout ça !</p><p>Découvrez sans plus attendre quel billet acheter pour votre enfant, en fonction de la compagnie de transport de votre choix ! </p>",
      },

      {
        type: 'img',
        content:
          'conditions-de-voyage-tarifs-compagnies_billet train enfant - enfant sur un siege dans un train cote fenetre.jpg',
        alt: 'billet train enfant - enfant sur un siege dans un train cote fenetre',
      },

      {
        type: 'title',
        content: 'Billet de train pour enfant chez la SNCF (France)',
      },

      {
        type: 'body',
        content:
          '<p>Chez la SNCF, la compagnie ferroviaire qui assure les trajets en France, de nombreuses options différentes sont possibles pour permettre à votre enfant de voyager en train.</p>',
      },

      {
        type: 'subtitle',
        content: 'Les tarifs des billets enfants avec TGV et Intercités',
      },

      {
        type: 'body',
        content:
          "<p>Il faut savoir que chez la SNCF, le voyage pour les enfants de <strong>moins de 4 ans</strong> est <strong>gratuit</strong>. Il n'aura cependant pas de place distincte, à vous de le prendre sur vous par exemple. Pour seulement 9€, votre enfant pourra jouir du forfait Bambin et notamment d'une place assise bien à lui.</p><p>Si votre enfant est âgé de 4ans à 12ans, il devra payer <strong>la moitié du prix d'un billet adulte</strong>, sous réserve de disponibilité. N'hésitez pas à contacter la SNCF directement pour faire valoir les droits de votre enfant.</p>",
      },

      {
        type: 'subtitle',
        content: 'Les tarifs des billets enfants avec TER',
      },

      {
        type: 'body',
        content:
          "<p>Comme pour les billets Intercités et TGV, si votre enfant a moins de 4ans, il pourra voyager gratuitement, <strong>sans place distincte</strong>.</p><p>S'il est âgé de 4ans à 12ans, profitez de l'offre SNCF : <em>Découverte Enfant Plus SNCF</em>. Cette offre vous permettra d'obtenir des réductions de 25% sur vos trajets en <a href=\"https://lu.oui.sncf/fr/informations-pratiques/calendrier-voyageurs\">période bleue</a> (offre valable pour 4 accompagnateurs, parents ou non).</p>",
      },

      {
        type: 'subtitle',
        content: 'Les tarifs des billets enfants avec OuiGo',
      },

      {
        type: 'body',
        content:
          '<p>Chez <em>Ouigo</em>, la marque de TGV low cost de la SNCF, les <strong>billets enfants</strong> aussi sont <strong>low cost</strong> ! En effet, pour tous les départs et arrivées des <strong>gares de Paris Centre</strong> et <strong>Lille-Flandres</strong>, si votre enfant est âgé de 0 à 11 ans, son billet enfant sera compris <strong>entre 5€ et 8€</strong> ! On espère que ces minis prix pour les trajets enfants en Ouigo vont permettre à toute votre famille de partir en voyage !</p>',
      },

      {
        type: 'subtitle',
        content: 'Les offres SNCF pour les familles',
      },

      {
        type: 'body',
        content:
          "<p>Chez la SNCF, il vous sera possible de profiter d'offres avantage en souscrivant à l'une des cartes de réduction de la SNCF, spécialement destinées aux  familles ! Voici les deux cartes : <ul><li><p><strong>La Carte Avantage Famille</strong> pour les parents âgés de  27 à 59 ans qui voyagent occasionnellement  : elle vous permettra notamment d'obtenir des réductions allant jusqu'à 30% sur vos trajet allers-retours comprenant au moins un jour/une nuit de week-end sur place. Mais ce n'est pas tout, vous aurez aussi la possibilité de profiter de 60%de réduction sur les billets de vos enfants âgés de 4 à 11 ans (dans la limite de trois enfants).</p></li><li><p><strong>La Carte Familles Nombreuses</strong> : avec cette carte, si vous avez 3 enfants ou plus, vous pourrez obtenir des réductions allant jusqu'à 75% du prix de vos billets. Pour en savoir plus, rendez-vous <a href=\"https://www.oui.sncf/services-train/famille/carte-familles-nombreuses\">ICI</a>.</p></li></ul></p>",
      },

      {
        type: 'subtitle',
        content: 'Résumé des tarifs enfant SNCF',
      },

      {
        type: 'body',
        content:
          "<p>En bref, chez la SNCF, votre enfant de moins de 4 ans voyage gratuitement mais sans jouir d'une place distincte à son nom pour votre trajet.</p><p>Et si votre enfant à entre 4 ans et 12 ans, il dispose automatiquement de de 50% de réduction sur le prix de son billet au tarif loisir.</p><p>Pensez aussi à souscrire à l'offre familiale de la <em>CARTE AVANTAGE FAMILLE SNCF</em> si vous voyagez souvent. Pour les familles nombreuses, la CARTE FAMILLES NOMBREUSES sera la plus avantageuse.</p>",
      },

      {
        type: 'title',
        content: 'Billet de train pour enfant chez Thalys (France & Belgique)',
      },

      {
        type: 'body',
        content:
          "<p>Chez Thalys, la compagnie de train Franco-Belge, la politique de voyage des enfants est simple : <ul><li><p>Les enfants de moins de 4ans voyagent gratuitement mais sans siège attitré. Ils devront alors voyager sur les genoux de leur parents.</p></li><li><p>Autrement, si vous souhaitez qu'ils disposent d'un siège, vous pouvez leur  acheter un billet au tarif enfant (à partir de 15€). Ce billet enfant Thalys est obligatoire pour les enfants de plus de 4 ans.</p>",
      },

      {
        type: 'title',
        content: 'Billet de train pour enfant chez Thello (France & Italie)',
      },

      {
        type: 'body',
        content:
          "<p>Chez Thello, la compagnie de train qui vous permet de voyager entre la France et l'Italie, la politique concernant le voyage des enfants est un peu différente des précédentes. En effet, <strong>un seul enfant de moins de 4 ans par accompagnateur</strong> peut voyager gratuitement et sans siège distinct. Si un seul parent (ou accompagnateur) est présent et qu'il voyage avec deux ou trois enfants, le deuxième et potentiellement le troisième doivent disposer de billets. </p><p>Thello considère qu'un seul enfant peut voyager sur les genoux de l'accompagnateur, les autres devant disposer de places  à eux. Pour les enfants de 4 à 14 ans, des billets nominatifs doivent être achetés au sein de la même réservation que pour les billets adultes. Ces enfants disposent de <strong>réductions de 30%</strong> sur le prix adulte au tarif Smart et Flexi chez Thello. Voilà, vous savez tout pour les <strong>billets enfants Thello</strong>.</p><p>Pour réserver votre billet Thello, c'est juste <a href=\"https://www.thello.com/\">ICI</a> !</p>",
      },

      {
        type: 'title',
        content: 'Billet de train pour enfant chez Trenitalia (Italie)',
      },

      {
        type: 'body',
        content:
          "<p>Chez Trenitalia, la compagnie ferroviaire italienne, les enfants de moins de 4 ans voyagent comme chez toutes les autres compagnies de train : gratuitement et sur les genoux de l'accompagnateur. Vous pouvez toujours faire le choix d'acheter un billet enfant Trenitalia à votre enfant pour qu'il dispose d'un siège à lui.</p><p>Pour les enfants âgés de 4 à 14 ans voyageant à bord d'un train national de Trenitalia, une réduction de 50% est appliquée sur le tarif de base. Le billet enfant coûte donc la moitié d'un billet adulte.</p><p>Pour les enfants âgés de 4 à 12 ans et voyageant à bord d'un train régional Trenitalia, le tarif de leur billet enfant Trenitalia aura <strong>50% de réduction</strong> sur le tarif de base d'un billet adulte.</p><p>Mais ATTENTION : il existe des exception en fonction des régions : <ul><li><p><strong>Abruzzes</strong>: le billet enfant est gratuit pour ceux mesurant moins d'un mètre de hauteur et qui sont accompagnés d'un adulte.</p></li><li><p><strong>Campanie</strong>: le billet enfant est gratuit pour ceux <strong>âgés de moins de 6 ans</strong> et qui sont accompagnés d'un adulte possédant un billet payant.</p></li><li><p><strong>Bolzano</strong>: le billet enfant est gratuit pour ceux <strong>âgés de moins de 6 ans</strong> ainsi que pour les <strong>enfants habitant dans la Province de Bolzano</strong>, qu'ils soient âgés de moins de 6 ans ou de 6 ans révolus, mais <strong>qui ne vont pas encore scolarisés</strong>. Ils doivent voyager avec un adulte.</p></li><li><p><strong>Lombardie</strong>: le billet enfant est gratuit pour ceux âgés de <strong>moins de 4 ans non révolus</strong> et qui voyagent accompagnés d'un adulte. Pour les <strong>enfants de 4 à 14 ans</strong>, une <strong>réduction de 50%</strong> sur le billet au plein tarif est appliquée.</p></li><li><p><strong>Puglia</strong>: le billet enfant est gratuit pour ceux âgés de <strong>moins de 10 ans</strong> et qui sont accompagnés d’un adulte disposant d'un billet. Pour les enfants de plus de 10 ans, il n'y a aucune réduction sur les billets pour enfants qui sont au tarif des billets adulte.</p></li><li><p><strong>Sardaigne</strong>: le billent enfant Trenitalia pour cette région est gratuit pour les enfants de <strong>moins de six ans</strong>, uniquement s'ils sont accompagnés d'un adulte possédant un billet valide. attention, cela n'est valable que pour un enfant par accompagnateur. Si plusieurs enfants voyagent avec un seul accompagnateur, il faudra acheter un titre de transport au plein tarif, pour deux enfants (par ex, un enfant est gratuit, deux enfants - un billet plein tarif, trois enfants - un billet plein tarif, quatre enfants - deux billets plein tarif etc.).</p></li><li><p><strong>Trente</strong>: le billet enfant est gratuit pour ceux qui sont âgés de <strong>moins de 6 ans</strong> accompagnés d'un adulte possédant un titre de transport valide. Cette offre est valable pour un maximum de 5 enfants de 6 ans ou moins, par accompagnateur adulte.</p></li></ul></p><p>Des tarifs spéciaux sont aussi disponibles au cas par cas. Pour les découvrir, rendez-vous <a href=\"https://www.trenitalia.com/content/tcom/fr/html/trenitalia/trenitalia_2014_fr/Info_regionale_FR.html\">ICI</a>.</p>",
      },

      {
        type: 'title',
        content:
          'Billet de train pour enfant chez TGV Lyria (France et Suisse)',
      },

      {
        type: 'body',
        content:
          "<p>Chez Lyria, la compagnie de train pour vos trajets entre la France et la Suisse, vous trouverez plusieurs offres différentes concernant les billets enfant : <ul><li><p>Les enfants de 4 ans ou moins peuvent voyager gratuitement dans les trains Lyria s'ils voyagent sur les genoux de leur accompagnateur. Si vous préférez qu'ils disposent d'un siège pour eux, vous pouvez toujours opter pour lui acheter un billet Baby Pass à partir de 9€.</p></li><li><p>Pour les enfants de 4 ans à 12 ans, il existe un Billet Enfan Lyria.</p></li><li><p>Pour les enfants et jeunes de 12 ans à 26 ans, il existe un billet Jeune TGV Lyria.</p></li><li><p>Enfin, une offre Famille Plus est proposée pour les familles. Celle-ci est applicable uniquement pour des trajets comprenant 1 ou 2 adultes qui accompagnent un enfant de moins de 12 ans (uniquement en 2nde classe).</p></li></ul></p>",
      },

      {
        type: 'title',
        content: 'Billet de train pour enfant chez la SNCB (Belgique)',
      },

      {
        type: 'body',
        content:
          "<p>Saviez-vous que chez la SNCB, la SNCF en version belge, jusqu'à 4 enfants de moins de 12 ans pouvaient voyager gratuitement ? Incroyable non ?! Cela est uniquement possible si ces 4 enfants sont accompagnés d'une personne âgée de 12 ans ou plus et disposant d'un billet de train <em>SNCB</em> valable.</p><p>Autrement, si votre enfant de moins de 12 ans voyage seul ou que vous voyagez avec plus de 4 enfants par accompagnateur, vous pouvez profiter de l'offre Kids Ticket à - 50%.</p><p> C'est plutôt sympa de voyager avec vos enfants et la SNCB ! Pour plus d'informations, rendez-vous <a href=\"https://www.belgiantrain.be/fr/tickets-and-railcards/child-ticket\">ICI</a>.</p>",
      },

      {
        type: 'title',
        content: 'Billet de train pour enfant chez la SBB (Suisse)',
      },

      {
        type: 'body',
        content:
          "<p>Chez la <em>SBB</em>, la compagnie ferroviaire Suisse, vos enfants de <strong>moins de 6 ans</strong> voyagent gratuitement lorsqu'ils sont accompagnés d'une personne âgée de 12 ans ou plus qui dispose d'un billet valable. Cette règle est applicable pour 4 enfants au maximum par accompagnateur de 12 ans. Si l'accompagnateur a 16 ans ou plus, le nombre d'enfants qui peuvent voyager gratuitement passe à 8.</p><p> Les enfants âgés de 6 ans à 16 ans, profitent d'une réduction de 50% sur leurs billets de train SBB.</p><p>Mais il existe d'offres offres de billets enfants SBB, les voici :<ul><li><p>La <strong>Carte Journalière Enfant SBB</strong> : elle s'adresse aux enfants âgés de 6 à 16 ans accompagnés d'un adulte disposant d'un billet valable. Cette carte permet à ces enfants de voyager toute la journée à bord des trains de la SBB en 2e classe au prix de  <strong>CHF 16</strong>. La carte peut aussi permettre de voyager en 1ère classe au prix de <strong>CHF 32</strong>.</p></li><li><p>La <strong>Carte Junior SBB</strong> : elle permet à votre enfant âgé de 6 ans à 16 ans, de voyager en transports publics durant une année au prix de <strong>CHF 30. par an</strong>. Cela n'est valable que s'il voyage avec l'un de ses parents, titulaire d'un billet valide.</p></li><li><p>La <strong>Carte Enfant Accompagné</strong> : elle coûte <strong>CHF 30 par an</strong>. Elle permettra, une fois en la possession de votre enfant, de voyager à travers la Suisse entière pendant une année complète. Cela est uniquement valable s'il voyage avec une personne adulte, titulaire d'un titre de transport valide. Cet accompagnateur doit être spécifié sur la carte enfant accompagné.</p></li></ul></p><p>Il existe encore quelques conseils de la SBB pour permettre aux enfants de voyager simplement en Suisse, au cas par cas. Découvrez les juste <a href=\"https://www.sbb.ch/fr/horaire/conseils-voyageurs/enfants.html\">ICI</a>.</p>",
      },

      {
        type: 'title',
        content: 'Billet de train pour enfant chez la Renfe (Espagne)',
      },

      {
        type: 'body',
        content:
          "<p>Chez la Renfe, compagnie ferroviaire espagnole, la politique de voyage des enfants est claire et concise : <ul><li><p>les enfants de <strong>moins de 4 ans</strong> voyagent gratuitement mais sans place distincte.</p></li><li><p>Les enfants de moins de 14 ans profitent d'une offre de <strong>billet de train 40% moins chère</strong> que pour les billets adultes.</p></li></ul></p>",
      },

      {
        type: 'title',
        content:
          'Billet de train pour enfant chez Eurostar (Royaume-Uni, France, Belgique)',
      },

      {
        type: 'body',
        content:
          "<p>Chez Eurostar, votre enfant pourra voyager gratuitement sur vos genoux s'il est âgé de moins de 4 ans.</p><p>Si vous souhaitez que votre enfant dispose d'un siège à lui ou qu'il est âgé de plus de 4 ans, il faudra impérativement que vous lui réserviez un billet enfant Eurostar. Si vous voyagez avec deux enfants ou plus, il faudra acheter un billet enfant pour tout enfant supplémentaire (un seul pouvant voyager gratuitement par accompagnateur).</p><p>Il existe chez Eurostar, des billets et tarifs préférentiels pour les enfants de 4 à 11 ans en Classe Standard. Resneignez-vous directement auprès d'Eurostar pour les connaitre.</p><p>Si votre enfant est âgé de 8 à 15 ans, il pourra profiter de l'offre Junior Traveller d'Eurostar. Il s'agit d'un <strong>billet de 150€</strong> qui prend en charge l'accompagnement de votre enfant. Pour plus de détails rendez-vous <a href=\"https://www.eurostar.com/fr-fr/junior-traveller\">ICI</a>.</p>",
      },

      {
        type: 'title',
        content:
          'Billet de train pour enfant chez la Deutsche Bahn (Allemagne)',
      },

      {
        type: 'body',
        content:
          "<p>Chez la Deutsche Bahn, compagnie allemande de train, vos enfants de moins de 6 ans n'ont pas besoin de billet ni de place réservée, ils voyagent gratuitement.</p><p>Lorsque votre enfant âgé de 14 ans au maximum est accompagné d'un parent ou d'un grand-parent, il voyage gratuitement pourvu que son nom ai été indiqué sur la réservation. Son nom doit figurer sur le titre de transport valide de l'adulte.</p><p>vous l'aurez compris, les enfants âgés de 15 ans et plus voyagent comme des adultes. Profitez donc de leur jeunesse pour voyager avec les offres enfants <a href=\"https://www.bahn.de/fr/view/index.shtml\">Deutsche Bahn</a> !</p><p>Enfin, notez-vous bien que chaque passager, enfant ou non, doit pouvoir justifier de son identité lors de trajet en train. Pensez-donc à être en possession des documents nécessaires. Également, les mineurs seront parfois contraints d'être en possession de documents spéciaux pour leurs voyages, renseignez-vous.</p>",
      },
    ],
    relatedQuestions: ['comment-reserver-billet-enfant', 'bons-plans-sncf'],
  },
  {
    name: 'echanger-mes-billets',
    title: 'Je souhaite échanger mon billet ?',
    meta: {
      title:
        'Echange de billet sur Tictactrip pour chacune de nos compagnies partenaires',
      description:
        "Votre voyage est déjà réservé mais vous ne pouvez plus vous déplacer ? Trouvez toutes les conditions d'échange de billets selon les compagnies partenaires de Tictactrip",
    },
    category: ['service-apres-vente'],
    updatedDate: '24/01/2022',
    content: [
      {
        type: 'body',
        content:
          '<p>Vous avez fraîchement acheté vos billets chez <em>Tictactrip</em> mais catastrophe vous ne pouvez plus voyager à la date initialement choisie.<br>Un changement de dernière minute, une erreur sur votre billet ou simplement une volonté de ne plus se déplacer sont autant de raisons de <strong>vouloir échanger son billet.</strong></p><p>Pas d’inquiétude ! Nous allons voir dans cette rubrique quelles possibilités s’offrent à vous afin de pouvoir échanger vos billets en toute tranquillité.</p>',
      },
      {
        type: 'img',
        content: 'service-apres-vente_billet-compagnies-echange-tictactrip.jpg',
        alt: 'billet compagnies échange tictactrip',
        imgSizePercent: 90,
      },

      {
        type: 'title',
        content: 'Les compagnies où il est possible d’échanger vos billets',
      },

      {
        type: 'body',
        content:
          '<p>Pour un grand nombre de compagnies il sera d’une grande facilité de procéder à un échange. Mais attention il peut tout de même y avoir <strong>certaines conditions.</strong></p><p>À noter que dans tous les cas il est <strong>impossible de procéder à l’échange de billet sur le site de <em>Tictactrip.</em></strong> Il faudra se rendre directement sur le site de la compagnie partenaire ou contacter notre service après-vente. Pour nous contacter, nous vous invitons à consulter notre FAQ consacrée : <a href="https://www.tictactrip.eu/faq/comment-contacter-tictactrip">https://www.tictactrip.eu/faq/comment-contacter-tictactrip</a>.</p>',
      },

      {
        type: 'subtitle',
        content: 'L’échange de billet SNCF',
      },

      {
        type: 'body',
        content:
          "<p>Nous commercialisons différents billets <em>SNCF</em>:<ul><li><p>Billets TGV Inoui,</p></li><li><p>Billets Intercités</p></li><li><p>Billets TER</p></li><li><p>Billets Navette Keolis</p></li></ul></p><p>Selon le type de billet, l'échange peut être possible sous conditions. Il est alors plus facile pour vous de<strong> contacter notre super équipe service client </strong>qui se fera une joie de vous communiquer les conditions au cas par cas.<br>Si celles-ci vous conviennent vous pourrez alors demander un échange pour la date souhaitée.</p><p>Enfin, si le tarif du nouveau billet est plus élevé il vous faudra régler la différence.</p>",
      },

      {
        type: 'subtitle',
        content: 'L’échange de billet Eurostar',
      },

      {
        type: 'body',
        content:
          '<p>Votre envie d’évasion Outre-Manche tombe à l’eau et vous voilà dans l’obligation de reporter votre voyage.<br>Chez <em>Eurostar</em>, les billets échangeables sont :<ul><li><p>Le billet Standard avec des frais d’échange de 40 €.</p></li><li><p>Le billet Standard Premier avec des frais d’échange de 50 €.</p></li><li><p>Le billet Business Premier échangeable jusque’à 60 jours après le départ.</p></li></ul></p><p>Veuillez <strong>nous contacter</strong> pour toute demande d’échange.</p>',
      },

      {
        type: 'subtitle',
        content: 'L’échange de billet Thalys',
      },
      {
        type: 'body',
        content:
          '<p>Tout comme pour l’<em>Eurostar</em>, les billets <em>Thalys</em> sont échangeables selon la classe tarifaire du billet :<ul><li><p>Billet Confort avec 15 € de frais.</p></li><li><p>Billet Premium sans frais.</p></li></ul></p><p>Veuillez <strong>nous contacter</strong> pour toute demande d’échange.</p>',
      },

      {
        type: 'subtitle',
        content: 'L’échange de billet Lyria',
      },

      {
        type: 'body',
        content:
          '<p>L’échange de billet <em>Lyria</em> se fait en fonction de la flexibilité du billet :<ul><li><p>Billet standard et standard Première <strong>flexible uniquement</strong> avec 30 € de frais.</p></li><li><p>Billet Business Première échange sans frais.</p></li></ul></p><p>Veuillez <strong>nous contacter</strong> pour toute demande d’échange.</p>',
      },

      {
        type: 'subtitle',
        content: 'L’échange de billet Deutsche Bahn',
      },

      {
        type: 'body',
        content:
          '<p>C’est très simple, pour un billet <em>Deutsche Bahn</em>, rendez vous sur <a href="https://fahrkarten.bahn.de/privatkunde/start/start.post?&lang=fr&scope=bahnbrs">ce lien</a>. Il vous suffira de vous munir de votre <strong>numéro de commande </strong>figurant sur votre billet afin d’échanger votre billet.</p>',
      },

      {
        type: 'subtitle',
        content: 'L’échange de billet Bus Blablacar',
      },

      {
        type: 'body',
        content:
          '<p>Chez <em>Bus Blablacar</em> comme pour l’annulation de billet, il faut contacter le <strong>service client</strong> en précisant la nouvelle date et l’heure souhaitée pour votre nouveau voyage.</p><p>Les frais de modification sont de 5€. À cela, il faudra ajouter la différence du prix du nouveau billet.</p>',
      },
      {
        type: 'subtitle',
        content: 'L’échange de billet Altibus',
      },

      {
        type: 'body',
        content:
          "<p>Vous êtes contraint d’échanger votre date de séjour sur les pistes ? L’échange de votre billet Altibus est possible. Pour ce faire, prenez contact avec nous afin que nous puissions échanger votre billet dans la mesure du possible. <br>Les frais de d’échange de billet sont de 5€.</p><p> Il est uniquement possible de modifier <strong>l'heure et la date</strong> d'un billet jusqu'à <strong>48 heures</strong> de la date de départ.<strong> Un billet modifié ne pourra être remboursé par la suite.</strong></p>",
      },

      {
        type: 'subtitle',
        content: 'L’échange de billet Flixbus',
      },

      {
        type: 'body',
        content:
          '<p>L’échange de billet <em>Flixbus</em> est récent, pour le bonheur du plus grand nombre. La procédure est simple. Il suffit de contacter le service client par téléphone ou à travers le formulaire de contact.<br>Ainsi, si vous avez commis une erreur sur la date ou la destination, nous pourrons rapidement la corriger.</p><p>Les frais de modification de billet sont également de 5€.</p>',
      },

      {
        type: 'title',
        content: "Les compagnies où il n'est possible d’échanger vos billets.",
      },

      {
        type: 'body',
        content: `<p>Malheureusement, pour quelques compagnies il n’est pas possible d’échanger vos billets. C’est notamment le cas de <em>Alsa</em>, la compagnie de bus espagnole ou encore <em>Izy</em> la compagnie low cost à destination de Bruxelles.</p><p>Vous savez désormais comment échanger votre billet. En cas de doute nous serons toujours là pour vous aider via notre <a href="${NAVIGATION.SUPPORT}">formulaire de contact</a>. Alors n’hésitez pas !</p>`,
      },
    ],
    relatedQuestions: [
      'politique-annulation-remboursement-billet',
      'compagnies-transport-annulation-remboursement-coronavirus',
    ],
  },
  {
    name: 'train-retard-remboursement',
    title: 'Mon train etait en retard, comment me faire rembourser ?',
    meta: {
      title: 'Remboursement de mon billet en cas de retard de mon train',
      description:
        'Votre train a du retard et vous souhaitez vous faire rembourser ? Découvrez les politiques de remboursement des compagnies de train partenaires de Tictactrip',
    },
    category: ['service-apres-vente'],
    updatedDate: '02/11/2020',
    content: [
      {
        type: 'body',
        content:
          '<p>Et oui ! En tant qu’usager, nous pouvons rencontrer plein de soucis avec notre train. Si ce n’est pas une suppression, c’est un <strong>retard</strong>. Cela est bien fâcheux lorsque notre voyage est millimétré à la seconde près, que l’on a un rendez-vous professionnel ou encore pire : une correspondance réservée chez Tictactrip grâce à nos incroyables trajets combinés.</p><p>Pas de panique encore une fois le <strong>service client</strong> est là pour vous aider à obtenir un <strong>remboursement</strong>.</p><p>À savoir que nous sommes soumis aux <strong>politiques de remboursement des compagnies de train</strong> partenaires. Vous ne pouvez donc pas prétendre à un remboursement s’il n’est pas répertorié dans les conditions des transporteurs ci-dessous.</p>',
      },

      {
        type: 'img',
        content:
          'service-apres-vente_horloge_montre_train_retard_remboursement_passager.jpg',
        alt: 'horloge montre train retard remboursement passager',
      },

      {
        type: 'title',
        content: 'Retard de mon train SNCF',
      },

      {
        type: 'body',
        content:
          '<p>Un retard SNCF ? Un classique nous direz vous… Mais en matière de remboursement vous pourrez plus ou moins obtenir des remboursements avantageux selon le type de train.</p>',
      },
      {
        type: 'subtitle',
        content: 'Retard de mon TGV INOUI, TGV Lyria et Intercité',
      },

      {
        type: 'body',
        content:
          '<p>Pour le retard de ces transports, la <em>SNCF</em> vous propose la <strong>Garantie G30</strong>. Celle-ci vous permet de bénéficier d’un remboursement sous forme de bon d’achat digital <strong>dès 30 minutes</strong> de retard et d’un virement bancaire à partir d’une heure.<br> Vous disposez de <strong>60 jours</strong> pour effectuer votre demande à compter de la date de départ. En voilà une bonne nouvelle !</p><p>Les conditions sont les suivantes :<ul><li><p>entre <strong>30 min et 2h</strong> de retard : <strong>25%</strong> du prix du billet,</p></li><li><p><strong>entre 2h et 3h</strong> de retard : <strong>50%</strong> du prix du billet</p></li><li><p><strong>au-delà de 3h</strong> de retard : <strong>70%</strong> du prix du billet</p><p></ul></p><p>La demande doit s’effectuer en ligne en remplissant <a href="https://garantie30minutes.sncf.com/?lang=fr&canal=SNCF">ce formulaire</a>, muni de votre référence de dossier voyage composée de 6 lettres et de votre nom de famille.</p><p>Attention, pour les <strong>Intercités 100%</strong>, la garantie G30 est applicable dès <strong>1 heure de retard</strong>.</p>',
      },

      {
        type: 'subtitle',
        content: 'Retard de mon TER ',
      },

      {
        type: 'body',
        content:
          '<p>Contactez notre service client qui s’occupera des démarches pour vous. Il faudra par contre s’armer de patience. En effet, le délais de traitement des demandes est très long. Bien entendu, nous vous tiendrons informés de l’avancée de votre dossier.</p>',
      },

      {
        type: 'title',
        content: 'Retard de mon train Eurostar',
      },
      {
        type: 'body',
        content:
          '<p>Pour les trains <em>Eurostar</em>, vous avez le droit à un bon d’achat appelé <q>e-voucher</q> à utiliser pour un prochain voyage.<br> Son montant varie selon l’importance du retard. <strong>A partir de 60 minutes</strong> de retard, l’indemnisation est à hauteur de <strong>25 %</strong> du prix du billet. Entre <strong>2h et 3h</strong>, cela passe à <strong>50 %</strong> du prix du billet, puis à <strong>75 %</strong> si le retard est <strong>supérieur à 3h</strong>.<br> Vous pouvez réclamer votre compensation en vous rendant sur <a href="https://compensation.eurostar.com/?lang=fr#/">cette page</a></p>',
      },

      {
        type: 'title',
        content: 'Retard de mon train Thalys',
      },

      {
        type: 'body',
        content:
          '<p>Chez <em>Thalys</em>, c’est le même principe de e-voucher qui est mit en place en cas de retard. Ainsi vous bénéficierez d’un remboursement de :<ul><li><p><strong>20 %</strong> du prix du billet en cas de retard <strong>égal ou supérieur à 30 min</strong>,</p></li><li><p><strong>50 %</strong> du prix du billet <strong>à partir de 60 minutes de retard</strong>,</p></li><li><p><strong>100 %</strong> du prix du billet <strong>dès 120 minutes de retard</strong></p></li></ul></p><p>Vous devez remplir un <a href="https://thalys.secure.force.com/?language=fr&country=fr&form=complaint">formulaire de compensation </a>dans un délai maximal de 2 mois suivant la date de votre voyage.<br>Enfin, il est tout à fait possible de recevoir le remboursement par virement. Mais  <strong>vous ne pouvez obtenir plus de 50% du prix du billet</strong>.</p>',
      },

      {
        type: 'title',
        content: 'Retard de mon train Deutsche Bahn',
      },

      {
        type: 'body',
        content:
          '<p>La procédure de remboursement de train Deutsche Bahn est un peu plus compliqué… Juste un peu, ne vous inquiétez pas !<br>Il n’existe pas de formulaire en ligne pour demander un remboursement dû à un retard. Il faudra donc remplir un questionnaire <a href="https://www.bahn.de/wmedia/view/mdb/media/intern/fahrgastrechteformular-englisch.pdf">à télecharger</a> ou à demander directement en gare puis l’envoyer par la Poste.<br>Pour plus d’information n’hésitez pas à suivre <a href="https://www.bahn.de/fr/view/informations-reservation/droits-des-voyageurs/formulaire-relatif-aux-droits-des-voyageurs.shtml">ce lien</a></p><p>On espère vous avoir aidé au mieux ! Ce que vous devez retenir, c’est que pour la plupart des compagnies ce sont des formulaires à remplir. Autrement, contactez l’équipe service client qui reste à votre disposition pour toute demande d’assistance. A très vite !</p>',
      },
    ],
    relatedQuestions: [
      'politique-annulation-remboursement-billet',
      'compagnies-transport-annulation-remboursement-coronavirus',
    ],
  },
  {
    name: 'bon-de-caisse',
    title: "J'ai un bon de caisse",
    meta: {
      title: 'Bon de caisse à échanger contre un remboursement',
      description:
        'Un bon de caisse vous a été remis au guichet SNCF ? Découvrez comment obtenir le remboursement de celui-ci.',
    },
    category: ['service-apres-vente'],
    updatedDate: '05/01/2021',
    content: [
      {
        type: 'body',
        content:
          '<p>Après vous être rendu à un guichet ou à une borne <em>SNCF</em> pour annuler votre billet de train acheté sur notre site <em>Tictactrip</em>, on vous a remis un <strong>bon de caisse</strong>. Vous vous attendiez à un <strong>remboursement</strong> mais vous voilà avec un «morceau de papier» qui ne ressemble en rien à un virement bancaire.<br>Encore une fois nous sommes là pour vous aider ! Laissez-vous guider étape par étape afin de savoir comment récupérer votre dû.</p>',
      },

      {
        type: 'title',
        content: 'Mais qu’est-ce qu’un bon de caisse ?',
      },

      {
        type: 'body',
        content:
          "<p>Un <strong>bon de caisse</strong> est un document ayant le même format qu'un billet de train. Il a une <strong>valeur monétaire</strong> car c’est ce qui prouve que votre billet a bien été annulé et donc que vous recevrez un remboursement. Ce bon de caisse ne peut vous être remis que par la <em>SNCF</em>.</p><p>Attention, une fois votre bon de caisse en main <strong>la procédure est assez longue</strong> pour obtenir votre <strong>remboursement</strong>. Mais pas d’inquiétude nous vous tiendrons informé de l’avancée de votre dossier.</p>",
      },

      {
        type: 'img',
        content: 'service-apres-vente_bon-caisse-echange-tictactrip.jpg',
        alt: 'billet compagnies échange tictactrip',
      },

      {
        type: 'title',
        content: 'Que faire de mon bon de caisse ?',
      },

      {
        type: 'body',
        content:
          "<p>Tout d’abord, prenez en bien soin et ne le perdez pas ! Il nous faut absolument<strong> l’original</strong> pour pouvoir vous rembourser. Une photocopie ou un scan ne sera malheureusement pas accepté. Nous sommes soumis aux directives de la SNCF.</p><p>Veuillez nous <strong>l'envoyer</strong> par La Poste à l’adresse suivante :</p><p>Tictactrip<br>22 rue popincourt, 75011 Paris</p><p>Nous vous suggérons de l’envoyer en <strong> courrier recommandé</strong> afin d’avoir une garantie supplémentaire qu’il arrive à destination. Bien sûr, nous ne vous forçons pas mais nous avons tous connu cette histoire de courriers égarés. Et n’oubliez pas que votre bon de caisse est précieux…</p><p>Une fois que nous accusons réception de celui-ci, nous devons l’envoyer à la SNCF afin que celle-ci nous rembourse. A ce moment-là nous pourrons enfin vous rembourser.</p><p>Mais pourquoi ne pas l’envoyer directement à la SNCF nous demanderez-vous ? Nous devons remplir certains documents à joindre au bon de caisse tout simplement.</p><p>Vous connaissez maintenant la <strong>procédure</strong> à suivre pour obtenir un <strong>remboursement</strong> à partir d’un <strong>bon de caisse</strong>. Il est vrai que c’est un peu long, donc nous vous conseillons de directement passer par notre <strong>service client</strong> pour une demande d’annulation afin d’obtenir un remboursement plus rapidement.<br>Enfin, vous avez un <strong>an</strong> pour nous faire parvenir votre bon de caisse. Passé cette date vous ne pourrez plus obtenir de remboursement.</p>",
      },
    ],
    relatedQuestions: ['politique-annulation-remboursement-billets'],
  },
  {
    name: 'billet-ouigo-non-recu',
    title: "Je n'ai pas reçu mon billet Ouigo, que faire ?",
    meta: {
      title: 'Billet Ouigo non reçu, pourquoi ? [À jour]',
      description:
        "Vous avez récemment acheté un billet Ouigo chez Ouigo ou Tictactrip. ?Découvrez pourquoi vous n'avez pas reçu votre billet !",
    },
    category: ['recherche-reservation-billets'],
    updatedDate: '19/11/2020',
    content: [
      {
        type: 'img',
        content: 'recherche-reservation-billets_billet-ouigo-non-recu.jpg',
        alt: 'billet ouigo non recu',
      },

      {
        type: 'body',
        content:
          "<p>Vous avez réservé un train TGV SNCF low cost, autrement dit, un train Ouigo ? Vous avez bien fait ! C'est l'un des moyens de déplacement grandes distances en France les moins chers. En plus, le service à bord des trains Ouigo est impeccable.</p>Mais ce n'est pas tant le trajet en Ouigo qui vous amène, mais bien vos billets Ouigo que vous n'avez pas reçu. Il existe deux raisons pour lesquels vous pouvez ne pas avoir reçu votre billet Ouigo, découvrez les et obtenez toutes les informations concernant vos billets de train Ouigo !</p>",
      },

      {
        type: 'title',
        content: "Vous n'avez pas réservé votre billet Ouigo sur Tictactrip",
      },

      {
        type: 'body',
        content:
          "<p>La première raison est toute simple. En fait, Ouigo est une marque à part entière de la SNCF. Elle ne fait pas partie, à proprement parler, des trains SNCF classiques.</p>C'est pour cette raison qu'aujourd'hui, il vous sera impossible de réserver un billet de train Ouigo sur une autre plateforme que Ouigo. Et c'est aussi le cas pour Tictactrip.</p><p>Ainsi, lorsque nous vous proposons un trajet combiné incluant un TGV Ouigo, vous pourrez aisément réserver les autres transports sur Tictactrip, mais pour le billet Ouigo, vous serez redirigé vers le site Ouigo.</p><p>Pensez bien à acheter votre billet Ouigo s'il est présent dans votre trajet ! Vous trouverez un exemple ci-dessous.</p>",
      },

      {
        type: 'img',
        content:
          'recherche-reservation-billets_paiement-billet-ouigo-non-recu.jpg',
        alt: 'paiement billet ouigo non recu',
      },

      {
        type: 'title',
        content: "Date d'envoi des billets Ouigo",
      },

      {
        type: 'body',
        content:
          "<p>La compagnie de <strong>train Ouigo</strong> dispose de sa propre politique d'envoi des billets de train puisqu'elle est quasiment exclusivement la seule à pouvoir vendre ses billets de train Ouigo.</p><p>Ainsi, la compagnie Ouigo vous <strong>envoie vos billets OUIGO 4 jours avant le départ</strong> de votre train low cost. Si votre départ est prévu dans plus de 4 jours, il est tout à fait normal que vous n’ayez pas reçu vos billets pour le moment.</p>Si, 4 jours et moins, avant votre départ, vous n'avez toujours pas reçu vos billets Ouigo, peut-être qu'une erreur est survenue dans l'envoi, ou dans l'adresse e-mail enregistrée... Mais pas de panique ! Il vous suffit de vous connecter sur le site de Ouigo à l'aide de votre référence de voyage et l’adresse e-mail de votre réservation. Pour ce faire, <a href=\"https://ventes.ouigo.com/fr-FR/booking/login\">rendez-vous ICI</a>.</p>",
      },
    ],
    relatedQuestions: [
      'paiement-billet-partenaire',
      'problemes-de-paiement-debite',
    ],
  },
  {
    name: 'train-rate-que-faire',
    title: 'Train raté, que faire ? Découvrez toutes vos solutions !',
    meta: {
      title: "J'ai raté mon train, que faire dans ce cas ?",
      description:
        "Vous avez raté votre train pour l'une des raisons que nous évoquons ici ? Découvrez la solution facile !",
    },
    category: ['service-apres-vente'],
    updatedDate: '17/11/2020',
    content: [
      {
        type: 'body',
        content:
          "<p>Vous avez récemment raté votre train et vous ne savez quoi faire dans cette situation ? Pas de panique, chez Tictactrip nous avons tout prévu pour vous aider au mieux dans votre service après vente. Voici les possibilités qui s'offrent à vous en fonction des raisons qui vous ont fait manquer votre train.</p>",
      },

      {
        type: 'img',
        content: 'service-apres-vente_jeune-femme-qui-court-apres-un-train.jpg',
        alt: 'jeune femme qui court apres un train',
      },

      {
        type: 'title',
        content: "Train raté à cause d'un retard de train",
      },

      {
        type: 'body',
        content:
          "<p>Parfois, il arrive qu'un train prenne un peu de retard, suite à une avarie technique, un problème sur les voies, une coupure de courant ou quelques autres raisons qui vont avoir des répercussions sur votre trajet en train. Mais pas de panique, dans la plupart des cas, cette mauvaise surprise finira bien pour vous ! Attention cependant, il faut bien différencier deux cas de figure.</p>",
      },

      {
        type: 'subtitle',
        content: 'Correspondance de deux trains du même transporteur',
      },

      {
        type: 'body',
        content:
          "<p>En France, si vous voyagez avec la SNCF et que votre premier train est en retard sur l'horaire prévu, pas de panique ! La compagnie sera au courant de l'existence de votre correspondance et viendra vous voir à bord de votre train. Comme votre achat de billet s'apparente à un contrat avec le transporteur, celui-ci s'engage à assurer votre correspondance de trains. Renseignez-vous auprès d'un contrôleur à bord si personne ne vient vers vous, il devra vous trouver une solution et un nouveau train pour rejoindre votre destination.</p>",
      },

      {
        type: 'subtitle',
        content:
          'Correspondance de deux transports ou transporteurs différents',
      },

      {
        type: 'img',
        content:
          'service-apres-vente_exemple-trajet-combine-deux-transporteurs.jpg',
        alt: 'exemple trajet combine deux transporteurs',
      },

      {
        type: 'body',
        content:
          "<p>Cependant, si votre voyage combine deux transporteurs différents et/ou deux types de transports différents, le problème se complexifie quelque peu. Mais pas de stress encore une fois, il nous reste des cartes en mains !</p><p>Notez bien que dans ce cas de figure de combinaison de deux transports différents, <strong>la correspondance n'est pas garantie</strong> ! En fait la raison est issue du fait que vous signez dès lors deux contrats avec des transporteurs différents, il n'y a donc pas d'obligation pour l'un vis-à-vis de l'autre. Ainsi, si votre train Paris Méribel en TGV vous fait manquer votre navette de bus Altibus, vous n’aurez droit à aucun dédommagement nu remboursement ni aucune solution de secours de la SNCF.</p><p>Cependant, il existe une alternative, en fonction des transports combinés pour votre voyage !</p>",
      },

      {
        type: 'subtitle',
        content: 'Le service HOTNAT de Railteam ',
      },

      {
        type: 'body',
        content:
          "<p>Cette solution, c'est le service Hotnat de Railteam ! Railteam est une alliance ferroviaire en européenne entre les différents grands transporteurs. Elle regroupe notamment : <ul><li><p>Les TGV ICE de la DeustcheBahn,</p></li><li><p>les TGV SNCF,</p></li><li><p>les TGV Eurostar,</p></li><li><p>les TGV Railjet ÖBB,</p></li><li><p>les TGV Thalys</p></li><li><p>et les TGV Lyria.</p></li></ul></p>Pour obtenir dès lors le service Hop On The Next Available Train (Hotnat), traduit en français : Montez dans le prochain train, votre voyage doit remplir les conditions suivantes :<ol><li><p>Il doit s'agir OBLIGATOIREMENT de transports combinés parmi ceux cités ci-dessus.</p></li><li><p>Le premier train est arrivé avec du retard. Le service HOTNAT ne s'applique pas pour des trains supprimés.</p></li><li><p>Votre correspondance est au départ de l'une des gares suivantes : <ul><li><p>Paris Gare de l’Est.</p></li><li><p>Paris Gare du Nord.</p></li><li><p>Paris Montparnasse.</p></li><li><p>Paris Gare de Lyon.</p></li><li><p>Lyon Part Dieu.</p></li><li><p>Lille Europe Station.</p></li><li><p>Gare de Strasbourg.</p></li><li><p>Brussels Midi-Zuid.</p></li><li><p>Gare d'Offenburg.</p></li><li><p>Gare de Stuttgart.</p></li><li><p>Cologne Main Station.</p></li><li><p>Frankfurt Main Station.</p></li></ul></ol></p><p>Ce service HOTNAT est disponible uniquement en gare et vous permettra d’emprunter le prochain train sans frais et au départ de la même gare. Il y a exception faite pour Paris, où votre train pourra partir de toutes les gares. Les places assises ne sont cependant pas garanties.</p>",
      },

      {
        type: 'title',
        content: 'Train raté par votre propre retard',
      },

      {
        type: 'img',
        content:
          'service-apres-vente_courir-apres-le-train-train-retard-train-rate.jpg',
        alt: 'courir apres le train train retard train rate',
      },

      {
        type: 'body',
        content:
          "<p>Malheureusement, vous avez couru après votre train comme cette femme ? Nous sommes réellement désolés pour vous... Surtout que dans ce cas de figure où la responsabilité de ce train raté vous incombe, nous ne pouvons rien faire du tout pour vous...</p><p>Dans ce cas, votre billet de transport est perdu et vous ne pourrez pas voyager ni demander de quelconque remboursement car le transporteur n'y est pour rien.</p>",
      },
    ],
    relatedQuestions: [
      'train-retard-remboursement',
      'politique-annulation-remboursement-billet',
    ],
  },
  {
    name: 'billet-bus-enfant',
    title: 'Enfants : quel billet de bus acheter ?',
    meta: {
      title: 'Quel billet enfant acheter pour un voyage en bus ?',
      description:
        'Pour votre prochain voyage en bus vous ne savez quel billet enfant acheter ? Pas de stress, voici les politiques de voyage enfant des compagnies !',
    },
    category: ['conditions-de-voyage-tarifs-compagnies'],
    updatedDate: '14/11/2020',
    content: [
      {
        type: 'body',
        content:
          '<p>Vous avez un doute concernant le billet de bus à acheter pour votre enfant dans le cadre de votre prochain voyage familial en bus ? Pas de panique, nous sommes aller recueillir toutes les informations qui pourront vous être utiles concernant les politiques de voyages des enfants en bus, des transporteurs. Découvrez-les sans plus attendre !  </p>',
      },
      {
        type: 'img',
        content:
          'conditions-de-voyage-tarifs-compagnies_billet-enfant-bus-enfant.jpg',
        alt: 'billet enfant bus enfant',
      },
      {
        type: 'title',
        content: 'Les billets enfant Flixbus',
      },
      {
        type: 'body',
        content:
          "<p>Chez Flixbus, la compagnie de bus allemande, la politique de voyage des enfants est très simple ! En effet, les <strong>enfants de moins de 3 ans</strong> peuvent voyager gratuitement sur les genoux de leurs parents. Si vous souhaitez que votre enfant de moins de 3 ans occupe un siège qui lui soit destiné, il devra s'acquitter d'un billet de bus pour le trajet. Il en va de même pour les enfants de plus de 3ans. Les <strong>tarifs de bus Flixbus</strong> sont les mêmes pour toutes personnes, sans distinction d'âge.</p>",
      },
      {
        type: 'title',
        content: 'Les billets enfant Blablabus',
      },
      {
        type: 'body',
        content:
          "<p>Chez la compagnie de bus de Blablacar, Blablabus, les conditions de voyage des enfants et les tarifs des billets enfant sont un peu plus strictes que chez Flixbus. En effet, <ul><li><p>Pour les enfants de moins de deux ans, vous devrez apporter un <strong>siège enfant</strong> à bord du bus, c'est obligatoire ! Vous l'aurez compris, votre enfant, même âgé de moins de deux ans, devra posséder un billet de bus attitré. Eh oui, la sécurité avant tout ! Le tarif de ce billet bébé sera de <strong>50% du tarif normal</strong>.</p></li><li><p>Pour les enfants de plus de deux ans, et de 12 ans au maximum, il est recommandé de prévoir un rehausseur enfant pour le voyage en bus, mais cette fois-ci, ce n'est pas obligatoire. Enfin, les billets enfant Blablabus sont au tarif enfant réduit de 25%. C'est à dire que le prix du billet enfant BlaBlaBus revient à 75% du billet normal.</p></li></ul><p>Enfin, les enfants mineurs peuvent voyager en France à condition d'être en possession d'un document attestant de leur identité. Pour les voyages internationaux, ils doivent en plus, être munis d'un document nécessaire au passage des frontières.</p>",
      },
      {
        type: 'title',
        content: 'Les billets enfant Altibus',
      },
      {
        type: 'body',
        content:
          "<p>Chez cette compagnie de bus et de navettes d'altitude, la politique de voyage des enfants Altibus est assez simple: <ul><li><p>Tous les enfants doivent disposer d'un billet nominatif pour voyager à bord des navettes Altibus, quelque soit l'âge de l'enfant voyageur</p></li><li><p>En fonction de l’âge de votre enfant et du trajet que vous souhaitez effectuer, votre enfant paiera soit <strong>le tarif jeune Altibus</strong>, soit le <strong>tarif enfant Altibus</strong> ou voyagera gratuitement.</p></li><li><p>La compagnie Altibus ne dispose pas de rehausseurs enfants ni de siège enfant pour le voyage de votre enfant. Cependant, il vous est toujours possible de ramener votre propre siège enfant. Malheureusement, les ceintures des transports Altibus sont très souvent centrales et ne permettent pas d'y installer un siège enfant.</p></li><li><p>Les politiques tarifaires pour les trajets en navette Altibus dépendent du trajet effectué. Renseignez-vous directement lors de votre recherche de trajet.</p></li><li><p>Enfin, les enfants peuvent voyager seul sous leur propre responsabilité et la responsabilité de leurs parents et /ou tuteurs. Pour les trajets passant par Genève, une autorisation parentale est obligatoire et sera contrôlée par la douane.</p></li></ul></p>",
      },
    ],
    relatedQuestions: ['billet-train-enfant', 'comment-reserver-billet-enfant'],
  },
  {
    name: 'remboursement-sncf-gare',
    title: 'Demande de remboursement SNCF en gare, comment faire ?',
    meta: {
      title:
        'Remboursement SNCF au guichet en gare, comment se faire rembourser par la SNCF ?',
      description:
        'Découvrez ici comment vous faire rembourser au guichet SNCF et en gare SNCF. Mais aussi les billets non remboursables en gare.',
    },
    category: ['service-apres-vente'],
    updatedDate: '12/11/2020',
    content: [
      {
        type: 'body',
        content:
          "<p>Nous le savons mieux que quiconque, se faire rembourser son billet de train et obtenir un remboursement SNCF en gare peut-être très difficile et et très long... Nous en avons pleinement conscience et c'est pourquoi nous avons envie de vous aider au mieux en vous donnant toutes les informations nécessaires au bon déroulement de votre demande d'annulation et/ou de remboursement en gare SNCF. Ainsi, vous aurez toutes les cartes en main pour éviter les erreurs de remboursement courantes et surtout, vous saurez dès à présent où vous faire rembourser ! Place aux infos. (L'image ci-dessous provient du site Oui.SNCF). </p>",
      },

      {
        type: 'img',
        content:
          'service-apres-vente_guichet-sncf-gare-scnf-remboursement-sncf.jpg',
        alt: 'guichet sncf gare scnf remboursement sncf',
      },

      {
        type: 'title',
        content: 'Les billets SNCF remboursables en gare',
      },

      {
        type: 'body',
        content:
          '<p>Chez la SNCF, certains billets sont directement remboursables en gare, en vous adressant au guichet SNCF. Voici les billets qui peuvent être remboursés directement par un agent SNCF se trouvant au guichet SNCF.</p>',
      },

      {
        type: 'subtitle',
        content: 'Les bons de caisse SNCF',
      },

      {
        type: 'body',
        content:
          "<p>Attention, il existe deux types de <strong>bons de caisse SNCF</Strong>, vérifiez bien celui dont vous disposez parmi ceux-ci : <ul><li><p>Le Bon de Caisse Gare. Il  est uniquement remboursable aux guichets des gares. Adressez-vous directement au guichetier SNCF pour être remboursé. Lorsque ce bon de caisse SNCF a été émis jusqu'au 06/12/2010, il est valable indéfiniment. Pour les bons de caisse émis à partir du 07/12/2010, ils ne sont valables que deux mois à compter de la date d'émission.</p></li><li><p>Le Bon de Caisse Agence. Pour celui-ci le remboursement ne peut être demandé qu'auprès de l'agence émettrice du titre initial.</p></li></ul></p>",
      },

      {
        type: 'subtitle',
        content: 'Les billets achetés avec des chèques vacances',
      },

      {
        type: 'body',
        content:
          "<p>Si vous n'étiez pas au courant, il est tout à fait possible de réserver son billet de train à l'aide de chèques vacances. Ces billets SNCF sont réservables uniquement dans votre gare ferroviaire. Pour le remboursement d'un trajet acheté tout ou partie en chèques vacances, il vous faudra effectuer une réclamation en ligne via ce site : <a href=\"https://www.sncf.com/fr/service-client/reclamations\">www.sncf.com/fr/service-client/reclamations</a>. Une fois votre demande prise en compte, vous n'aurez plus qu'à finaliser votre service après-vente SNCF en vous rendant à votre guichet de gare SNCF.</p>",
      },

      {
        type: 'subtitle',
        content: 'Les billets achetés au guichet SNCF',
      },

      {
        type: 'body',
        content:
          '<p>Comme vous pouvez vous en douter, un billet acheté au guichet SNCF en gare est remboursable à ce même guichet SNCF.</p>',
      },

      {
        type: 'subtitle',
        content: 'Les billets physiques et billets cartonnés',
      },

      {
        type: 'body',
        content:
          "<p>Les billets TER physiques et les billets TER cartonnés sont eux remboursables et échangeables sans frais lors d'une période de grève. Autrement, la plupart des billets ne sont pas remboursables, cf ci-dessous. </p>",
      },

      {
        type: 'subtitle',
        content: 'Les billets TER supprimés et TER en retard',
      },

      {
        type: 'body',
        content:
          "<p>Dans la plupart des régions de France, les billets TER achetés en ligne ou sur l'application ne sont pas remboursables. Cependant, les billets achetés en gare sont remboursables au guichet SNCF contre une retenue de 10%. Ce sont les régions qui fixent la politique de remboursement des billets TER. pour obtenir le remboursement potentiel sur ces trains, il faudra vous adresser UNIQUEMENT au guichet.</p>",
      },

      {
        type: 'title',
        content: 'Les billets SNCF non remboursables en gare',
      },

      {
        type: 'body',
        content:
          "<p>Eh oui, aujourd'hui encore il existe des billets SNCF non remboursables en gare ! Mais pour la plupart des billets, ne vous inquiétez pas, vous pourrez obtenir votre remboursement SNCF ! En fait, seuls les billets Agence ne sont pas remboursables directement par la SNCF ! Mais les billets Agence SNCF, c'est quoi ?</p><p>En fait il s'agit tout simplement des billets de train SNCF que vous avez acheté sur un site partenaire de la SCNF comme Tictactrip par exemple ! Pour des raisons de comptabilité et de service client, c'est aux agences d'effectuer le remboursement direct des billets SNCF qui peuvent l'être. Pour exemple, si vous avez réservé un train Intercités SNCF sur le site de Tictactrip, c'est auprès de Tictactrip que vous devrez demander un remboursement ! En plus, notre service client vous chouchoutera, contactez-nous !</p>Pensez bien à nous communiquer directement vos demandes de remboursement de billets agence SNCF, car si vous faites la demande de remboursement directement auprès de la SNCF, nous n'en serons par informés et nous ne pourrons donc vous rembourser.</p>",
      },
    ],
    relatedQuestions: [
      'politique-annulation-remboursement-billet',
      'couvre-feu-train-sncf',
    ],
  },
  {
    name: 'connexion-WIFI-train-bus',
    title: 'Y a-t-il une connexion WIFI à bord de mon train ou de mon bus ?',
    meta: {
      title:
        'Connexion WIFI à bord des trains et bus partenaires de Tictactrip',
      description:
        "Vous souhaitez savoir si votre transport est équipé d'une connexion WIFI ? Découvrez l'ensemble des services de connexion proposés à bord de vos transports terrestres",
    },
    category: ['conditions-de-voyage-tarifs-compagnies'],
    updatedDate: '10/12/2020',
    content: [
      {
        type: 'body',
        content:
          '<p>Confortablement installé dans votre transport préféré, l’heure est à la détente. Vous voulez profiter de ce trajet pour vous mettre à jour sur votre dernière série, liker quelques posts sur Instagram ou pour les plus courageux travailler sur un dossier urgent. Mais y a-t-il une connexion WIFI à bord de votre train ou de votre bus ? </p>',
      },

      {
        type: 'img',
        content:
          'conditions-de-voyage-tarifs-compagnies_smartphone-wifi-train-bus.jpg',
        alt: 'smartphone mains wifi train bus',
      },

      {
        type: 'title',
        content: 'Le WIFI à bord des bus',
      },

      {
        type: 'body',
        content:
          '<p>Les compagnies de bus comme <em>Flixbus</em> ou <em>Blablabus</em> offrent des trajets qui peuvent parfois être long. Vous pouvez donc effectuer un trajet d’une trentaine de minutes comme un trajet de plus d’une dizaine d’heures. Il faut donc bien s’occuper à l’intérieur.<br>Même si la lecture et les mots fléchés sont de bons compromis, les cars <em>Flixbus</em> sont équipés d’une <strong>connexion WIFI</strong>. Il existe également une <strong>plateforme de divertissement</strong> <q>Flixtainment</q> permettant de regarder des films, lire des e-books, jouer ou écouter de la musique. Vous pouvez également obtenir des informations sur votre trajet, voir votre position actuelle et être au courant de l’heure d’arrivée estimée selon le trajet.<br>C’est une offre complète qui n’est malheureusement pas encore disponible dans tous les Flixbus. Ne soyez donc pas étonné si celui-ci n’est pas encore équipé, ça ne saurait tarder.</p><p>Vous bénéficierez aussi du <strong>WIFI gratuit et illimité</strong> dans les bus <em>Blablabus</em> et <em>Alsa</em> pour rejoindre l’Espagne.</p>',
      },

      {
        type: 'title',
        content: ' Le WIFI à bord des trains',
      },

      {
        type: 'body',
        content:
          '<p>Dans un souci d’améliorer l’expérience des voyageurs à bord des trains, la plupart des compagnies ferroviaires ont investi dans une technologie de pointe afin de vous permettre d’accéder à un réseau WIFI de qualité.</p>',
      },

      {
        type: 'subtitle',
        content: 'À bord des TGV INOUI',
      },

      {
        type: 'body',
        content:
          '<p>Les TGV INOUI sont équipés d’un <strong>service WIFI</strong> et d’un <strong>portail</strong> qui donne accès au suivi du voyage, à la consultation du menu et à la commande au bar, à du contenu divertissant et à un chat entre voyageurs.<br>Ils ont pensé à tout : pour les voyages en famille, ce portail propose des podcasts éducatifs et de nombreuses histoires à lire. De quoi occuper les plus jeunes.<br>Pour découvrir les lignes équipées de ce service, n‘hésitez pas à suivre <a href="https://www.sncf.com/fr/offres-voyageurs/tgv-inoui/connectez-vous-pendant-votre-voyage#:~:text=wifi à bord-,Le Portail TGV INOUI,nos différents services et divertissements.">ce lien</a></p><p>Vous trouverez également ce même type de service chez <em>Lyria</em>, <em>Renfe</em> ou encore <em>Deutsche Bahn</em>.</p>',
      },

      {
        type: 'subtitle',
        content: 'À bord des INTERCITÉS et des TER',
      },
      {
        type: 'body',
        content:
          '<p>Concernant les <em>INTERCITÉS</em>, le <strong>WIFI</strong> est disponible sur les liaisons Paris - Clermont-Ferrand et Paris - Limoge - Toulouse. Il devrait arriver sur la ligne Bordeaux - Marseille en 2021.<br>Il en est de même pour les <em>TER</em> où le réseau WIFI arrive progressivement au sein de certaines rames, selon les régions.</p>',
      },

      {
        type: 'subtitle',
        content: 'À bord des trains Eurostar',
      },

      {
        type: 'body',
        content:
          '<p>Dans les trains <em>Eurostar</em> vous pouvez également profiter du <strong>WIFI</strong> sur l’ensemble des lignes Paris-Londres. Ils ont su innover en proposant dans leur <strong>plateforme de divertissement</strong> à bord, une aventure de <strong>réalité virtuelle</strong> totalement gratuite appelée <q>Odyssey</q>. Celle-ci vous permettra de découvrir les fonds marins durant la traversée de la Manche. Un smartphone ou une tablette suffit.<br>Pour une immersion plus complète vous pouvez acheter un casque de réalité virtuelle en salle d’embarquement. </p>',
      },

      {
        type: 'subtitle',
        content: 'À bord des Thalys',
      },

      {
        type: 'body',
        content:
          'Chez Thalys le service WIFI diffère selon votre classe de réservation. Il y a donc trois type de forfait : <strong>Standard</strong>, <strong>Comfort</strong> et <strong>Premium</strong>. Plus votre classe est élevée et plus vous bénéficierez d’une connexion plus ou moins importante avec des de services additionnels.</p>',
      },

      {
        type: 'subtitle',
        content: 'À bord des OUIGO',
      },

      {
        type: 'body',
        content:
          "<p>Nouveauté pour les trains <em>OUIGO</em> où le <strong>WIFI</strong> est désormais disponible à bord. Pas de précipitation, le service est arrivé en juillet 2020, uniquement sur la ligne Paris Gare de Lyon - Lyon Part Dieu/ Perrache.<br>Étant une compagnie low cost chaque service est payant donc le WIFI aussi :<ul><li><p><strong>3€</strong> par appareil pour le WIFI seul.</p></li><li><p>5€ par appareil pour le WIFI et l’offre de divertissement (jeux, séries, films).</p></li></ul><p>Pour les transports où il n’y a pas de WIFI de disponible, vous pouvez toujours utiliser la 4G de votre téléphone. Même s'il est vrai que lorsque vous traverserez certains <q>patelins</q> la connexion risque d’être complètement absente. Il faudra donc prendre son mal en patience.<br>Pour la plupart des compagnies n’ayant pas encore le WIFI à bord, il est en majeur partie en projet d’installation et sera opérationnel dans quelques années. De quoi profiter au mieux d’internet !<p>",
      },
    ],

    relatedQuestions: ['reserver-sur-tictactrip'],
  },
  {
    name: 'sms-confirmation-voyage',
    title: 'Vais-je recevoir un SMS de confirmation pour mon voyage ?',
    meta: {
      title:
        "Confirmation de voyage par SMS, tout ce qu'il faut savoir ! [À jour]",
      description:
        'Vous souhaitez savoir si vous recevrez un SMS de confirmation de votre voyage avant son départ ? Toutes les informations ici.',
    },
    category: ['service-apres-vente'],
    updatedDate: '28/12/2020',
    content: [
      {
        type: 'img',
        content: 'service-apres-vente_confirmation-de-voyage-par-sms.jpg',
        alt: 'confirmation de voyage par sms',
      },

      {
        type: 'body',
        content:
          "<p>Tout d'abord, il faut que vous sachiez que l'envoi de SMS n'est pas une pratique courante car elle peut paraître intrusive aux yeux de certains voyageurs. Découvrez dès à présent dans quels cas vous pourriez <strong>recevoir un SMS de confirmation</strong> et par quelles compagnies ! </p>",
      },

      {
        type: 'title',
        content: 'SMS de confirmation Tictactrip',
      },

      {
        type: 'body',
        content:
          "<p>Chez Tictactrip, nous estimons qu'il n'est pas nécessaire de vous envoyer un sms de confirmation de votre voyage. En effet, nous préférons vous envoyer toutes les informations relatives à votre voyage, par email. Cela vous permet de ne pas être dérangé par un SMS.</p><p>C'est là que vous vous demander pourquoi nous vous demandons (de façon optionnelle) votre numéro de téléphone lors de votre réservation ?</p><p>La réponse est simple, afin de vous venir en aide le plus rapidement possible en cas de problème lié à votre réservation !</p><p>Autrement, chez certaines compagnies de transport comme la SNCF, vous pourriez être amené à recevoir un SMS de confirmation de votre voyage.</p>",
      },

      {
        type: 'title',
        content: 'SMS de confirmation SNCF',
      },

      {
        type: 'body',
        content:
          "<p>Comme nous vous le disions plus haut, chez la SNCF, il est parfois possible de recevoir un SMS concernant son trajet en train. Mais pour cela, il faut remplir certaines conditions : <ul><li><p>Avoir acheté un e-billet de train SNCF.</p></li><li><p>Avoir réservé son billet avant 12h00 la veille du départ du train.</p></li><li><p>La SNCF doit être en possession de votre numéro de téléphone. C'est possible si vous faites partie du Programme Voyageur par exemple.</p></li></ul></p><p>Si vous remplissez toutes ces conditions, la SNCF devrait vous envoyer un SMS de confirmation de votre trajet, la veille de votre voyage. Ce SMS contiendra votre référence de dossier, votre numéro du train et votre placement à bord.</p><p>D'autres cas peuvent donner suite à un envoi de SMS comme pour les périodes de grève intenses avec de nombreuses suppressions de trains et afin de vous tenir informé.</p>",
      },

      {
        type: 'title',
        content: 'SMS de confirmation Eurostar',
      },

      {
        type: 'body',
        content:
          "<p>Chez Eurostar aussi, ces envois de SMS sont possibles si vous l'acceptez au moment de la réservation. Ces envois ont lieu principalement dans le cas d'un souci lié à votre voyage en train.</p><p>Voici les situations dans lesquelles vous pourriez recevoir un SMS Eurostar : <ul><li><p>Pour suivre le trafic en tant réel,</p></li><li><p>L'annulation d'un train Eurostar,</p></li><li><p>Le retard d'un train Eurostar,</p></li><li><p>Pour la procédure à suivre dans le cas d'une perturbation sur votre voyage <strong>donnant suite à un dédommagement</strong>.</p></li></ul></p>",
      },

      {
        type: 'title',
        content: 'SMS de confirmation Thalys',
      },

      {
        type: 'body',
        content:
          "<p>Pour Thalys, vous permettre de recevoir un SMS avec les informations concernant votre trajet, est une option ! Vous serez alors directement au courant en cas de <strong>perturbations du trafic</strong> pour votre train, vous recevrez un <strong>rappel de votre place à bord</strong> ainsi que l'ensemble des informations dont vous aurez besoin pour voyager sereinement.</p><p>De ce fait, vous avez le choix de recevoir des SMS Thalys ou non, à vous de voir !</p><p>Pour profiter des <strong>SMS Thalys</strong>, il vous suffit de complétez votre numéro de téléphone au moment de votre réservation de billets. De plus, si vous êtes déjà membre du programme My Thalys World, vous n'aurez pas besoin d'entrer à nouveau votre numéro de mobile.</p>",
      },

      {
        type: 'title',
        content: 'SMS de confirmation Flixbus',
      },

      {
        type: 'body',
        content:
          "<p>Chez Flixbus aussi il vous sera possible de recevoir un SMS concernant votre voyage. Il vous faudra tout d'abord indiquer votre numéro de téléphone au moment de votre réservation.</p><p>Ensuite, vous pourrez recevoir un SMS en cas de perturbation, retard ou annulation de votre voyage en bus.</p>",
      },
    ],
    relatedQuestions: [
      'comment-contacter-tictactrip',
      'train-retard-remboursement',
    ],
  },
  {
    name: 'retirer-son-billet-de-train',
    title: 'Comment retirer son billet de train pour son voyage ?',
    meta: {
      title: 'Comment retirer un billet de train pour voyager ? [À jour]',
      description:
        'Vous venez de réserver votre billet de train ? Découvrez comment le retirer et voyager facilement en train !',
    },
    category: ['conditions-de-voyage-tarifs-compagnies'],
    updatedDate: '22/12/2020',
    content: [
      {
        type: 'img',
        content:
          'conditions-de-voyage-tarifs-compagnies_retrait-billet-de-train-companie.jpg',
        alt: 'retrait billet de train companie',
      },

      {
        type: 'body',
        content:
          "<p>Il est courant de réserver ses billets de train mais de ne pas savoir réellement quoi en faire par la suite... Devez-vous imprimer vos billets de train ? Pouvez-vous garder uniquement vos billets sur votre smartphone ? Ce sont tant de questions auxquelles les réponses sont simples, mais qui dépendent des compagnies, c'est là que réside la source de complexité.</p><p>Pas de panique, Tictactrip vous explique tout à la suite. Dans 1min même pas, vous aurez votre réponse !</p>",
      },

      {
        type: 'title',
        content: 'Retirer votre billet de train TER',
      },

      {
        type: 'body',
        content:
          "<p>Pour les trains régionaux express en France, retirer votre billet sera un jeu d'enfant ! En effet, la quasi-totalité des billets TER sont aujourd'hui des <strong>e-billets</strong>.</p><p>Une fois votre billet TER réservé sur Tictactrip, nous vous l'enverrons par mail à l'adresse renseignée pour la commande.</p><p>Vous n'aurez plus qu'à <ul><li><p><strong>imprimer votre billet</strong> au format PDF,</p></li><li><p>ou bien intégrer votre billet TER à votre <strong>application Assistant SNCF</strong>.</p></li></ul></p><p>Pourquoi n'avez-vous que ces deux choix ? Car le billet TER en format PDF (comme envoyé par mail) sur votre mobile n'est pas valide lors d'un contrôle. Il vous faudra donc être en possession de l'une des deux solutions présentées ci-dessus.</p><p>De plus, il n'est <strong>pas possible de retirer votre billet TER en gare</strong>, ni à une borne ou à un guichet SNCF.</p>",
      },

      {
        type: 'title',
        content: 'Retirer votre billet OUIGO',
      },

      {
        type: 'body',
        content:
          "<p>Chez OUIGO, le fonctionnement du retrait des billets et du contrôle à l'embarquement est très simple. Pour accéder au train, vous devrez présenter votre titre de transport sous format papier, ou via l'<strong>application mobile OUIGO</strong>.</p><p>Suite à votre réservation OUIGO, vous recevrez un email de confirmation de commande. Vos billets de transports en train OUIGO ne sont envoyés en mail par la compagnie que 4 jours avant le départ de votre TGV. Pensez bien à vérifier votre boite mail et à imprimer votre billet dans le temps imparti. Sinon, vous pouvez toujours retrouver vos billets sur votre application OUIGO pour smartphones.</p>",
      },

      {
        type: 'title',
        content: 'Retirer votre billet TGV Inoui',
      },

      {
        type: 'body',
        content:
          "<p>Pour ce type de trajet en TGV SNCF, la plupart du temps votre billet sera digital. Autrement dit, vous le recevrez dans votre boite mail et/ou sur l'application SNCF.</p><p> Vous pourrez soit l'<strong>imprimer en version papier</strong>, soit l'<strong>imprimer via une borne SNCF</strong> en gare ou enfin garder uniquement votre <strong>e-billet</strong> sur votre smartphone. Voyager en TGV Inoui, c'est très simple au final !</p>",
      },

      {
        type: 'title',
        content: 'Retirer votre billet Intercités',
      },

      {
        type: 'body',
        content:
          "<p>Pour vos voyages en trains Intercités, différents moyens pour retirer votre billet sont envisageables et tous aussi simples les uns que les autres.</p><p>En effet, la plupart des billets de train Intercités sont des e-billets que vous recevrez directement sur votre boîte mail. Vous en disposerez également dans votre application SNCF.</p><p>Pour retirer votre billet et voyager avec, vous aurez différentes solutions : <ul><li><p>Imprimer votre billet Intercités sur papier,</p></li><li><p>imprimer votre billet Intercités en gare, sur une borne de retrait,</p></li><li><p>ou bien garder votre billet sous forme de e-billet Intercités sur votre smartphone.</p></li></ul></p>C'est plutôt simple de voyager en train Intercités, vous ne trouvez pas ?!</p>",
      },

      {
        type: 'title',
        content: 'Retirer votre billet Eurostar',
      },

      {
        type: 'body',
        content:
          "<p>Retirer votre billet Eurostar est chose aisée ! Une fois votre réservation Eurostar effectuée, vous recevrez votre billet billet par email.</p><p>À partir de ce moment là, trois options s'offrent à vous pour retirer votre billet Eurostar et voyager avec : <ul><li><p>Imprimer votre billet Eurostar à domicile, en version papier. Pour ce faire, il vous suffira d'imprimer vos billets reçus par mail, ou bien de vous connecter sur le site Eurostar et imprimer vos billets. À noter, tous les trajets ne sont pas imprimables (trajets combinés notamment).</p></li><li><p> Télécharger un billet électronique Eurostar et l’enregistrer sur l’application Wallet. Cela vous permet d'avoir accès à votre billet directement sur votre smartphone, sans avoir à télécharger obligatoirement l'application Eurostar. Pour ce faire, il vous faudra ouvrir le mail contenant votre billet, directement sur votre Smartphone. L'option d'ajout à votre Wallet vous sera alors proposée.</p></li><li><p>Enfin, il vous est aussi possible de télécharger directement l'application Eurostar afin d'accéder à vos réservations et donc de pouvoir présenter votre billet ainsi.</p></li></ul><p>Alors, prêt à voyager facilement en Eurostar ?</p>",
      },

      {
        type: 'title',
        content: 'Retrait des billets Thalys',
      },

      {
        type: 'body',
        content:
          "<p>Pour les trains Thalys, vous n'aurez aucune difficulté à retirer vos billets.</p><p>Il vous suffira tout simplement d'imprimer vos billets Thalys reçus par mail, ou bien de les enregistrer dans votre Wallet ou <strong>application Thalys</strong>. C'est tout simple !</p> <p>Enfin, si vous recherchez vos billets Thalys, vous pouvez les retrouver très facilement sur le site ou l'application Thalys, dans votre compte, au sein de l'onglet \"Mes billets\". Votre <strong>numéro de commande PNR</strong> et adresse e-mail ou nom sur la réservation vous seront demandés.</p> ",
      },

      {
        type: 'title',
        content: 'Retrait des billets Lyria',
      },

      {
        type: 'body',
        content:
          "<p>Voyager avec Lyria c'est voyager sans tracas. Effectivement, pour retirer votre billet Lyria, vous aurez de nombreuses options.</p><p>Il vous suffira d'imprimer votre billet Lydia depuis chez vous, sur une borne libre-service en gare ou à un guichet SNCF.</p><p>Et pour recevoir votre billet, c'est aussi simple. Il vous sera envoyé par email suite à votre réservation. Vous pouvez aussi l'obtenir en gare directement ou via un appel au 36 35 le prix de l'appel s'élève à <strong>0,40 € TTC/minute</strong>.</p>",
      },
    ],
    relatedQuestions: [
      'imprimer-billet-train-bus',
      'retirer-son-billet-de-bus',
    ],
  },
  {
    name: 'retirer-son-billet-de-bus',
    title: 'Comment retirer son billet de bus pour voyager ?',
    meta: {
      title: 'Comment retirer son billet de bus pour voyager ? [À jour]',
      description:
        'Vous venez de réserver un billet de bus ? Découvrez comment le retirer et voyager en bus facilement !',
    },
    category: ['conditions-de-voyage-tarifs-compagnies'],
    updatedDate: '16/12/2020',
    content: [
      {
        type: 'img',
        content:
          'conditions-de-voyage-tarifs-compagnies_retirer-billet-de-bus-voyage-bus-facile.jpg',
        alt: 'retirer billet de bus voyage bus facile',
      },

      {
        type: 'body',
        content:
          "<p>Suite à votre dernière réservation de voyage, vous vous apprêtez à vous déplacer en bus. Mais vous avez un doute sur la manière dont vous devez retirer votre billet de bus ? Vous avez en effe la possibilité d'avoir un e-billet de bus, un billet de bus cartonné ou bien autre chose encore... Quel casse-tête ! </p><p>Mais pas d'inquiétudes, nous sommes là pour simplifier votre voyage, découvrez toutes les informations nécessaires à votre voyage, en fonction de la compagnie de bus avec laquelle vous allez voyager.</p>",
      },

      {
        type: 'title',
        content: 'Retirer votre billet Blablabus',
      },

      {
        type: 'body',
        content:
          "<p>Chez Blablabus, retirer votre billet de bus est une chose très simple ! Pourquoi ? Tout simplement car le billet Blablabus n'est pas indispensable pour voyager !</p><p>Les conducteurs et contrôleurs de bus possèdent une liste des passagers et seule une pièce d'identité vous sera demandée à l'embarquement.</p><p>Quoi qu'il en soit, nous vous enverrons vos billets Blablabus par mail. Pas de panique donc !</p>",
      },

      {
        type: 'title',
        content: 'Retirer votre billet Flixbus',
      },

      {
        type: 'body',
        content:
          "<p>Chez Flixbus, la politique de retrait et de possession des billets de bus est un peu plus stricte. En effet, dans les <a href=\"https://www.flixbus.fr/conditions-generales-de-transport\">conditions générales de vente Flixbus</a>, il est écrit \"Lors d'un contrôle de titre de transport aléatoire par des employés des filiales de FlixBus, le passager est tenu de présenter à la fois un titre de transport et une pièce d'identité valide avec photo.\". Pensez donc bien à vous munir de ces deux documents !</p><p>Pour le retrait de votre billet Flixbus c'est tout simple : nous vous l'envoyons par mail une fois votre réservation effectuée. À partir de ce moment, vous pourrez : <ol><li><p><strong>Imprimer votre billet Flixbus</strong> en version papier.</p></li><li><p>Le télécharger sur votre mobile en tant que <strong>e-billet</strong>.</p></li><li><p>Télécharger l'<strong>application Flixbus</strong> directement afin d'accèder simplement à toutes vos réservations Flixbus et vos billets de bus.</p></li></ol></p>",
      },

      {
        type: 'title',
        content: 'Retirer votre billet Altibus',
      },

      {
        type: 'body',
        content:
          "<p>Pour vos voyages à bord des navettes Altibus, la politique de contrôle des billets est stricte comme celle de Flixbus. En effet, vous devrez être en possession de votre billet de transport au moment de monter à bord du bus Altibus car votre titre de transport vous sera demandé, accompagné d'une pièce d'identité.</p><p>De la même façon, pensez à garder votre titre de transport tout au long du trajet car il pourrait vous être demandé à nouveau lors d'un contrôle.</p><p>Pour retirer votre billet Altibus, c'est tout simple ! Nous vous enverrons votre <strong>billet par mail</strong> une fois réservé sur notre site. Vous n'aurez alors plus qu'à <strong>imprimer votre billet Altibus</strong> en version papier. Si vous êtes plutôt adepte des solutions digitales, vous pouvez faire le choix d'<strong>enregistrer votre billet</strong> directement sur votre smartphone.</p><p>C'est plutôt simple de voyager en bus tout de même, vous ne trouvez pas ?</p>",
      },
    ],
    relatedQuestions: ['imprimer-billet-train-bus', 'billet-bus-enfant'],
  },
  {
    name: 'train-eurostar-annule',
    title: 'Train Eurostar annulé, que faire ?',
    meta: {
      title: "Que faire en cas d'annulation train Eurostar ? [À jour]",
      description:
        'Vous aviez récemment réservé un train Eurostar mais celui-ci a été annulé ? Découvrez les solutions pour votre annulation de train Eurostar.',
    },
    category: ['service-apres-vente'],
    updatedDate: '18/12/2020',
    content: [
      {
        type: 'img',
        content: 'service-apres-vente_annulation-train-eurostar-que-faire.jpg',
        alt: 'annulation train eurostar solutions eurostar apres-vente',
      },

      {
        type: 'body',
        content:
          "<p>Vous souhaitiez voyager entre la France, l'Angleterre et/ou la Belgique à bord d'un train Eurostar mais votre train a été supprimé ? Nous sommes réellement navrés de cette annulation de votre train Eurostar... Mais nous pouvons vous aider à trouver une solution ! Découvrez comment à la suite.</p>",
      },

      {
        type: 'title',
        content: 'Demandez un remboursement Eurostar',
      },

      {
        type: 'body',
        content:
          "<p>En effet, si et seulement si, le train Eurostar supprimé est du fait de la compagnie, vous pouvez demander simplement à <strong>être remboursé du prix de votre billet Eurostar</strong>. S'il s'agit d'un billet <strong>Eurostar aller-retour</strong>, vous pouvez également demander le <strong>remboursement intégral</strong> de votre voyage en train Eurostar aller-retour.</p>",
      },

      {
        type: 'title',
        content: 'Échangez votre billet Eurostar',
      },

      {
        type: 'body',
        content:
          '<p>Votre seconde solution dans le cas d\'une <strong>suppression de train Eurostar</strong> réside dans votre capacité à <strong>échanger votre billet de train Eurostar</strong>. En effet, il vous sera possible de procéder à un échange gratuit en gardant bien entendu les mêmes gares de départ et d’arrivée, ainsi que la classe dans laquelle vous deviez voyager.</p><p>Quelque soit l\'option que vous décidez de prendre concernant votre trajet supprimé et votre billet Eurostar, nous vous invitons à contacter directement notre service client et/ou à vous rendre directement sur <a href="https://www.eurostar.com/fr-fr/voyage/informations-trafic/politique-de-compensation">cette page du site Eurostar</a>.</p>',
      },
    ],
    relatedQuestions: ['echanger-mes-billets', 'train-retard-remboursement'],
  },
  {
    name: 'bagages-ouigo',
    title: 'Bagages à bord du OUIGO',
    meta: {
      title: "les bagages autorisés à bord d'un train OUIGO",
      description:
        "Vous voulez savoir avec quel type de bagages vous pouvez voyager à bord d'un OUIGO",
    },
    category: ['conditions-de-voyage-tarifs-compagnies'],
    updatedDate: '21/12/2020',
    content: [
      {
        type: 'body',
        content:
          '<p>Vous avez réussi à dénicher une super offre de <strong>voyage</strong> auprès de notre partenaire <em>OUIGO</em>. Il est vrai que cette compagnie propose des trajets à petit prix vers un bon nombre de destinations en France. Nous sommes heureux de vous en faire bénéficier.<br>Cependant, comme toutes compagnies low-cost beaucoup de <strong>services à bord</strong> sont réduits ou payants. Mais qu’en est-il de vos <strong>bagages OUIGO</strong> ? Pourriez-vous voyager avec toute votre armoire ou devriez-vous prendre le strict minimum ?</p>',
      },

      {
        type: 'img',
        content:
          'conditions-de-voyage-tarifs-compagnies_valise-sac-a-dos-bagages-ouigo.jpg',
        alt: 'valise sac à dos bagages ouigo',
      },

      {
        type: 'title',
        content: 'Quels sont les bagages inclus dans le tarif de mon billet ?',
      },

      {
        type: 'body',
        content:
          '<p>À bord d’un OUIGO vous avez la possibilité de voyager avec :<ul><li><p><strong>2 Bagages à main</strong> ne dépassant pas 36 x 27 x 15 cm</p></li> Ou<li><p><strong>1 Bagage à main</strong> ne dépassant pas 36 x 27 x 15 cm + <strong>1 Bagage cabine</strong> ne dépassant pas 55 x 35 x 25 cm</p></li></ul></p>Ces bagages seront à placer <strong>sous le siège</strong>, les racks à bagages étant réservés pour les grosses valises. De même, vous ne pouvez pas remplacer vos deux bagages cabine par une grande valise.</p>',
      },

      {
        type: 'title',
        content:
          ' Comment rajouter un bagage OUIGO après avoir effectué ma réservation ?',
      },

      {
        type: 'body',
        content:
          '<p>Si pour vous il est impossible de choisir et qu’il vous faut emmener toute votre garde-robe dans votre valise, nous avons la solution !<br>Souscrivez à <strong>l’option <q> Bagage </q> à 5€</strong> afin de pouvoir rajouter jusqu’à 2 bagages supplémentaires volumineux ou non. Parmi ces bagages vous avez le droit à :<ul><li><p>Un sac de voyage ou une valise,</p></li><li><p>Un vélo avec housse 120 x 90 cm,</p></li><li><p>Une trotinette,</p></li><li><p>Un instrument de musique dans sa housse,</p></li><li><p>Une planche de surf ou une paire de ski sous housse et n’excédant pas 2 mètres.</p></li></ul></p>Pour ajouter l’option <q> Bagage </q> c’est simple. Il suffit de vous rendre sur la page <a href="https://ventes.ouigo.com/fr-FR/booking/login">Mes réservations OUIGO</a>.<br>Renseignez-y :<ul><li><p>l\'<strong>adresse mail</strong> utilisée lors de la réservation</p></li><li><p>votre <strong>numéro de réservation</strong> composé de 6 caractères</p></li></ul></p><p>Rendez-vous dans la rubrique : <q>Modifier votre voyage / Ajouter des options</q>, puis vous pourrez ajouter votre bagage. Bonne nouvelle ! Vous pouvez souscrire à cette option <strong>jusqu’à 1h30</strong> avant le départ de votre train.</p><p>Vous savez désormais comment rajouter un bagage supplémentaire à votre réservation et surtout avec quels bagages vous pouvez voyager à bord d’un <em>OUIGO</em>. Pour toutes questions supplémentaires n’hésitez pas à contacter notre service client !</p>',
      },
    ],

    relatedQuestions: [
      'politique-annulation-remboursement-billet',
      'billet-ouigo-non-recu',
      'imprimer-billet-train-bus',
    ],
  },
  {
    name: 'service-apres-vente-flixbus',
    title:
      'Flixbus Contact - Toutes les informations  sur le service après-vente Flixbus !',
    meta: {
      title:
        'Flixbus contact service client et informations importantes ! [À Jour]',
      description:
        'Une question ou une réclamation pour votre voyage Flixbus ? Découvrez comment contacter Flixbus facilement.',
    },
    category: ['service-apres-vente'],
    updatedDate: '28/05/2024',
    content: [
      {
        type: 'img',
        content: 'service-apres-vente_sav-flixbus-emplacement-bus-au-sol.jpg',
        alt: 'service-apres-vente-flixbus-emplacement-bus-au-sol',
      },
      {
        type: 'body',
        content:
          '<p>Vous voyagez en Flixbus et vous avez un problème ?</p><p>Il est vrai qu\'il peut être assez complexe d\'obtenir des informations sur le <strong>service client Flixbus</strong> et les démarches à effectuer en fonction de votre réclamation.</p><p>Pourtant, vous le verrez ci-dessous, la plupart des démarches sont à effectuer directement auprès de la compagnie Flixbus. Et ce, même si vous avez réservé votre billet Flixbus sur Tictactrip ou chez une autre agence de voyage.</p><p>Découvrez dès à présent le fonctionnement du service client de Flixbus.</p><p>Et pour votre information, voici le numéro de téléphone Flixbus : <a href="tel:0176360412">01 76 36 04 12</a>.<br>Ainsi que l\'adresse du <a href="https://help.flixbus.com/s/article/PSSP-Comment-puisje-demander-un-remboursement-pour-retard-inf%C3%A9rieur-%C3%A0-120-minutes?language=fr">Formulaire de contact Flixbus</a>.</p>',
      },
      {
        type: 'title',
        content:
          'Application Flixbus: le service client Flixbus à portée de main',
      },
      {
        type: 'body',
        content:
          '<p>Bien entendu, avec l\'application Flixbus, il vous sera très simple de résoudre la plupart de vos soucis de service après-vente Flixbus !</p><p>Par exemple, vous pouvez simplement modifier un billet sur l\'application Flixbus. Il vous suffit de : <ol><li><p>Vous connecter à l\'application FlixBus.</p></li><li><p>Vous rendre dans l\'onglet "Billets", situé dans la barre de menu.</p></li><li><p>Cliquez sur "Trajets à venir".</p></li><li><p>Cliquez sur le voyage que vous aimeriez modifier, puis sur "Modifier".</p></li><li><p>Laissez vous guider et procédez aux modifications souhaitées.</p></li></ol></p><p>Plutôt simple, vous ne trouvez pas ?</p>',
      },
      {
        type: 'title',
        content: "L'aide Flixbus en FAQ",
      },
      {
        type: 'body',
        content:
          '<p>Vous n\'avez pas trouvé la réponse à votre question dans notre FAQ Service client Flixbus ? Nous en sommes navrés... N\'hésitez pas à nous faire part des recommandations que vous auriez pour améliorer encore un peu plus cette FAQ ! </p><p>Quoi qu\'il en soit, vous pouvez accèder très simplement à la <a href="https://help.flixbus.com/s/home-fr/?language=fr">FAQ Flixbus</a> qui regroupe l\'ensemble de vos questions voyageur. Vous cherchez une information croustillante sur la <a href="/company/bus/flixbus">compagnie aux bus verts Flixbus</a> ? </p>',
      },
      {
        type: 'title',
        content: 'Et pour votre prochaine réservation Flixbus ?',
      },
      {
        type: 'body',
        content:
          '<p>Rien de plus facile : rendez-vous <a href="/company/bus/flixbus/reservation">sur notre page dédiée</a> et réservez en 3 clics.</p>',
      },
    ],
    relatedQuestions: [
      'imprimer-billet-train-bus',
      'animal-compagnie-a-bord-du-bus',
      'remboursement-annulation-flixbus',
    ],
  },
  {
    name: 'remboursement-annulation-flixbus',
    title:
      'Flixbus Remboursement et modifications - Comment fonctionne le service après-vente Flixbus ?',
    meta: {
      title:
        'Flixbus remboursement, modifcations et autres informations importantes ! [À Jour]',
      description:
        'Une annulation ou une modification pour votre voyage Flixbus ? Simplement.',
    },
    category: ['service-apres-vente'],
    updatedDate: '28/05/2024',
    content: [
      {
        type: 'img',
        content: 'service-apres-vente_sav-flixbus-emplacement-bus-au-sol.jpg',
        alt: 'service-apres-vente-flixbus-emplacement-bus-au-sol',
      },

      {
        type: 'title',
        content:
          'Un changement de plan ? Votre Flixbus ne vous convient plus ?',
      },
      {
        type: 'body',
        content:
          "<p>🚨 Vous avez réservé votre voyage mais malheureusement vous êtes contraint de demander une annulation et un remboursement de billet Flixbus car vous ne pouvez plus voyager ? En raison d'un bus <b>Flixbus annulé</b> ? Et vous êtes préoccupé par le montant du remboursement Flixbus ?</b></p><p>Sachez que l'on vous comprend et nous avons déjà par le passé aidé des <strong>milliers de voyageurs Flixbus</strong> à obtenir leur remboursement. Laissez-nous vous guider.</p><p>À contrario, si vous n'avez pas encore effectué votre réservation de billet Flixbus mais que vous êtes curieux de la politique d'annulation et de remboursement de la compagnie de bus, vous êtes aussi <b>au bon endroit</b> !</p><p>Nous vous avons compilé tous les cas de figure afin que vous sachiez quelle est la procédure pour demander un remboursement et sous quels délais celui-ci est traité, <b>comment modifier votre réservation</b>, comme changer l'horaire ou la destination ou bien encore si vous pourrez être remboursé totalement ou en partie, du prix de votre billet.</p><p>Et si après toutes ces informations, il vous reste la moindre interrogation, n'hésitez pas à contacter notre service client, disponible 7j/7 pour vous.</p>",
      },
      {
        type: 'title',
        content: 'Annuler un billet Flixbus',
      },
      {
        type: 'body',
        content:
          "<p>À la suite de votre réservation de bus Flixbus, vous souhaiteriez annuler votre voyage ?</p><p>Vous avez de la chance car c'est tout à fait possible !</p><p>Pour ce faire, il vous suffit tout simplement de vous connecter à l'adresse suivante : <a href=\"https://shop.flixbus.fr/rebooking/login\">https://shop.flixbus.fr/rebooking/login</a>.</p><p>Pour vous connecter, vous aurez besoin uniquement de votre :<ul><li><p>adresse email de réservation</p></li><li><p>et de votre numéro de réservation. Pas de panique si vous ne le connaissez pas, il est récupérable facilement à l'aide de votre adresse email.</p></li></ul></p><p>Une fois cette étape passée, vous pourrez gérer vos réservations comme bon vous semble !</p><p><strong>Attention</strong> cependant car des <strong>frais d’annulation</strong> sont possibles selon le barème suivant :<ul><li><p>À 30 jours et plus du départ : pas de frais d’annulation.</p></li><li><p>Entre 14 et 29 jours du départ : 1€ de frais d’annulation.</p></li><li><p>Entre 3 et 13 jours du départ : 3€ de frais d’annulation.</p></li><li><p>À moins de 3 jours du départ : 5€ de frais d’annulation.</p></li></ul></p>",
      },
      {
        type: 'title',
        content: 'Échanger un billet Flixbus',
      },
      {
        type: 'body',
        content:
          "<p>Après avoir réservé votre voyage en Flixbus vous vous apercevez que la date ou l'horaire de votre voyage ne vous convient pas ?</p><p>Pas de panique, il existe une solution simple et accessible.</p><p>En effet, il n'est pas possible d'échanger votre billet Flixbus à proprement parler. Cependant, il vous sera possible d'annuler votre billet initial et d'en réserver un nouveau !</p><p>Pour annuler votre billet, nous vous invitons à effectuer les démarches indiquées plus haut. Et pour réserver un nouveau billet, vous n'avez qu'a réitérer votre réservation. Pensez à réserver sur Tictactrip pour obtenir les meilleurs prix et une assistance 7j/7 !</p>",
      },
      {
        type: 'title',
        content: 'Remboursement Flixbus',
      },
      {
        type: 'body',
        content:
          "<p>Attention cependant si vous comptez annuler votre billet Flixbus, car les remboursements Flixbus sont particuliers.</p><p>Il faudra tout d'abord que vous preniez bien en compte les frais d'annulation qui peuvent être appliqués à votre voyage, cités ci-dessus.</p><p>Au delà de ces frais, sachez que les billets Flixbus ne sont remboursables qu'en bons d'achat valables 1 an.</p><p>Cette durée d'un an peut potentiellement être prolongée en en faisant la requête expresse directement à Flixbus. Cela est possible uniquement si le bon d'achat n'est pas utilisé dans cette période d'un an.</p><p>Certaines exceptions existent, dans quels cas Flixbus pourra vous rembourser en valeur monétaire. Mais sachez bien que ce n'est que 5% du temps...</p>",
      },
      {
        type: 'title',
        content: 'Modifier un billet Flixbus',
      },
      {
        type: 'body',
        content:
          '<p>Ici, nous évoquerons les cas des erreurs sur la réservation de vos billets, vous concernant. Autrement dit, les cas où vous auriez fait une faute à votre nom, prénom ou encore à votre date de naissance.</p><p>Pour modifier simplement votre billet Flixbus, il vous suffit de vous rendre sur le site Flixbus et sur la page contenant vos réservations (cf les démarches "Annuler un billet Flixbus").</p><p>Une fois sur cette page, il vous sera possible très simplement de modifier gratuitement vos coordonnées ainsi que vos informations voyageur Flixbus.</p>',
      },
      {
        type: 'subtitle',
        content: 'Supprimer une valise supplémentaire Flixbus',
      },
      {
        type: 'body',
        content:
          "<p>Eh oui, modifier votre billet peut aussi revenir à la suppression d'une valise supplémentaire pour votre voyage.</p><p>Sachez qu'il est vous est tout à fait possible de réaliser une telle démarche auprès de Flixbus, en suivant une nouvelle fois, la démarche indiquée plus haut.</p><p>Cette modification du billet concernant vos bagages peut intervenir jusqu'à 15 minutes avant le départ de votre bus. Un bon d'achat correspondant vous sera alors attribué.</p>",
      },
      {
        type: 'title',
        content: "L'aide Flixbus en FAQ",
      },
      {
        type: 'body',
        content:
          '<p>Vous n\'avez pas trouvé la réponse à votre question dans notre FAQ Service client Flixbus ? Nous en sommes navrés... N\'hésitez pas à nous faire part des recommandations que vous auriez pour améliorer encore un peu plus cette FAQ ! </p><p>Quoi qu\'il en soit, vous pouvez accèder très simplement à la <a href="https://help.flixbus.com/s/home-fr/?language=fr">FAQ Flixbus</a> qui regroupe l\'ensemble de vos questions voyageur. Vous cherchez une information croustillante sur la <a href="/company/bus/flixbus">compagnie aux bus verts Flixbus</a> ? </p>',
      },
      {
        type: 'title',
        content: 'Et pour votre prochaine réservation Flixbus ?',
      },
      {
        type: 'body',
        content:
          '<p>Rien de plus facile : rendez-vous <a href="/company/bus/flixbus/reservation">sur notre page dédiée</a> et réservez en 3 clics.</p>',
      },
    ],
    relatedQuestions: ['service-apres-vente-flixbus'],
  },
  {
    name: 'services-sncf-avant-depart',
    title:
      'Les Services SNCF avant votre départ, de quoi embellir le début du voyage !',
    meta: {
      title:
        'Découvrez tous les services SNCF avant votre départ ! [Nouveautés]',
      description:
        "Découvrez l'ensemble des services SNCF dont vous pouvez profiter avant votre départ !",
    },
    category: ['conditions-de-voyage-tarifs-compagnies'],
    updatedDate: '29/01/2020',
    content: [
      {
        type: 'img',
        content: 'conditions-de-voyage-tarifs-compagnies_services-sncf.jpg',
        alt: 'les services sncf avant depart',
      },
      {
        type: 'body',
        content:
          "<p>Chez la SNCF, votre bien-être de voyage passe avant tout !</p><p>C'est d'ailleurs pour cette raison que la compagnie ferroviaire française met tant de services en place : afin de répondre au mieux à vos attentes et besoins.</p><p>Aussi, nous souhaitons vous éclairer par rapport à toutes les possibilités et services SNCF qui s'offrent à vous avant même le départ de votre train. Il ne faudrait pas que vous passiez à coté de services qui amélioreraient considérablement votre voyage, vous ne pensez pas ?</p><p>Place à la découverte des services SNCF avant voyage !</p>",
      },
      {
        type: 'title',
        content: 'Le service bagage SNCF',
      },
      {
        type: 'body',
        content:
          "<p>Le service bagage SNCF est peut-être l'un des plus utiles, surtout si vous êtes très chargé.e lorsque vous voyagez.</p><p>En effet, ce service vous permet de voyager sans vous encombrer de vos bagages. C'est la SNCF qui s'occupe de tout !</p><p>Ils viendront chercher vos bagages directement à votre domicile. Ensuite, vos bagages vous seront livrés le lendemain à l'adresse et à l'horaire de votre choix.</p><p>Plutôt cool comme service non ?! Vous pouvez par ailleurs choisir l'horaire de prise en charge de vos bagages et même suivre leur acheminement en direct.</p><p>En bref, c'est un service très complet ! Cependant, ce service est actuellement suspendu depuis le 1er novembre 2020 en raison de la crise sanitaire actuelle.</p><p>Ce service est compatible avec tous vos voyages InOui, moyennant un suplément monétaire.</p><p>Pour en savoir plus sur les modalité du service bagage SNCF, rendez-vous <a href=\"https://www.sncf.com/fr/offres-voyageurs/voyager-en-train/tgv-inoui/votre-voyage/bagages-et-consignes\">ICI</a>.</p>",
      },
      {
        type: 'title',
        content: 'Le service Hiflow SNCF',
      },
      {
        type: 'body',
        content:
          "<p>Ce service SNCF, dont vous n'avez peut-être jamais entendu parlé, est similaire au précédent : le service bagage SNCF. </p><p>Pourquoi ?</p><p>Tout simplement car il s'agit d'un service qui a pour but de déplacer votre bien. Mais de quel bien s'agit-il ?</p><p>Hiflow SNCF déplace votre véhicule où que vous alliez ! Ainsi, si vous partez loin en train, vous pouvez choisir ce service qui vous assurera de retrouver votre véhicule à votre arrivée. Plutôt séduisant comme système.</p><p>Et pour y arriver, la solution Hiflow Oui SNCF s'appuie sur trois différentes solutions : <ol><li><p>Le recours à un conducteur particulier.</p></li><li><p>Le transport dans un camion.</p></li><li><p>Le recours à un conducteur professionnel.</p></li></ol></p>Hiflow, anciennement Expedicar, est partenaire SNCF depuis 2017, donc pas d'inquiétudes ! Le prix de cette prestation est à partir de 98€ et c'est vous qui choisissez la solution !</p>",
      },
      {
        type: 'title',
        content: 'Le service mon chauffeur SNCF',
      },
      {
        type: 'body',
        content:
          "<p>Ce service de la SNCF a su se faire une place rapidement car il est très utile !</p><p>Le concept est simple : pour les voyageurs des trains InOui et autres trains SNCF, il vous est possible de réserver à l'avance un chauffeur qui viendra vous chercher à votre domicile et vous déposera directement en gare. Vous serez dès lors certain d'arriver à l'heure pour votre train ! Mais il est aussi possible de réserver un trajet de votre gare d'arrivée, jusqu'à votre destination finale.</p><p>Ce service simplifie la vie non ? Le mieux dans tout ça, c'est bien que si vous vous connectez au réseau WiFi de votre TGV InOui et que vous allez directement dans la rubrique Mon Chauffeur, vous pourrez aisément réserver une course 1h15 minimum avant l'arrivée du train en gare.</p><p>C'est carrément top comme service, merci la SNCF !</p>",
      },
      {
        type: 'title',
        content: 'Le service accompagnement domicile train SNCF',
      },
      {
        type: 'body',
        content:
          "<p>Comme nous vous le disions, chez la SNCF, votre confort de voyage est primordial. C'est pourquoi la SNCF a créé le <strong>service domicile train</strong>.</p><p>Vous pouvez en profiter facilement, que vous soyez une personne à mobilité réduite, une personne âgée, une femme enceinte...</p><p>Le principe est simple, vous jouirez d'un accompagnement depuis votre domicile et ce jusqu'à ce que vous soyez à votre place dans le train. Mais aussi, d'un accompagnement depuis votre gare d'arrivée jusqu'à votre lieu de destination !</p><p>Ce service de la SNCF est facturé 30€ au minimum pour 1h d'accompagnement. L'accompagnateur est un professionnel et il est à noter que vous pourrez bénéficier d'une réduction d'impôts de 50% du montant de la facture de ce service. autrement dit, vous ne paierez que 50% du montant du service !</p><p>Vous l'aurez compris, c'est un service très pratique, d'autant plus qu'il est réservable jusqu'à 48h avant le départ ! Enfin, cerise sur le gâteau, votre accompagnateur s'occupera de tout pour vous, vos achats, votre billet... Vous pourrez vous la couler douce !</p>",
      },
      {
        type: 'title',
        content: 'Le service parking SNCF Onepark',
      },
      {
        type: 'body',
        content:
          "<p>Si vous comptiez vous rendre à votre gare SNCF en voiture, pensez à la solution Onepark !</p><p>Il s'agit là encore d'un partenaire de la SNCF : Onepark. Celui-ci est spécialiste des solutions de parking faciles. Ainsi, vous pourrez réserver à l'avance votre place de parking gare SNCF facilement.</p><p>Les places de parking peuvent se trouver dans des parkings officiels, parkings voituriers ou parkings d'hôtels. Quoi qu'il en soit, vous pouvez assurer le coup en réservant votre place de parking à l'avance à partir de 15€/jour.</p><p>Encore une fois, un bon moyen de se simplifier la vie !</p>",
      },
      {
        type: 'title',
        content: 'Le service Accès Plus SNCF',
      },
      {
        type: 'body',
        content:
          "<p>Le service Accès Plus SNCF est l'un des plus connus. Ce service a pour but de venir en aide de la meilleure des façons aux personnes handicapées et à mobilité réduite.</p><p>Tout d'abord il faut savoir que le service Accès Plus de la SNCF est gratuit ! Il permet à ces personnes de profiter d'un accueil personnalisé en gare ainsi que d'un accompagnement jusqu'à sa place dans le train (mais pas durant le voyage).</p><p>Mais qui peut profiter du service Accès Plus ?</p><p>Pour les voyages en train nationaux et internationaux : toutes les personnes ayant une mobilité réduite.</p><p>Pour les TER possédant au moins une correspondance : toutes les personnes en possession d'une carte d'invalidité, d'une carte de priorité, de stationnement de véhicule, de pensionnés de guerre ou encore pour les clients se présentant en gare avec leur fauteuil roulant.</p>",
      },
    ],
    relatedQuestions: [
      'voyageur-handicape-mobilite-reduite-reservation-billet',
      'bons-plans-sncf',
    ],
  },
  {
    name: 'remboursement-bon-achat-ouigo',
    title: "Remboursement et bon d'achat OUIGO",
    meta: {
      title: 'Remboursement OUIGO et annulation [Tous les cas]',
      description:
        "Vous avez des questions relatives au remboursement et l'annulation d'un billet OUIGO ? On vous aide en direct !",
    },
    category: ['service-apres-vente'],
    updatedDate: '10/06/2024',
    content: [
      {
        type: 'body',
        content:
          "<p>Vous venez de <a href='/company/train/sncf/ouigo/reservation'>réserver un billet Ouigo</a> ou vous comptez le faire d'ici peu ? Peu importe la raison pour laquelle vous souhaitez <strong>annuler</strong> un billet et en obtenir le <strong>remboursement</strong>, vous allez découvrir dans cette rubrique les différentes possibilités en matière de remboursement chez <em>OUIGO</em>.</p>",
      },
      {
        type: 'img',
        content:
          'service-apres-vente_homme-lunettes-train-bleu-remboursement-ouigo.jpg',
        alt: 'homme lunettes train bleu remboursement ouigo',
      },
      {
        type: 'title',
        content: 'Les conditions pour obtenir un remboursement Ouigo',
      },
      {
        type: 'body',
        content:
          "<p><a href='/company/train/sncf/ouigo'>OUIGO</a> est une compagnie low cost vous permettant de voyager à des tarifs préférentiels. C’est pourquoi les billets ne sont <strong>pas annulables</strong> donc <strong>pas remboursables</strong>.</p><p>Vous pouvez tout de même avoir le remboursement de votre billet si votre train a au minimum <strong>1h de retard</strong>. Sous ce minimum, vous n’avez pas le droit à une compensation. Autrement :<ul><li><p>Retard entre <strong>1h et 1h59</strong> à l’arrivée : remboursement à hauteur de <strong>25%</strong> du prix du billet uniquement concerné par le retard</p></li><li><p>Retard de <strong>plus de 2h</strong> à l’arrivée : remboursement à hauteur de <strong>50%</strong>  du prix du billet uniquement concerné par le retard</p></li></ul></p>Attention les options ou les animaux ajoutés ne sont pas pris en compte dans le remboursement.</p><p>Vous pouvez également obtenir un remboursement si votre train a dû être annulé et qu’aucune solution proposée par OUIGO ne vous convenait.</p>",
      },
      {
        type: 'title',
        content: 'Comment recevoir mon remboursement Ouigo',
      },
      {
        type: 'body',
        content: `<p>Si votre demande se trouve parmi les conditions ci-dessus, vous pourrez alors entamer la <strong>procédure</strong> pour percevoir votre remboursement.</p><p>En premier lieu, rendez-vous sur la <strong>plateforme</strong> de remboursement Ouigo en vous munissant de votre <strong>numéro de réservation</strong> situé sur votre billet ou reçu dans le mail de confirmation et de l’<strong>adresse mail</strong> utilisée.</p><p>Ensuite, deux cas de figure s’offre à vous :<ul><li><p>Recevoir un <strong>bon d’achat</strong></p></li><li><p>Se faire recréditer le montant sur <strong>son compte bancaire</strong></p></li></ul></p><p>Selon votre choix, il faudra se rendre sur la page <a href='https://ventes.ouigo.com/fr-FR/booking/login'><q> mes réservations OUIGO </q></a> et entrer vos <strong>informations de réservation</strong>. Vous pouvez alors choisir d’obtenir un bon d’achat ou un recrédit bancaire.<br>Si vous avez acheté votre billet chez <em>Tictactrip</em>, notifiez-nous de l’annulation via le <a href='${NAVIGATION.SUPPORT}'>formulaire de contact</a> afin qu’on puisse par la suite vous rembourser.</p>`,
      },
      {
        type: 'title',
        content: "Les différents cas d'annulation Ouigo",
      },
      {
        type: 'body',
        content:
          "<p>Malheureusement, il faut déjà noter que les billets Ouigo ne sont pas annulables. C'est aussi pour cette raison que vos billets Ouigo sont si peu chers.</p><p>Par contre, dans le cas d'un retard Ouigo, remboursement de 25% lorsque le train à entre 1h et 1h59 de retard.</p><p>Autrement, pour un retard de plus de 2h, vous serez remboursés de 50% du montant total du billet de train sans les options.</p><p>Enfin, l'annulation Ouigo n'est pas envisageable mais vous pouvez toujours échanger votre billet avec le service OuigoSWAP. C'est une bonne solution pour éviter de perdre de l'argent lorsque vous ne pouvez pas voyager.</p>",
      },
    ],
    relatedQuestions: ['bagages-ouigo'],
  },
  {
    name: 'objet-perdu-bus',
    title: "J'ai perdu un objet dans mon bus, que faire ?",
    meta: {
      title: 'Objet perdu Bus - Que faire ? [Étape par Étape]',
      description:
        "Vous avez récemment voyagé en bus et vous êtes aperçu d'un objet perdu dans le bus ? Découvrez les solutions faciles.",
    },
    category: ['service-apres-vente'],
    updatedDate: '05/03/2021',
    content: [
      {
        type: 'img',
        content:
          'service-apres-vente_objet-perdu-bus-que-faire-cles-perdues.jpg',
        alt: 'objet perdu bus - que faire - cles perdues',
      },

      {
        type: 'body',
        content:
          "<p>Vous avez récemment voyagé avec une compagnie de bus et vous êtes aperçu après votre voyage de l'oubli d'un objet à bord ?</p><p>Découvrez comment contacter la compagnie en question et comment récupérer votre objet perdu bus !</p>",
      },

      {
        type: 'title',
        content: 'Objet trouvé Blablabus - Que faire ?',
      },

      {
        type: 'body',
        content:
          "<p>Chez Blablabus, si vous avez oublié un objet à bord du bus, il vous sera possible de le récupérer. Encore heureux nous direz-vous !</p><p>Pour entamer le processus de récupération de votre <strong>objet trouvé Blablabus</strong>, vous n'aurez qu'à remplir un formulaire. Pour le remplir, <a href=\"https://help.blablabus.com/hc/fr/requests/new\">cliquez ici</a> !</p><p>Dans ce formulaire, pensez à choisir le souci suivant : \"Bagages perdus/oubliés\".</p><p>Afin de trouver le plus facilement et rapidement possible votre bien, un certain nombre d'informations vous seront demandées. À savoir : <ul><li><p>Des renseignements concernant votre voyage : Référence de réservation, Numéro de votre bus, origine et destination du voyage ainsi que la date de votte voyage.</p></li><li><p>Des informations concernant votre identité : votre nom de famille et prénom, votre adresse e-mail ainsi que votre numéro de téléphone.</p></li><li><p>Enfin des renseignements concernant l'objet perdu et potentiellement retrouvé : Le type d’objet concerné par votre demande, la couleur de celui-ci, l'endroit où se trouvait l'objet durant votre voyage (en soute ou à l'intérieur du bus) et enfin la marque de votre objet perdu.</p></li></ul></p><p>Une fois tous ces renseignements fournis, l'équipe de Blablabus commencera des recherches approfondies et vous recontactera pour vous tenir au courant.</p>",
      },

      {
        type: 'title',
        content: 'Objet trouvé Flixbus - Que faire ?',
      },

      {
        type: 'body',
        content:
          '<p>Flixbus vous offre une solution rapide pour accèder aux Flixbus objets trouvés.</p><p>Dans un premier temps, vous devrez inscrire votre objet perdu Flixbus via ce <a href="https://help.flixbus.com/s/article/PSSP-Jai-oubli%C3%A9-quelque-chose-dans-le-bus-Que-doisje-faire?language=fr">Flixbus formulaire objet perdu.</a></p><p>Pour remplir ce formulaire, il vous suffit de cliquer sur le bouton "Nous contacter" et de remplir le formulaire. Pesnez à bien y indiquer un maximum d\'informations concernant votre objet perdu, afin qu\'il soit facilement identifiable par l\'équipe Flixbus.</p><p>Ensuite, rendez-vous sur le <a href="https://www.flixbus.fr/services/verification-de-statut-objets-perdus-trouves">site des objets trouvés Flixbus</a>. En entrant votre numéro de réservation vous accèderez à la liste des objets trouvés et vous pourrez suivre les recherches de votre objet à bord du bus pour votre voyage passé. En espérant que votre bien s\'y trouve...</p>',
      },

      {
        type: 'title',
        content:
          "Comment faire pour ne pas oublier d'objet pendant votre voyage en bus ?",
      },

      {
        type: 'body',
        content:
          "<p>Bien sûr, il existe quelques astuces pour éviter d'oublier ses affaires à bord des bus lors de vos voyages. Vous dire d'éviter d'être tête en l'air n'est pas vraiment un conseil... Mais on peut y remédier ! Voici comment.</p><p>Tout d'abord, commencez par voyager léger. Car qui dit peu d'affaires dit aussi moins de chances de perdre vos bagages en bus. Vous pouvez aussi éviter de sortir vos affaires de votre bagage à main. Ainsi, si vous n'oubliez pas votre valise en soute, vous repartirez bel et bien avec l'ensemble de vos affaires !</p><p>Autrement, vous pouvez demander à votre voisin.e de vous rappeler de ne pas oublier telle ou telle affaire lors de votre départ... Cela peut toujours vous aider.</p><p>Aussi, peut-être que vous mettre un rappel et/ou une alarme sur votre téléphone peut vous permettre de ne rien oublier à votre arrivée à destination !</p><p>Enfin, pensez à étiquetter vos bagages et potentiellement chacune des affaires que vous êtes certain de sortir durant votre voyage. Ainsi, même si vous oubliez un objet à bord du bus, celui-ci sera facilement identifiable par l'équipe de la compagnie de bus !</p>",
      },
    ],
    relatedQuestions: ['service-apres-vente-flixbus', 'bagages-ouigo'],
  },
  {
    name: 'voyage-enfant-mineur-seul',
    title: 'Mes enfants peuvent-ils voyager seuls ?',
    meta: {
      title: 'Un enfant mineur peut-il voyager seul en train ?',
      description:
        'Découvrez les conditions de voyage pour un enfant mineur seul, en fonction des compagnies de transport.',
    },
    category: ['conditions-de-voyage-tarifs-compagnies'],
    updatedDate: '24/02/2021',
    content: [
      {
        type: 'img',
        content:
          'conditions-de-voyage-tarifs-compagnies_voyage-enfant-mineur.jpg',
        alt: 'voyage enfant mineur',
      },

      {
        type: 'body',
        content:
          "<p>Pour quelque raison que ce soit, vous aimeriez savoir s'il est possible pour votre enfant mineur de voyager seul ?</p><p>En effet, c'est une question qui peut se poser, d'autant plus que les conditions de voyages peuvent différer en fonction des compagnies...</p><p>Mettons la lumière sur cette question sans plus attendre !</p>",
      },

      {
        type: 'title',
        content: 'SNCF:  enfant seul et voyage',
      },

      {
        type: 'body',
        content:
          "<p>Chez la SNCF et à bord des trains de ses différentes marques, les conditions de voyage des mineurs seuls peuvent varier légèrement. Découvrez les à la suite, ainsi que les services d'accompagnement dédiés de la SNCF.</p>",
      },

      {
        type: 'subtitle',
        content: "Voyage d'un enfant Ouigo",
      },

      {
        type: 'body',
        content:
          "<p>La compagnie Ouigo est très stricte concernant le voyage des mineurs seuls. En effet, la compagnie de train low-cost n'accepte pas les enfants de moins de 12 ans à la date du voyage, pour voyager seuls. Ces enfants seront donc obligatoirement accompagnés d'un adulte pour voyager.</p><p>De plus, le service d'accompagnement Junior & Cie de la SNCF n'est pas disponible pour les TGV Ouigo.</p>",
      },

      {
        type: 'subtitle',
        content: 'Conditions de voyage enfant - TGV InOui',
      },

      {
        type: 'body',
        content:
          "<p>Tout d'abord, il faut savoir que les enfants mineurs de moins de 12 ans ne peuvent pas voyager seuls en train. Il devront obligatoirement être accompagnés d'un adulte. Il s'agit là de mesure de sécurité.</p><p>C'est pourquoi la SNCF a mis en place le service d'accompagnement Junior & Cie SNCF. Ce service, disponible uniquement pour les voyages en TGV inOui vous propose l'accompagnement de votre enfant de 4 à 14 ans par un animateur accrédité. Il sera au sein d'un groupe de plusieurs enfants pour être bien entouré et que son voyage se déroule au mieux, rapidement.</p><p>L'animateur prendra en charge la totalité du voyage, procédera à l'enregistrement de votre enfant et ne le laissera repartir qu'avec la personne désignée comme resonsable pour récupérer votre enfant, à l'aide d'une pièce d'identité, bien entendu.</p>",
      },

      {
        type: 'subtitle',
        content: "Voyage d'un enfant seul - TER",
      },

      {
        type: 'body',
        content:
          '<p>Comme pour tous les trains, vos enfants de moins de 12 ans ne pourront pas voyager seul en TER et devront être accompagnés obligatoirement.</p><p>Les enfants âgés de plus de 12 ans devront donc être munis des documents nécessaires, comme indiqué plus bas.</p>',
      },

      {
        type: 'subtitle',
        content: 'Voyage seul pour un enfant - Intercités',
      },

      {
        type: 'body',
        content:
          "<p>Au sein des trains Intercités, la même règle de voyage des enfant mineurs s'applique.</p><p>Pour les enfants de 11 ans et moins, il sera impossible qu'ils voyagent seuls. Ces enfants devront être accompagnés à bord des trains Intercités.</p><p>Les enfants plus âgés pourront voyager seuls s'ils disposent des documents nécessaires pour prouver leur âge, identité et titre de transport.</p>",
      },

      {
        type: 'title',
        content: 'Conditions de voyage pour les enfants seuls - Lyria',
      },

      {
        type: 'body',
        content:
          "<p>Chez Lyria, vous aurez la chance de pouvoir profiter du service d'accompagnement de la SNCF : <a href=\"https://juniorcie.oui.sncf/\">Junior & Cie</a> !</p><p>Attention cependant, ce service n'est accessible que lors des périodes de vacances scolaires et pour les trajets : <ul><li><p>TGV Lyria Paris Genève (et inversement),</p></li><li><p> TGV Lyria Paris Bâle (et inversement).</p></li></ul></p><p>Bien entendu, ce service est disponible pour tous les accompagnements d'enfants âgés de 4 ans à 14 ans.</p><p>Autrement, les voyageurs âges de plus de 12ans peuvent voyager seuls à bord des trains Lyria.</p><p>Pour ceux ayant 11 ans et moins, il devront obligatoirement être accompagnés d'un adulte.</p>",
      },

      {
        type: 'title',
        content: 'Voyage en train pour un enfant seul - Thalys',
      },

      {
        type: 'body',
        content:
          "<p>Chez Thalys, les mêmes règlementations du voyage des enfants mineurs seuls s'appliquent. À savoir, les enfants mineurs de moins de 12 ans ne peuvent pas voyager seuls en train. Ils devront obligatoirement être accompagnés par un adulte.</p><p>Les enfants plus vieux peuvent voyager seuls, à condition bien sûr qu'il disposent de documents de voyage en règle.</p>",
      },

      {
        type: 'title',
        content: 'Voyage enfant mineur - Eurostar',
      },

      {
        type: 'body',
        content:
          "<p>Chez Eurostar, s'appliquent les conditions de voyage des compagnies de transport ferroviaires en France, à savoir :<ul><li><p>Les enfants de moins de 12 ans doivent obliagtoirement être accompagnés par un adulte.</p></li><li><p>Les enfants mineurs de 12 ans et plus peuvent voyager seuls s'ils disposent des documents nécessaires.</p></li></ul></p><p>De plus, comme nous le dit le <a href=\"https://www.demarches.interieur.gouv.fr/particuliers/quels-documents-mineur-etranger-peut-il-sortir-france\">site du Gouvernement</a>, pour le voyage d'un enfant Eurostar, celui-ci devra :<ul><li><p>être muni d'une carte d'identité ainsi que d'une autorisation de sortie du territoire ou bien d'un passeport en cours de validité.</p></li><li><p>À l'arrivée du train Eurostar en gare de Londres, l'enfant devra être récupéré par la personne dont les coordonnées auront été communiquées au préalable lors du contrôle des autorités britanniques.</p></li></ul></p>",
      },

      {
        type: 'title',
        content:
          "Quels sont les documents à avoir pour le voyage en train d'un enfant mineur seul ?",
      },

      {
        type: 'body',
        content:
          "<p>Si votre enfant, obligatoirement âgé de 12 ans et plus pour voyager seul, s'apprête à partir, pensez bien à lui fournir : <ul><li><p>Son titre de transport valide, que vous pouvezz réservé sur Tictactrip à un prix avantageux !</p></li><li><p>Une carte d'identité ou passeport valide afin de prouver son âge et son identité.</p></li><li><p>Une autorisation parentale de sortie de territoire (AST) en fonction de la destination du voyage, au format du document CERFA téléchargeable <a href=\"https://www.formulaires.modernisation.gouv.fr/gf/cerfa_15646.do\">ICI</a>,</p></li><li><p>une photocopie du titre d'identité de l'un de ses parents,</p></li><li><p>un visa,</p></li><li><p>et un certificat de vaccination.</p></li></ul></p>",
      },
    ],
    relatedQuestions: ['billet-train-enfant', 'comment-reserver-billet-enfant'],
  },
  {
    name: 'choisir-sa-place-train',
    title: 'Comment choisir sa place à bord de mon train ?',
    meta: {
      title: 'Choisir sa place dans un train [Guide COMPLET]',
      description:
        "Découvrez simplement comment choisir votre place à bord d'un train pour vos futurs voyages.",
    },
    category: ['recherche-reservation-billets'],
    updatedDate: '19/02/2021',
    content: [
      {
        type: 'img',
        content: 'recherche-reservation-billets_choisir-place-train.jpg',
        alt: 'choisir sa place dans un train',
      },

      {
        type: 'body',
        content:
          "<p>Vous vous apprêtez à voyager à bord d'un train mais vous aimeriez obtenir un peu plus de précisions ? Vous êtes au bon endroit !</p><p>Avant de réserver sa place, il est important de connaitre vos conditions de voyage et donc savoir s'il vous est possible de choisir votre place à bord d'un train.</p><p>Malheureusement, cela n'est pas le cas à bord de tous les types de train. On vous explique tout à la suite, par type de compagnie.</p>",
      },

      {
        type: 'title',
        content: 'Choix de place train SNCF',
      },

      {
        type: 'body',
        content:
          "<p>Parmi les marques de trains de la SNCF, il est possible chez certaines, de choisir son placement à bord. Cependant vous l'aurez compris, ce n'est pas le cas pour toutes. Découvrons les conditions au cas par cas.</p>",
      },

      {
        type: 'subtitle',
        content: 'Placement Ouigo',
      },

      {
        type: 'body',
        content:
          "<p>Au sein des trains low-cost de la SNCF, les TGV Ouigo, il vous est possible de profiter d'une <strong>place tranquille Ouigo</strong>. En effet il existe trois types de places distincts chez Ouigo : <ol><li><p>Les places standards,</p></li><li><p>les places avec prise électrique,</p></li><li><p>et les places tranquilles.</p></li></ol></p><p>Bien entendu, il vous est possible de choisir votre placement Ouigo, les places autres que \"standards\" seront soumises à un supplément tarifaire (bien qu'il ne soit pas très élevé).</p><p>Enfin, il n'est pas encore possible de choisir son placement exact chez Ouigo, mais vous êtes sûr d'avoir une place assise ! </p><p>Si vous voyagez entre amis ou en famille et que vous réservez l'ensemble des billets en même temps, Ouigo le prendra en compte et tentera de vous réserver un \"carré\" ou du moins des places côte à côte.</p><p>Si vous n'êtes cependant pas placés à côté en raison de réservations distinctes, nous vous invitons à vous rendre auprès du service Ouigo à bord. Ils se feront un plaisir de vous aider et d'arranger la situation.</p><p>À savoir, il n'y a pas de place 1ère classe Ouigo.</p>",
      },

      {
        type: 'subtitle',
        content: 'Placement InOui',
      },

      {
        type: 'body',
        content:
          "<p>À bord des trains TGV InOui de la SNCF, il existe deux types de classe : <ul><li><p>La 1ère classe InOui avec des sièges seuls isolés, des sièges à 2 ou à 4.</p></li><li>La 2nde classe InOui avec des sièges côte à côte ou en carré.</p></li></ul></p><p>Bien entendu, en fonction de la classe choisie, le prix de votre billet variera. Les sièges des TGV InOui peuvent s'incliner facilement et contenir une tablette escamotable, disposé de prises électriques en 1ère classe...</p><p>Aussi, il existe un espace Business Première InOui, où vous pourrez travailler, mener à bien une réunion ou vous reposer dans le plus grand calme ! Cet espace est réservé aux voyageurs Premiums Première Classe InOui et pour les destinations suivantes : <ul><li><p>Paris,</p></li><li><p>Lille Flandres,</p></li><li><p>Bordeaux,</p></li><li><p>Lyon,</p></li><li><p>Marseille,</p></li><li><p>Montpellier,</p></li><li><p>Nantes,</p></li>Rennes,</p></li><li><p>Strasbourg.</p></li></ul></p><p>Également, il vous est possible de choisir votre siège InOui parmi un grand nombre de paramètres comme par exemple le sens du train, plutôt côté couloir ou fenêtre... À vous de choisir votre placement InOui !</p>",
      },

      {
        type: 'subtitle',
        content: 'Placement Intercités',
      },

      {
        type: 'body',
        content:
          "<p>Pour les trains Intercités, la réponse est plus dure à donner. En effet, certains Intercités ne jurent que par le placement libre à bord,  d'autres sont uniquement sur réservation et offrent la possibilité de choisir sa place dans le sens du train par exemple. C'est le cas de l'ensemble des trajets Intercités mise à part pour les voyages de Marseille à Nice ainsi qu'entre Narbonne et Cerbère. Bien entendu, le choix de la place est conditionné à la limite des places disponibles.</p><p>Il apparaît donc qu'il est tout à fait possible, pour vous de réserver votre place Intercités dans la plupart des trains !</p><p>En plus, l'application SNCF vous permet de connaitre rapidement les places restantes à bord de votre train Intercités en réservation facultative. Vous allez adorer voyager en train !</p><p>Enfin, dans les trains Intercités, il existe des places en 1ère classe, des places en carré, des places côte à côte... bref un grand choix de diversité pour combler tous vos besoins !</p>",
      },

      {
        type: 'subtitle',
        content: 'Placement TER',
      },

      {
        type: 'body',
        content:
          "<p>Pour votre voyage en train TER, vous n'aurez malheureusement pas la chance de choisir votre place. Effectivement, à bord de ces trains, une seule règle d'or est applicable : 1er arrivé, 1er servi !</p><p>Eh oui, avec TER, le placement est libre. Vous ne pourrez donc pas réserver votre place. Mais pour avoir la chance de choisir, vous n'aurez qu'à arriver tôt en gare. Pas besoin de payer de supplément donc !</p>",
      },

      {
        type: 'title',
        content: 'Choix de place train Lyria',
      },

      {
        type: 'body',
        content:
          "<p>Pour vos voyages à bord des trains Lyria, vous pourrez aisément choisir vos places. ainsi, si vous voyagez en famille par exemple, pensez à réserver un carré de 4 avec les places Club 4 ou Carré Famille.</p><p>Au sein des trains TGV Lyria, il existe trois types de classes Lyria : <ul><li><p>La classe Standard,</p></li><li><p>La classe standard 1ère,</p></li><li><p>La classe Business 1ère.</p></li></ul></p><p>Chacune de ces classes possèdent des avantages et tarifs différents.</p><p>Enfin, si vous choisissez de réserver un billet Lyria Surréservation, il ne vous sera pas garanti d'avoir une place assise. Cela dépendra des disponibilités.</p>",
      },

      {
        type: 'title',
        content: 'Choix de place train Thalys',
      },

      {
        type: 'body',
        content:
          '<p>Lors de vos réservations Thalys, il vous est possible de choisir votre placement Thalys. En effet, vous aurez le choix du côté : plutôt couloir ou fenêtre ? </p><p>Également, il existe deux classes Thalys :<ul><li><p>La classe Comfort 2 Thalys (2nde classe), qui se compose uniquement de sièges côte à côte.</p></li><li><p>La classe Comfort 1 (1ère classe), au sein de laquelle vous pourrez profiter d\'espaces "Club Quatre" ainsi que d\'espaces "Club Duo". Des places solo et un salon pour vos réunions vous sont aussi accessibles.</p></li></ul></p><p>Enfin, il existe des places isolés des autres. Si vous avez des enfants par exemple, cela vous permettra d\'être tranquille pendant votre voyage Thalys !</p>',
      },

      {
        type: 'title',
        content: 'Choix de place train Eurostar',
      },

      {
        type: 'body',
        content:
          "<p>Lors de vos voyages en eurostar, vous n'aurez malheureusement pas le choix de votre place à bord du train.</p><p>En effet, la compagnie a fait le choix d'attribuer de manière automatique le placement des sièges afin d'assurer une répartition équitable sur l'ensemble de ses trains.</p><p>Cependant, vous aurez le choix sur votre type de billet Eurostar. Il existe: <ul><li><p>La classe standard Eurostar avec 2 valises et 1 bagage à main.</p></li><li><p>La classe standard Premier avec ces mêmes conditions de bagages, ainsi que des sièges spacieux et un repas léger servi à votre place à bord.</p></li><li><p>La classe Business Premier avec ces mêmes services ainsi que des billets remboursables, un repas du chef Étoilé Raymond Blanc accompagné de champagne ainsi qu'un service de réservation de taxi et des salons privatifs à Londres et Paris. La classe quoi.</p></li></ul></p>",
      },

      {
        type: 'title',
        content:
          "Est-il possible de réserver sa place lors d'une réservation sur Tictactrip ?",
      },

      {
        type: 'body',
        content:
          "<p>Malheureusement, nous ne proposons pas encore ce type de service lors de vos réservations sur le site de Tictactrip.</p><p>Comme vous l'avez vu, en fonction des compagnies de transport, les conditions de réservation et de choix des places diffèrent, c'est ce qui rend la tâche ardue.</p><p>Mais pas d'inquiétudes ! C'est dans nos projets à venir.</p><p>Pour être directement au courant de l'arrivée de cette possibilité, inscrivez-vous à notre newsletter !</p>",
      },
    ],
    relatedQuestions: [
      'animal-compagnie-a-bord-du-bus',
      'connexion-WIFI-train-bus',
    ],
  },
  {
    name: 'reservation-billet-non-recu',
    title: "J'ai réservé mais je n'ai pas reçu de billet, que faire ?",
    meta: {
      title: 'Les différents cas de figure justifiant un billet non reçu',
      description:
        "Découvrez les différentes raisons pour lesquelles vous n'avez pas reçu votre billet",
    },
    category: ['recherche-reservation-billets'],
    updatedDate: '28/02/2021',
    content: [
      {
        type: 'body',
        content:
          '<p>Après avoir réservé simplement et en 3 clics sur <em>Tictactrip</em> vous voilà confronté à un problème… Vous n’avez <strong>pas reçu votre billet</strong> ! Pris de panique, vous vous demandez alors si vous pourrez visiter votre grande tante en Ardèche ou encore rejoindre votre moitié sur la Côte d’Azur.</p><p>Quoi qu’il en soit il vous faut une solution rapide afin de <strong>recevoir votre billet</strong> et ainsi pouvoir voyager dans les meilleures conditions possibles et sans stress.<br> Vous voilà dans la bonne rubrique !</p>',
      },

      {
        type: 'title',
        content: 'Pourquoi n’ai-je pas reçu mon billet ?',
      },

      {
        type: 'body',
        content:
          '<p>En voilà une question ! Cela peut-être fâcheux que tout ne se passe pas comme prévu, d’autant plus que sur <em>Tictactrip</em> tout a été pensé pour vous faciliter la tâche.<br>Ainsi, vous allez découvrir les différentes raisons qui font que vous n’avez pas reçu votre billet.</p>',
      },

      {
        type: 'subtitle',
        content: 'Un paiement refusé',
      },

      {
        type: 'body',
        content:
          '<p>Votre billet a pu ne pas avoir été réservé tout simplement car votre <strong>paiement a été refusé</strong> par votre banque. Un message s’affiche alors vous invitant à réitérer le paiement.<br> Si le problème persiste, n’hésitez pas à contacter votre banque.</p><p>En effet, cela peut être un problème de plafond, de provision ou que vous vous êtes tout simplement trompé en tapant vos informations bancaires. Vous pouvez également, si vous en avez la possibilité, réessayer avec une autre carte bancaire.</p>',
      },

      {
        type: 'subtitle',
        content: 'Une erreur survenue',
      },

      {
        type: 'img',
        content:
          'recherche-reservation-billets_erreur-survenue-contacter-support.jpg',
        alt: 'erreur survenue contacter support',
      },

      {
        type: 'body',
        content:
          '<p>Un <strong>message d’erreur</strong> peut également s’afficher sur la page de confirmation et vous ne recevez pas un ou l’ensemble des billets de votre réservation. Dans ce cas là, il suffit simplement de nous contacter en cliquant sur le bouton <q> cliquez ici pour contacter le support </q>. Notre équipe du service client vous répondra dans les plus brefs délais.</p><p>Ce type d’erreur est souvent dû à un problème de remontée de billets entre nous et le transporteur. Pas d’inquiétude, il est très facile pour nous de les récupérer et de vous les envoyer à votre demande.</p>',
      },

      {
        type: 'subtitle',
        content: 'Une adresse mail erronée',
      },

      {
        type: 'body',
        content:
          '<p>Dans l’excitation et la précipitation de votre réservation vous écrivez <q> .com </q> au lieu de <q> fr </q>. Une erreur classique mais qui peut bien être fâcheuse. Mais nous avons pensé à tout ! Vous pouvez <strong>télécharger votre billet</strong> directement sur la page de confirmation.<br> Certes vous ne le recevrez pas par mail car il n’est pas possible de changer vos informations de réservation mais vous pourrez directement le récupérer et profiter de votre voyage en toute sérénité.</p>',
      },

      {
        type: 'img',
        content: 'recherche-reservation-billets_telecharger-billet.jpg',
        alt: 'télécharger-billet',
      },

      {
        type: 'subtitle',
        content: 'Dans vos spams',
      },

      {
        type: 'body',
        content:
          "<p>N'hésitez pas à vérifier dans vos <strong>courriers indésirables</strong> ou spams avant de nous contacter. Il s’avère que dans certains cas vous ne recevez pas votre billet dans votre boite de réception. Vérifiez donc toujours avant de faire une demande auprès du support pour un billet manquant.<br>De même, s’il s’agit de plusieurs billets, ceux-ci sont attachés sur le même document PDF que vous recevez donc pensez à bien regarder tout le document en entier.</p>",
      },

      {
        type: 'subtitle',
        content: 'Une réservation sur un autre site',
      },

      {
        type: 'body',
        content:
          '<p>Parfois vous pensez avoir réservé sur <em>Tictactrip</em> mais ce n’est pas le cas… Ce qui explique pourquoi nous ne pouvons pas vous aider. En effet, nous n’avons pas de trace de réservations externes aux nôtres sur notre système. Le plus simple est donc de contacter le service client du site concerné.<br>Pour vous aider, sachez que si vous réserver chez Tictactrip, votre <strong>numéro de réservation</strong> est une suite de chiffres et de lettres composée de 16 caractères.</p>',
      },

      {
        type: 'subtitle',
        content: 'Une réservation OUIGO',
      },

      {
        type: 'body',
        content:
          '<p>Si vous avez réservé un billet <em>OUIGO</em>. Il se peut que vous ne le recevez pas sur votre boite mail. Dans certains cas c’est tout à fait normal : les billets OUIGO sont envoyés <strong>4 jours avant le départ</strong> de votre train.<br> Par contre si votre réservation a été effectuée à moins de 4 jours du départ n’hésitez pas à nous contacter via le support afin qu’on puisse vous renvoyer votre billet.</p>',
      },

      {
        type: 'subtitle',
        content: 'Un transport complet',
      },

      {
        type: 'body',
        content:
          '<p>Cette situation est la moins drôle. En effet, entre le moment ou vous mettez votre billet dans le panier et celui où vous passez au paiement, la dernière place a déjà été vendu. Cela arrive souvent en période de vacances scolaires où les réservations sont plus nombreuses et sur les réservations de dernière minute.<br>Dans ce cas, contactez-nous via le support et nous vous <strong>rembourserons</strong> le prix du billet.</p><p>N’hésitez pas à nous faire part d’éventuels problèmes qui n’ont pas été mentionnés plus haut. Nous vous répondrons avec plaisir pour vous aiguiller au mieux. Nous vous souhaitons un excellent voyage !</p>',
      },
    ],
    relatedQuestions: ['imprimer-billet-train-bus', 'billet-ouigo-non-recu'],
  },
  {
    name: 'comment-savoir-train-annule',
    title:
      'Circulation des trains - Comment savoir si mon train est annulé ou pas ?',
    meta: {
      title: 'Comment savoir si mon train est annulé ? [Solutions Faciles]',
      description:
        'Vous devez voyager bientôt mais vous vous dites actuellement : "et si mon train ne circule pas ?!". Découvrez simplement comment savoir si votre train est annulé ou s\'il circule bien !',
    },
    category: ['service-apres-vente'],
    updatedDate: '08/04/2021',
    content: [
      {
        type: 'img',
        content:
          'service-apres-vente_comment-savoir-train-annule-gare-londres.jpg',
        alt: 'comment savoir train annule gare londres',
      },

      {
        type: 'body',
        content:
          "<p>Vous devez voyager très prochainement et pour une raison qui vous échappe, vous n'êtes pas sur que votre train circule bien ?</p><p>En effet, les grèves de train, confinement, couvre-feu, ou encore simples pannes du réseau de chemin de fer sont tant de possibilités de dérégulations du trafic ferroviaire et donc d'annulation de votre train...</p>Mais pas d'inquiétudes ! Il existe diverses solutions pour que vous sachiez à tout instant si votre train circule ou si votre train est annulé !</p>",
      },

      {
        type: 'title',
        content: 'Info circulation train OuiGo',
      },

      {
        type: 'body',
        content:
          "<p>Pour obtenir toutes les informations relatives à la circulation de vos trains OuiGo, nous vous invitons à vous rendre directement <a href=\"https://www.sncf.com/fr/itineraire-reservation/recherche-numero-train\">ICI</a>.</p><p>Vous n'aurez alors qu'à renseigner directement votre numéro de réservation Ouigo ainsi que la date de votre départ.</p><p>Toutes les informations concernant le statut de votre trajet : en circulation et prévu à l'heure ou bien train annulé et train supprimé... seront disponibles.</p><p>Enfin, vous pouvez également retrouver ce type d'informations directement sur l'application <a href=\"https://www.sncf.com/fr/itineraire-reservation/informations-trafic/application-sncf\">Assistant SNCF</a>.</p>",
      },

      {
        type: 'title',
        content: 'Circulation Ter - Ter supprimé ou non ?',
      },

      {
        type: 'body',
        content:
          '<p>Vous avez déjà votre billet TER et êtes sous la menace d\'une suppression de votre train TER ? Pas de panique !</p><p>Sachez dans un premier temps que vos billets TER sont valables toute la journée. C\'est déjà une très bonne nouvelle car vous ne perdrez pas d\'argent avec ce train TER supprimé...</p><p>Pour connaître en temps réel la circulation TER de votre région, rendez-vous directement sur le site qui vous concerne : <ul><li><p><a href="https://www.ter.sncf.com/auvergne-rhone-alpes">TER Auvergne-Rhône-Alpes</a>.</p></li><li><p><a href="https://www.ter.sncf.com/bourgogne-franche-comte">TER Bourgogne-Franche-Comté</a>.</p></li><li><p><a href="https://www.ter.sncf.com/bretagne">TER Bretagne</a>.</p></li><li><p><a href="https://www.ter.sncf.com/centre-val-de-loire/horaires/info-trafic-greve-sncf-ter">TER Centre-Val de Loire</a>.</p></li><li><p><a href="https://www.ter.sncf.com/grand-est">TER Grand Est</a>.</p></li><li><p><a href="https://www.ter.sncf.com/hauts-de-france/gares/recherche/prochains-departs">TER Hauts-de-France</a>.</p></li><li><p><a href="https://www.ter.sncf.com/normandie">TER Normandie</a>.</p></li><li><p><a href="https://www.ter.sncf.com/nouvelle-aquitaine">TER Nouvelle Aquitaine</a>.</p></li><li><p><a href="https://www.ter.sncf.com/occitanie/horaires/info-trafic-ter">TER Occitanie</a>.</p></li><li><p><a href="https://www.ter.sncf.com/pays-de-la-loire/horaires/recherche">TER Pays de la Loire</a>.</p></li><li><p><a href="https://www.ter.sncf.com/sud-provence-alpes-cote-d-azur">TER Provence-Alpes-Côte d\'Azur</a>.</p></li></ul></p><p>Autrement, vous pouvez aussi vous renseigner en suivant le compte Twitter TER de votre région ou directement sur l\'application Assistant SNCF - Info Trafic !</p>',
      },

      {
        type: 'title',
        content:
          'Eurostar Annulé - Circulation TGV InOui - Trains Intercités supprimés - Trains annulés Thalys - Circulation TGV lyria',
      },

      {
        type: 'body',
        content:
          "<p>Pour l'ensemble de ces compagnies de train rattachées de près ou de loin à la SNCF, les solutions sont les mêmes pour savoir si votre train circule.</p><p>En effet, Pour connaitre la circulation de votre TGV InOui, avoir des informations quant à un train Eurostar annulé ou un train Intercités supprimé, un train annulé Thalys ou encore pour en savoir plus sur la circulation TGV Lyria, il vous suffira de : <ol><li><p>vous rendre sur <a href=\"https://www.sncf.com/fr/itineraire-reservation/recherche-numero-train\">cette page</a>.</p></li><li><p>Puis d'y indiquer votre numéro de réservation (que vous retrouverez sur votre billet) ainsi que votre date de départ initiale.</p></li></ol></p><p>Autrement, vous pouvez aussi bien utiliser directement la recherche de trajet sur Tictactrip ou Oui.SNCF. Ainsi, en recherchant votre trajet, vous aurez le statut du train et ses horaires.</p><p>De plus, vous pouvez retrouver les informations concernant votre train sur l'application Assistant SNCF.</p><p>Enfin, la dernière solution, si vous êtes adepte de Twitter, est de suivre le compte de la SNCF dédiée et/ou de rechercher les tendances par rapport à votre trajet.</p>",
      },

      {
        type: 'title',
        content: 'Besoin de voyager malgré un train supprimé ?',
      },

      {
        type: 'subtitle',
        content: 'Les solutions alternatives de transport',
      },

      {
        type: 'body',
        content:
          '<p>Sapristi, tous les trains sont supprimés et vous avez un besoin urgent de vous déplacer... Heureusement, il existe des solutions alternatives de qualité !</p><p>Sur votre plateforme de réservation Tictactrip, vous pouvez aisément comparer et combiner les offres de bus et covoiturage pour pallier aux suppressiosn de trains.</p><p>Découvrez nos offres !</p>',
      },
    ],
    relatedQuestions: ['train-eurostar-annule', 'train-retard-remboursement'],
  },
  {
    name: 'perte-oubli-objets-train',
    title: "J'ai perdu ou oublié un objet dans mon train",
    meta: {
      title: 'Vous avez perdu ou oublié un objet dans le train ?',
      description:
        "Suite à la perte d'un objet à bord de votre train, vous garder espoir de pouvoir le retrouver. Voici la procédure à suivre pour le retrouver dans les meilleurs conditions. ",
    },
    category: ['service-apres-vente'],
    updatedDate: '02/04/2021',
    content: [
      {
        type: 'img',
        content:
          'service-apres-vente_objet-perdu-train-ordinateur-soleil-macbook.jpg',
        alt: 'objet-perdu-train-ordinateur-soleil-macbook',
      },
      {
        type: 'body',
        content:
          "<p>Vous avez effectué un super voyage et vous en avez encore des étoiles plein les yeux. Dans l'euphorie de rentrer à votre domicile, vous avez <strong>oublié</strong> votre chapeau ou encore pire votre appareil photo sur le siège du TGV. Tous vos souvenirs sont comme envolés et vous vous demandez alors si vous pourrez <strong>récupérer</strong> vos objets si précieux oubliés à bord de votre train.</p><p>Nous allons vous indiquer comment avoir une chance de retrouver votre bien selon la compagnie de train dans laquelle vous avez oublié votre objet.</p>",
      },
      {
        type: 'title',
        content: 'Procédure à suivre selon les compagnies',
      },
      {
        type: 'body',
        content:
          "<p>En soi, toutes les procédures pour retrouver un objet perdu sont plus ou moins semblables. Il faut souvent se rendre directement en <strong>guichet</strong>, ou contacter le service des objets perdus par <strong>téléphone</strong> ou par <strong>mail</strong>.</p><p>Nous vous laissons découvrir ci-dessous, selon la compagnie concernée, les solutions qui s'offrent à vous afin de pouvoir récupérer votre bien dans les meilleures conditions.</p>",
      },
      {
        type: 'subtitle',
        content: 'Objet oublié dans un train SNCF',
      },
      {
        type: 'body',
        content:
          "<p>Deux options s'offrent à vous si vous avez oublié un objet dans un TGV, un intercité, un TER ou encore un OUIGO :<ul><li><p>Vous rendre dans un bureau d'objets trouvés en gare</p></li><li>Remplir <a href=\"https://www.garesetconnexions.sncf/fr/service-client/a-vos-cotes/objet-perdu-trouve/declaration-perte\">ce formulaire</a> en ligne</p></li></ul></p><p>Sachez que tous les objets qui ne sont pas périssables sont gardés pendant maximum un mois. Ne tardez donc pas trop à faire une réclamation. De même, remplissez bien le formulaire de réclamation en ne vous trompant pas dans vos informations données afin que l'on vous retrouve plus facilement.</p>",
      },
      {
        type: 'subtitle',
        content: 'Objet oublié dans un train IZY',
      },
      {
        type: 'body',
        content:
          '<p>Chez la compagnie IZY c\'est très simple : il y a uniquement deux destinations Paris ou Bruxelles.<br>Il vous faut donc contacter la gare de destination. Cela se fait <strong>uniquement par téléphone</strong> :<ul><li><p>Gare de Paris : 3635, le standard téléphonique est ouvert de 08h à 20h du lundi au samedi.<br>Vous pouvez également remplir le même formulaire de réclamation que celui pour des trajets SNCF.</p></li><li>Gare de Bruxelles-Midi :<a href="tel:+3222248862">+32 2 224 88 62</a></p></li></ul></p>',
      },
      {
        type: 'subtitle',
        content: 'Objet oublié dans un train Eurostar',
      },
      {
        type: 'body',
        content:
          "<p>Si vous avez oublié quoique ce soit à bord d'un train Eurostar, la procédure est assez simple.<br>Pour tous les objets perdus en <strong>gares françaises</strong> : Paris Gare du Nord, Marne-la-Vallée, Lille-Europe, Avignon, Calais-Fréthum, Moûtiers et Bourg-Saint-Maurice vous pouvez également remplir le même formulaire SNCF qu'évoqué plus haut.</p><p>Concernant les objet perdus en <strong>gare londonienne</strong> : Saint Pacras, Ashford ou Ebbsfleet, il suffit d'envoyer un mail de réclamation à l'adresse suivante : <a href=\"mailto:lost.property@eurostar.com\">lost.property@eurostar.com</a>.</p>",
      },
      {
        type: 'subtitle',
        content: 'Objet oublié dans un train Lyria',
      },
      {
        type: 'body',
        content:
          '<p>Tête en l\'air dans votre train en direction de la Suisse ? Rendez-vous dans le <strong>guichet</strong> de votre gare d\'arrivée. Vous pouvez également remplir <a href="https://lostandfound.sbb.ch/home/sbb/SBB/app/lossrecords/new/items/0/category">ce formulaire</a> qui répertorie tous les objets perdus par catégories. Pratique pour faciliter vos investigations !</p>',
      },
      {
        type: 'subtitle',
        content: 'Objet oublié dans un train Thalys',
      },
      {
        type: 'body',
        content:
          '<p>Si vous avez oublié un objet à bord d\'un train <em>Thalys</em> selon la destination les procédures sont différentes :<ul><li><p>Gare en Belgique : Il y a un formulaire à remplir en suivant <a href="https://www.belgiantrain.be/fr/support/customer-service/lost-item">ce lien</a>. Cependant, dans le formulaire il n\'y a que les <strong>gares intérieures</strong> à la Belgique qui peuvent être sélectionnées. S\'il s\'agit d\'un trajet à l\'international. Vous pouvez tout simplement choisir une gare au hasard et préciser la gare dans la <strong>description</strong> de votre réclamation.</p></li><li>Gare aux Pays-Bas : Vous pouvez soit téléphoner au bureaux des objets trouvés :<a href="tel:+31307515155">+31 30 7515155</a>, soit remplir une réclamation juste <a href="https://www.ns.nl/registratie-ketendienst/verlorenvoorwerpen?0"> ici</a>.</p></li><li>Gare en Allemagne : Remplissez <a href="https://www.bahn.com/fr/contact/perte-de-bagage-formulaire"> ce formulaire</a> afin d\'avoir un espoir de récupérer votre précieux objet. Attention cependant, il faut que l\'objet déclaré est une <strong>valeur minimale de 15€</strong>. Autrement, il ne sera pas enregistré dans la base de données des objets perdus.</p></li></ul></p>',
      },
      {
        type: 'title',
        content: 'Que se passe-t-il ensuite ? ',
      },
      {
        type: 'body',
        content:
          "<p>Une fois que vous avez entamé les démarches de <strong>signalement</strong> de votre objet, il ne reste plus qu'à patienter. Soit par chance, une âme charitable l'a retrouvé et l'a déposé auprès d'un guichet ou d'un agent en gare. Malheureusement, il se peut que votre objet n'ait pas été retrouvé... </p>",
      },
      {
        type: 'subtitle',
        content: 'Votre objet a été retrouvé ',
      },
      {
        type: 'body',
        content:
          "<p>Tout d'abord, un e-mail vous sera envoyé si vous avez effectué votre demande en ligne, confirmant la prise en compte et le début des démarches afin de trouver votre bien. Tous les objets perdus sont <strong>recensés</strong> dans une base de données et selon la description de l'objet les données s'entrecroisent afin de pouvoir être sûr de trouver votre objet précisément et non pas le confondre avec un objet dont la description pourrait être proche.<br>C'est d'ailleurs pour cela qu'il faut que la description soit la plus <strong>précise</strong> possible.</p><p>Lorsque votre objet est retrouvé vous serez contacté par téléphone ou par mail. Vous aurez la possibilité de directement allez le récupérer en <strong>gare</strong> ou de vous le faire livrer à votre <strong>domicile</strong> en payant les frais d'expéditions. Il faudra alors, présenter une carte d'identité pour récupérer l'objet. Il faut également verser une <strong>taxe de restitution</strong> de 5 ou 10€ selon la valeur de l'objet retrouvé.</p>",
      },
      {
        type: 'subtitle',
        content: "Votre objet n'a pas été retrouvé ",
      },
      {
        type: 'body',
        content:
          "<p>Les objets sont gardés <strong>un mois</strong> dans les bureaux s'ils ont été retrouvés. S'ils ne sont pas réclamés il seront remis à l'Administration des Domaines ou détruits. Il se peut aussi que votre objet ait malheureusent été volé donc plus d'espoir pour pouvoir le retrouvé.</p><p>Pour éviter ce type de désagrément, n'hésitez pas à bien <strong>vérifier</strong> votre siège lors de votre arrivée en gare pour être sûr de ne rien avoir oublié. De même, sortez uniquement le <strong>strict nécessaire</strong> durant le voyage pour ne pas que vos affaires soient éparpillées partout.</p><p>Il est également important d'avoir un comportement responsable si à l'inverse nous trouvons un objet. En effet, il faut se mettre à la place de cette pauvre personne qui a perdu son objet et qui souhaiterait avoir un espoir de le récupérer. Il est donc aussi important de <strong>déposer</strong> ou <strong>signaler</strong> tout objet trouvé dans une gare ou à bord d'un train.</p><p>Nous espérons qu'une mésaventure de la sorte ne vous arrivera pas ! Restez prudents et attentifs en gare et à bord de votre train.</p>",
      },
    ],
    relatedQuestions: ['objet-perdu-bus'],
  },
  {
    name: 'calendrier-voyageur',
    title: 'Périodes bleues et blanches TER',
    meta: {
      title: 'Les réductions de billet de TER par période bleue ou blanche',
      description:
        'Vous voulez acheter votre billet de TER au meilleur prix ? Vous voilà sur la bonne page !',
    },

    category: ['conditions-de-voyage-tarifs-compagnies'],
    updatedDate: '26/03/2021',
    content: [
      {
        type: 'img',
        content:
          'conditions-de-voyage-tarifs-compagnies_TER-Calendrier voyageurs-reduction.jpg',
        alt: 'TER-Calendrier voyageurs-réduction',
      },

      {
        type: 'body',
        content:
          '<p>Dans l’optique de toujours vous garantir les meilleurs <strong>bons plans</strong> nous allons vous définir les différentes périodes pour l’achat d’un <strong>billet de TER</strong> classées selon un calendrier.<br>Vous comprendrez alors pourquoi votre billet de TER peut-être plus ou moins cher selon la période donnée. Celles-ci sont classées en périodes bleues et périodes blanches.</p>',
      },

      {
        type: 'title',
        content: 'Période bleue',
      },

      {
        type: 'body',
        content:
          '<p>La période bleue correspond aux heures de faibles affluences. Ainsi, la semaine type est : <ul><li><p>Du Lundi au Jeudi : 00h00-06h30, 08h00-17h00 et 18h30-00h00</p></li><li>00h00-06h30, 08h00-14h00 et 20h00-00h00</p></li><li>Samedi : Toute la journée</p></li><li>Dimanche : 00h00-15h00 et 20h00-00h00</p></li></ul></p><p>Avec la carte de réduction Avantage, Jeune, Week-end, Senior + et Enfant + vous bénéficiez de 50% de réduction sur l’ensemble des billets dont le trajet s’effectue sur les horaires mentionnées ci-dessus.</p><p>Pour les cartes Découvertes 12-25, Découverte Senior, et Découverte Enfant +, une réduction de 25% est applicable.</p><p>Il y a des jours particuliers à prendre en compte sur l’année 2021 où le calendrier habituel diverge :<ul><li><p>Les 1er janvier, 4 avril, 13, 14 et 23 mai : toute la journée</p></li><li>Les 2 janvier, 6, 13, 20 et 27 février, 6 mars, 10, 17 et 24 avril, 1er et 8 mai, 26 juin, 3, 10, 17, 24 et 31 juillet, 7, 14, 21 et 28 août, 16, 23 et 30 octobre et 18 décembre : 00h00 - 08h00 et 14h00 - 00h00</p></li><li>Les 5 avril et 24 mai : 00h00 - 15h00 et 20h00 - 00h00</p></li><li>Le 12 mai : 00h00 - 06h30 , 08h00 - 14h00 et 20h00 - 00h00</p></li></ul></p>',
      },

      {
        type: 'title',
        content: 'Période blanche',
      },

      {
        type: 'body',
        content:
          '<p>La période blanche correspond aux heures de fortes affluences. La semaine type est la suivante :<ul><li><p>Du Lundi au Jeudi : 06h30-08h00 et 17h00-18h30</p></li><li>Vendredi : 06h30-08h00 et 14h00-20h00</p></li><li>Dimanche : 15h00-20h00</p></li></ul></p><p>Les bénéficiaires d’un billet première classe ont le privilège d’obtenir 40% de réduction sur leur billet.</p><p>Il y a jusqu’à 25% de réductions garantis avec les cartes de réduction Avantage.</p><p>Comme mentionné plus haut, les jours particuliers sont également valables pour la période blanche comme suit : <ul><li><p>Les 2 janvier, 6, 13, 20 et 27 février, 6 mars, 10, 17 et 24 avril, 1er et 8 mai, 26 juin, 3, 10, 17, 24 et 31 juillet, 7, 14, 21 et 28 août, 16, 23 et 30 octobre et 18 décembre : 08h00 - 14h00</p></li><li>Les 5 avril et 24 mai : 15h00 - 20h00</p></li><li>Le 12 mai : 6h30 - 8h00 et 14h00 - 20h00</p>Grâce à ces précieuses informations, à vous les meilleurs voyages au meilleur prix ! Ne nous remerciez pas, on fait ça de bon coeur !<br>N’oubliez pas que si vous souhaitez plus d’informations, notre service client est là pour vous. ',
      },
    ],
    relatedQuestions: [
      'services-sncf-avant-depart',
      'retirer-son-billet-de-train',
    ],
  },
  {
    name: 'carte-de-reduction-avantage-SNCF-acceptee-Tictactrip',
    title: 'Cartes Avantages SNCF et réductions SNCF',
    meta: {
      title:
        'Puis-je utiliser ma carte avantage SNCF sur le site de Tictactrip',
      description:
        'Vous avez en votre possession une carte avantage SNCF ou une carte de réduction SNCF vous offrant tarif avantageux sur un trajet de train SNCF. Mais est-elle acceptée sur le site de Tictactrip',
    },
    category: ['recherche-reservation-billets'],
    updatedDate: '26/01/2022',
    content: [
      {
        type: 'body',
        content:
          '<p>En tant que voyageur régulier vous savez que les prix de tous vos allers-retours peuvent vite grimper ! La <em>SNCF</em> propose des <strong>cartes Avantages</strong> vous permettant de faire de grandes économies.</p><p>Avec ces cartes, vous bénéficiez de <strong>réductions</strong> sur les TGV INOUI, INTERCITÉS et TER. L’offre s’étend aussi vers <strong>l’Europe</strong> pour des trajets vers la Suisse, le Luxembourg, l’Italie et l’Allemagne.</p><p>Chez Tictactrip, nous voulons également vous aider dans votre mobilité. Ainsi, vous pouvez utiliser ces cartes de réduction sur notre site.<br>Nous vous partageons les meilleures options qui s’offrent à vous selon votre profil de <strong>voyageur</strong>.</p><p>La grande nouveauté est que vous pouvez acheter ces cartes Avantages directement en contactant le <strong>service client</strong> via notre <a href="https://airtable.com/shrWe3gITjGsJj5OW">formulaire d’achat</a> de <strong>carte avantage SNCF</strong>.</p>',
      },
      {
        type: 'img',
        content:
          'recherche-reservation-billets_main-ordinateur-reservation-reduction-carte-sncf.jpg',
        alt: 'main-ordinateur-reservation-réduction-carte-snc',
      },
      {
        type: 'title',
        content: 'Cartes Avantages SNCF',
      },
      {
        type: 'body',
        content:
          '<p>Différentes cartes sont utilisables sur notre site. Le type de cartes a été simplifié et mis à jour afin de vous permettre de profiter d’un grand nombre d’avantages. Ainsi la <strong>carte Avantage famille</strong> n’est plus commercialisée mais ce n’est pas pour autant qu’il n’a plus de solution pour les familles. </p><p>Au contraire, tous les atouts que vous pouviez retrouver dans cette carte ne sont pas perdus et sont disponibles d’une autre façon dans toutes les cartes de réductions disponibles : carte Liberté, carte Avantage jeune, carte Avantage adulte et carte Avantage senior.</p><p>Concernant la <strong>carte Avantage week-end</strong>, elle n’existe plus non plus et s’est automatiquement transformée en <strong>carte Avantage adulte</strong></p>',
      },
      {
        type: 'subtitle',
        content: 'Les différentes cartes avantages SNCF',
      },
      {
        type: 'body',
        content:
          '<p>Pour <strong>les cartes avantages</strong> listées ci-dessous, les services sont les mêmes. Il n’y a que la typologie de carte qui change :<ul><li><p>Carte Avantage jeune SNCF pour les <strong>12-27 ans</strong></p></li><li>Carte Avantage adulte SNCF pour les <strong>28 - 59 ans</strong></p></li><li>Carte Avantage senior SNCF dès <strong>60 ans</strong></p></li></ul></p><p>Parmi les différents avantages proposés, vous bénéficiez de pourcentage de réduction sur vos billlets  comme suit :<ul><li><p>TGV Inoui & INTERCITÉS : -30% ainsi que sur les billets Prem’s</p></li><li>TER : Bretagne, Nouvelle-Aquitaine, Occitanie, AURA, PACA : - 25% ou - 50%</p></li><li>Normandie, Pays de la Loire : - 30%</p></li><li>Hauts de France, Grand Est, Centre Val de Loire : - 25%</p></li></ul></p><p>L’offre est également valable sur les trains à destinations de l’Europe : Luxembourg, Italie, Allemagne, Suisse, Espagne. Vous avez <strong>60% de réduction</strong> jusqu\'à 3 enfants accompagnants de 4 à 11 ans en seconde et en première classe ainsi que d’autres offres comme -15% sur les services (Ma Location AVIS, Mes bagages, la commande en ligne de la restauration à bord et Junior & cie).</p><p>Un des plus gros avantages de ces cartes est que les prix sont plafonnés en 2nde classe sur TGV INOUI et INTERCITÉS pour l’achat de billet de dernière minute. Ainsi, vous paierez :<ul><li><p>39€ max pour un trajet se situant à moins d’1h30 de la destination</p></li><li>49€ max pour un trajet se situant entre 1h30 et 3h de la destination</p></li><li>79€ max  pour un trajet se situant à plus de 3h de la destination</p></li></ul></p><p>Un billet ne pourras pas coûter plus cher que les tarifs affichés ci-dessus.</p><p>Tarif des Carte Avantage junior, carte Avantage adulte et carte Avantage senior : <strong>49€</strong><br>À noter : Cette carte est rentable dès le premier aller-retour</p><p><a href="https://airtable.com/shrWe3gITjGsJj5OW">Faire une demande d’achat de Carte Avantage</a></p>',
      },
      {
        type: 'subtitle',
        content: 'Carte Liberté',
      },
      {
        type: 'body',
        content:
          '<p>Comme son nom l’indique, elle permet de voyager en toute liberté grâce à ses nombreux <strong>avantages</strong>.</p><p>Pour les trajets en TGV INOUI et INTERCITÉS vous bénéficiez de :<ul><li><p><strong>60%</strong> de réduction sur vos trajets en 2nde classe</p></li><li><strong>45 %</strong> de réduction sur vos trajets en 1ère classe</p></li><li><strong>100%</strong> de vos billets sont <strong>échangeables et remboursables sans frais</strong></p></li></ul></p>Concernant les TER vous avez le droit à :<ul><li><p><strong>50%</strong> de réduction sur vos trajets parmi les régions PACA, Nouvelle-Aquitaine, Pays-de-la-Loire, Bretagne, Normandie</p></li><li><strong>25%</strong> de réduction sur vos trajets des régions Occitanie, AURA, Grand-Est, Haut de France</p></li></ul></p>Enfin, la <em>SNCF</em> a même pensé à vos enfants et vous accorde <strong>50%</strong> de réduction pour un maximum de <strong>3 enfants</strong> vous accompagnant âgés de 4 à 11 ans.</p><p>Vous bénéficierez en plus de services exclusifs en Business Première comme l’Accès Express qui permet l’accès aux files prioritaires lors des embarquements et des files dédiées dans les <strong>boutiques SNCF</strong>. Les salons grand voyageur TGV INOUI sont également à votre disposition. Ces espaces calmes proposent des magazines et de la presse en libres-service, des boissons chaudes et le wi-fi gratuit.</p><p>Tarif de la Carte Liberté : 399€</p><p>À noter : cette carte est destinée aux personnes effectuant au minimum 4 allers-retours par an.</p>',
      },

      {
        type: 'title',
        content: 'Les réductions SNCF',
      },
      {
        type: 'body',
        content:
          '<p>Les réductions ci-dessous sont valables uniquement si vous êtes en possession de la carte Famille Nombreuse, Militaire ou Famille Militaire.</p>',
      },
      {
        type: 'subtitle',
        content: 'Carte Famille Nombreuse',
      },
      {
        type: 'body',
        content:
          '<p>Si vous êtes bénéficiaire d’une carte <strong>Famille Nombreuse</strong> vous pouvez profitez des réductions sur l’ensemble des billets de trains TGV INOUI, INTERCITÉS et TER et pour l’ensemble des membres de la <strong>famille</strong>.</p><p>Le pourcentage de réduction est différent selon le nombre d’enfants au sein du foyer :<ul><li><p><strong>30%</strong> pour une famille avec 3 enfants</p></li><li><strong>40%</strong> pour une famille avec 4 enfants</p></li><li><strong>50% </strong>pour une famille avec 5 enfants</p></li><li><strong>75%</strong> pour une famille avec 6 enfants et plus</p></li></ul></p>',
      },
      {
        type: 'subtitle',
        content: 'Carte Militaire & Famille Militaire',
      },
      {
        type: 'body',
        content:
          '<p>Avec votre carte de <strong>circulation militaire</strong> vous avez le droit à <strong>75%</strong> de réduction sur vos voyages en train.<br>La carte Famille Militaire donne accès à des tarifs <strong>à - 25% ou - 50%</strong> pour vos enfants et votre conjoint(e).</p><p>Vous pouvez donc profitez de pas mal d’offres et de réductions sur notre site.En plus, vous avez le choix de récupérer votre carte au guichet, à une borne SNCF ou à l’avoir de façon dématérialisée sur votre smartphone en réservant directement depuis notre plateforme avec l’aide d’un conseiller.</p>',
      },
    ],
    relatedQuestions: ['politique-annulation-remboursement-billet'],
  },
  {
    name: 'bagage-bus',
    title: 'Quels sont les bagages autorisés pour mes voyages en bus ?',
    meta: {
      title:
        'Quels Bagages Bus sont autorisés pour mon voyage ? - Toutes les réponses',
      description:
        "Besoin d'éclaircissements ? Découvrez quels bagages bus sont autorisés pour vos voyages !",
    },
    category: ['recherche-reservation-billets'],
    updatedDate: '11/05/2021',
    content: [
      {
        type: 'img',
        content: 'recherche-reservation-billets_bagage-bus-autorise.jpg',
        alt: 'bagage bus autorisé - voyageur homme bus sac',
      },

      {
        type: 'body',
        content:
          "<p>Vous vous apprêtez à voyager en bus mais certaines informations sont manquantes pour vous permettre de vous organiser au mieux ?</p><p>Pas de panique concernant les bagages bus autorisés, nous vous donnons à la suite, l'ensemble des informations nécessaires pour savoir comment voyager et quels bagages prendre !</p><p>Découvrez ces informations par compagnie de bus. Ensuite, vous aurez toutes les cartes en main pour passer un superbe voyage !</p>",
      },

      {
        type: 'title',
        content: 'Les bagages bus - BlaBlaCar Bus',
      },

      {
        type: 'body',
        content:
          "<p>La question que vous vous posez certainement c'est bien: combien de bagage BlaBlaBus, enfin plutôt, combien de bagages Bus Blablacar ?</p><p>Et la réponse est très simple : vous aurez droit à un bagage en soute et un bagage à main avec Blablacar Bus.</p>",
      },

      {
        type: 'subtitle',
        content: 'Les bagages à main - BlaBlaCar Bus',
      },

      {
        type: 'body',
        content:
          '<p>Vos bagages à main chez Blablabus sont considérés comment comportant vos effets personnels. Ils peuvent être rangés dans les compartiments au-dessus des sièges ou sous le siège occupé.</p>',
      },

      {
        type: 'subtitle',
        content: 'Les bagages en soute - BlaBlaCar Bus',
      },

      {
        type: 'body',
        content:
          "<p>Pour chaque billet Blablabus, deux bagage Blablabus en soute sont disponibles. Si vous n'en emportez pas avec vous, ce n'est pas grave, c'est le même prix... Également, vous aurez droit à deux bagages à main Bus Blablacar.</p><p>Si vous avez un bagage en soute cependant, il faudra qu'il respecte les blablabus condition bagage suivantes :<ul><li><p>Dimensions : le cumul total des dimensions longueur + largeur + profondeur ne doit pas excéder 200 cm.</p></li><li><p>Poids : votre bagage doit peser au maximum 23 kg</p></li></ul></p><p>Autrement, les poussettes ne sont pas comptabilisées comme étant un bagage et peuvent donc voyager gratuitement (sans ajout de bagage au billet acheté). Aussi, vos bagages doivent être correctement étiquettées avec nom , prénom , numéro de téléphone et adresse du passager. Vos bagages doivent être correctement emballés, dans des valises, sacs qui ferment bien...</p><p>Enfin, pour les bagages fragiles, pensez à les placer dans un emballage adéquat et à signaler ce bagage fragile au Capitaine de bord au moment de l'embarquement.</p>",
      },

      {
        type: 'subtitle',
        content: 'Exceptions des bagages en soute - BlaBlaCar Bus',
      },

      {
        type: 'body',
        content:
          "<p>Vous ne savez pas si vous pouvez voyager avec tel ou tel bagage ? Laissez-nous vous répondre ! Voici une liste des bagages autorisés en soute des bus BlaBlaCar Bus : <ul><li><p>Le matériel de ski, à savoir 1 paire de chaussures de ski + 1 paire de ski/snowboard</p></li><li><p>Le matériel de glisse estival, à savoir la planche de surf, le body surf, le kite surf (planche + voile).</p></li><li><p>Les équipements de Golf si les clubs de golf se trouvent dans un sac de Golf fermé.</p></li><li><p>Les instruments de musiques rangés dans leur étui rigide.</p></li><li><p>Les vélos pliables bus BlaBlaCar.</p></li></ul></p><p>À l'inverse, voici les bagages non autorisés en soute des bus Blabacar Bus :<ul><li><p>Les animaux.</p></li><li><p>Les contenus illégaux et illicites comme les armes ou les stupéfiants.</p></li><li><p>Les éléments combustibles, les batteries avec électrolyte,l'ensemble des feux d´artifices, pétards, autres feux de Bengale, les fusées de détresse, les pistolets factices, les allume-feux ou encore les gaz lacrymogènes.</p></li><li><p>Les réchauds de camping, les bouteilles de gaz, les bouteilles de plongée à oxygène, la peinture, les vernis et la laque, ne sont pas non plus autorisés.</p></li><li><p>Tous les produits chimiques et toxiques, les matières infectieuses, les matériaux radioactifs, les engrais, les désherbants, les pesticides et les insecticides sont aussi inévitablement interdits.</p></li><li><p>Enfin, les décapants, l'eau de Javel, le chlore, la lessive et l'ensemble des liquides inflammables (carburant, diluant, solvant, acétone) sont interdits de voyage en bus.</p></li></ul></p>",
      },

      {
        type: 'subtitle',
        content: 'Un bagage perdu - BlaBlaCar Bus',
      },

      {
        type: 'body',
        content:
          "<p>Dernier point important concernant les bagages bus Blablacar, l'oubli d'un bagage à bord du bus. Dans ce cas de figure, contactez au plus vite Blablacar Bus pour obtenir une assistance. Voici toutes les informations dont vous avez besoin dans notre <a href=\"https://www.tictactrip.eu/faq/objet-perdu-bus\">FAQ dédiée</a>.</p><p>À noter : Blablacar Bus ne sera pas tenu responsable de la perte de l'un de vos bagages à main.</p>",
      },

      {
        type: 'title',
        content: 'Les bagages bus - Flixbus',
      },

      {
        type: 'body',
        content:
          '<p>Découvrez dès à présent les Flixbus bagage que vous pourrez emporter pour vos prochains voyages avec la compagnie de bus.</p>',
      },

      {
        type: 'subtitle',
        content: 'Les types de bagages - Flixbus',
      },

      {
        type: 'body',
        content:
          "<p>Avec Flixbus, le nombre bagage Flixbus que comprend un billet est le suivant : <ul><li><p>1 bagage à main de 7kg au maximum et de type sac à dos ou petite valise cabine.</p></li><li><p>1 bagage en soute de 20kg maximum et de dimension bagage Flixbus maximale : 50cm x 30cm x 80cm.</p></li></ul></p><p>À noter, il vous est possible d'ajouter un bagage supplémentaire Flixbus. Voici les tarifs indiqués par la compagnie : <ul><li><p>ajout de bagages Flixbus au cours de la réservation : 3,99€ / bagage.</p></li><li><p>Ajout de bagage après la réservation du billet : 6€ / bagage.</p></li></ul></p><p>Le mieux pour vous, ce sera donc de bien estimer votre besoin de bagages au moment de la réservation du voyage, pour éviter des frais supplémentaires.</p>",
      },

      {
        type: 'subtitle',
        content: 'Ajout de bagages spéciaux Flixbus',
      },

      {
        type: 'body',
        content:
          "<p>Avec Flixbus, vous avez la possibilité d'emporter avec vous lors de votre voyage, un bagage spécial. Mais qu'est-ce qu'un bagage spécial Flixbus ? </p><p>Il s'agit en fait d'un bagage avec un poids maximal de 30kg et dont la somme des dimensions totales ne dépasse pas 240cm.</p><p>À noter encore une fois, le coût d'un bagage spécial comme défini précédemment est de 9€.</p>",
      },

      {
        type: 'subtitle',
        content: "Vélo dans Flixbus, c'est possible ?",
      },

      {
        type: 'body',
        content:
          "<p>Oui, vous pouvez voyager avec votre vélo à bord des bus Flixbus ! À savoir : les vélos (hormis les vélos électriques, pliants, les tandems et e-bikes) sont autorisés à bord des bus flixbus. De plus, vous n'aurez pas besoin de plier votre vélo.</p><p>Le poids maximum de votre vélo doit être inférieur ou égal à 20kg.</p><p>L'ajout d'un vélo en bagage en soute à votre réservation vous coûtera <strong>9€</strong>.</p>",
      },

      {
        type: 'subtitle',
        content: 'Instrument de musique Flixbus',
      },

      {
        type: 'body',
        content:
          "<p>Bonne nouvelle : vos petits instruments de musique peuvent voyager gratuitement avec vous en bus Flixbus ! Un instrument de musique est défini comme \"petit\" s'il ne dépasse pas les dimensions suivantes : 30cm x 18cm x 42 cm et qu'il ne pèse pas plus de 7kg. </p><p>Au-delà de ces conditions bagages Flixbus, votre grand instrument de musique sera considéré comme un bagage supplémentaire payant et ne devra pas dépasser 30kg. Le prix pour l'ajout d'un instrument de musique est de 9€.</p>",
      },

      {
        type: 'subtitle',
        content: 'Voyage des poussettes Flixbus',
      },

      {
        type: 'body',
        content:
          "<p>Nouvelle bonne nouvelle : votre poussette voyage gratuitement en soute de votre bus Flixbus ! Il faut seulement qu'elle rentre dans les critères suivants : <ul><li><p>Ne pas peser plus de 30kg.</p></li><li><p>Ne pas dépasser 240cm en somme totale des dimensions (L x l x h).</p></li></ul></p>",
      },

      {
        type: 'subtitle',
        content: 'Fauteuil roulant Flixbus',
      },

      {
        type: 'body',
        content:
          '<p>Pour les personnes à mobilité réduite voyageant en fauteuil roulant, certaines conditions sont à respecter pour pouvoir voyager de la meilleure des façons. <a href="https://www.flixbus.fr/services/personnes-mobilite-reduite">En savoir plus</a>.</p>',
      },
    ],
    relatedQuestions: ['billet-bus-enfant', 'animal-compagnie-a-bord-du-bus'],
  },
  {
    name: 'differents-billets-SNCF',
    title: 'Quels sont les différents billets SNCF ?',
    meta: {
      title: 'A quoi correspondent les différents type de billets SNCF ',
      description:
        'Vous vous interrogez sur la tarification de billet SNCF ? Vous vous demandez également ce dont vous allez bénéficier avec votre billets ? Toutes les réponses juste après. ',
    },

    category: ['conditions-de-voyage-tarifs-compagnies'],
    updatedDate: '20/04/2021',
    content: [
      {
        type: 'img',
        content:
          'conditions-de-voyage-tarifs-compagnies_differents-billets-sncf.jpg',
        alt: 'différents-billets-sncf-train-siège-vitre',
      },

      {
        type: 'body',
        content:
          "<p>Il existe un grand nombre de tarif pour un même billet de train chez la <em>SNCF</em>. Bien qu'il n'y ait que deux classes dans un train : la <strong>seconde</strong> et la <strong>première</strong>, la tarification des billets diverge selon plusieurs points.</p><p>En effet, le prix d'un billet varie selon ses conditions d'annulation, d'échange ou de remboursement et de sa flexibilité. A la fin de cette lecture, vous serez incollable sur les différents <strong>types de billet <em>SNCF</em></strong>.</p>",
      },

      {
        type: 'title',
        content: 'Les billets en Première classe',
      },

      {
        type: 'body',
        content:
          "<p>La <strong>première classe</strong> est le top du top pour les voyageurs à la recherche de sérénité et de confort. Vous pourrez profiter à bord de larges fauteuils et d'une ambiance feutrée, de quoi passer un agréable voyage. De plus, il y a moins de sièges donc plus de place pour pouvoir allonger ses jambes : détente absolue !</p><p>Vos billets sont tous échangeables et remboursables selon conditions vous permettant une grande flexibilité.</p>",
      },

      {
        type: 'subtitle',
        content: 'Le tarif Première',
      },

      {
        type: 'body',
        content:
          "<p>Avec un <strong>billet Première</strong> vous aurez la chance de profiter d'une multitude d'avantages : <ul><li><p>Le choix d'un siège isolé, duo, à 4 ou en salon fermé pour les plus intimiste</p></li><li>La possibilité de profiter de l'Espace Calme (choix du siège au moment de la réservation et sur une sélection de destination)</p></li></ul></p><p>En plus de ces avantages, il est mis à votre disposition une prise électrique pour ne jamais être à cours de batterie. Vous pourrez manger ou travailler dans le plus grand des conforts grâce à une tablette escamotable. Une liseuse individuelle vous permettra également d'apprécier un bon roman sans déranger vos voisins.</p>",
      },

      {
        type: 'subtitle',
        content: 'Le tarif Business Première',
      },

      {
        type: 'body',
        content:
          "<p>Le tarif <strong>Business Première</strong> est vraiment réservé aux professionnels. A bord, vous êtes placés dans des wagons Première mais vous avez la chance d'avoir un niveau de service plus conséquent.<br>Ne vous embêtez plus à faire la queue, en utilisant les files prioritaires pour les embarquements et dans les boutiques SNCF. Ils vous sera en plus offert une boisson froide ou chaude et un titre de presse à quai.</p><p>Enfin, vous pourrez patienter tranquillement le temps que votre train arrive en accédant à l'espace <q> salons grand voyageur </q> avec accès wi-fi, magazines en libre service et des boissons offertes. Ces salons sont ouverts en semaine jusqu'à 22h et le week-end jusqu'à 20h.</p><p>C'est d'ailleurs le billet vous permettant une plus grande  flexibilité : l'échange ou la modification du billet Business Première sont gratuits jusqu'à 30 minutes avant le départ.</p>",
      },

      {
        type: 'title',
        content: 'Les billets en Seconde classe ',
      },

      {
        type: 'body',
        content:
          "<p>La <strong>seconde classe</strong> rime plus avec convivialité bien qu'il faut respecter le calme ambiant à bord. Mais vous pourrez profitez du carré famille ou de l'espace famille où vous rencontrerez d'autres famille.</p><p>Ces billets sont échangeables et remboursables selon des conditions encore plus spécifiques que des billets Première. Mais vous apprécierez de nombreux avantages à bord.</p>",
      },

      {
        type: 'subtitle',
        content: "Le Tarif Prem's",
      },

      {
        type: 'body',
        content:
          "<p>Ce sont des billets à <strong>petit prix</strong> permettant de voyager en ayant fait une très bonne affaire. Ils sont mis en vente en premier, d'où le nom et en nombre limité.<br>Ainsi, dès l'ouverture des ventes, quatre mois à l'avance, vous pouvez acheter ces billets. Ne perdez pas de temps et mettez vous un rappel pour ne pas louper la mise en vente.</p>Une fois, l'ensemble des billets Prem's écoulé, le tarif des billets augmente. De même, plus le train se rempli, plus le tarif augmente. Il est donc à votre avantage de réserver vos billets en avance.</p>",
      },

      {
        type: 'subtitle',
        content: 'Le tarif Seconde ',
      },

      {
        type: 'body',
        content:
          "<p>Ce sont les billets vendus une fois que tous les billets en tarif Prem's sont écoulés.</p><p>Comme pour les billets Prem's il est préférable de réserver ses billets en avance pour bénéficier de petits prix pouvant aller jusqu'à <strong>-35% de réduction</strong>. Ils sont également réservables et remboursables selon des conditions moins souples que des billets Première.</p>",
      },

      {
        type: 'Subtitle',
        content: 'Le tarif Pro Seconde ',
      },

      {
        type: 'body',
        content:
          "<p>Enfin, le tarif <strong>Pro Seconde</strong> est une bonne alternative pour les professionnels. Cela vous permet de profiter d'une plus grande flexibilité qu'un tarif seconde même si vous voyagez quand même dans un wagon seconde classe.<br>Tous les <strong>services premium</strong> disponibles en billet Première sont accessibles avec ce tarif.</p><p>Attention cependant, les entreprises doivent signer un contrat avec la SNCF afin d'avoir ces avantages. Pour y souscrire suivez :<a href=\"https://pro-adhesion.sncf.com/pme/adhes ion?canal=trainline\"> ce lien </a>.</p><p>Vous connaissez désormais les différents billets SNCF. S'il y a une chose à retenir pour pouvoir se déplacer au meilleur prix : c'est de s'y prendre à l'avance.<br>Il ne vous reste plus qu'à réserver, chez Tictactrip bien sûr !</p>",
      },
    ],
    relatedQuestions: [
      'services-sncf-avant-depart,retirer-son-billet-de-train',
    ],
  },
  {
    name: 'prix-billet-augmente',
    title: 'Pourquoi le prix de mon billet a augmenté ? - Tictactrip',
    meta: {
      title: 'Pourquoi le prix de mon billet a augmenté ?',
      description:
        'Un changement du prix de vos billets au moment du paiement ? Laissez-nous vous en expliquer la simple raison !',
    },
    category: ['recherche-reservation-billets'],
    updatedDate: '15/04/2021',
    content: [
      {
        type: 'img',
        content: 'recherche-reservation-billets_prix-billet-augmente.jpg',
        alt: 'prix billet augmente',
      },

      {
        type: 'body',
        content:
          "<p>Vous vous apprêtiez à réserver le voyage de vos rêves (on éxagère qu'un tout petit peu !) et là horreur : une pop-up d'augmentation du prix de vos billets est arrivée sur votre page de commande...</p><p>Ici, nous allons vous expliquer les raisons de ce changement de prix !</p>",
      },

      {
        type: 'title',
        content: 'Pourquoi les prix de mes billets ont augmenté ?',
      },

      {
        type: 'body',
        content:
          "<p>Il existe une seule et unique réponse à cette question.</p><p>En effet, seules les compagnies de transports partenaires de Tictactrip peuvent modifier et ajuster leurs prix. Autrement dit, Tictactrip, en tant qu'agence de voyage et vendeur agréée des billets de ces compagnies, n'a aucun pouvoir sur les prix. Nous ne pouvons donc pas augmenter les prix des compagnies à notre guise.</p><p>Ainsi, une augmentation du prix de votre billet lors de votre commande indique soit : <ol><li><p>Que la compagnie partenaire a décidé de modifier ses tarifs en raison d'un nombre de places restantes très limitées,</p></li><li><p>soit que la compagnie de transport connait un grand nombre de recherches pour ce trajet,</p></li><li><p>soit enfin que le trajet en question à été modifié ou supprimé par la compagnie. Dans ce cas, c'est notre plateforme qui se charge de trouver la meilleure alternative pour vous, en respectant vos filtres par prix, durée ou les deux.</p></li></ol></p><p>Chez Tictactrip, nous faisons tout notre possible pour vous donner l'ensemble des informations cruciales nécessaires à votre voyage et à sa réservation. C'est pourquoi nous faisons notre maximum pour vous afficher cette information relative à l'augmentation du prix de votre billet, le plus tôt possible.</p><p>Même si bien entendu, nous préférerions que cette mauvaise nouvelle n'apparaisse pour aucun de nos clients, vous vous en doutez...</p><p>Enfin, il faut bien noter à nouveau que Tictactrip n'augmente pas les prix de son propre chef. Il s'agit uniquement d'un changement de l'offre de la compagnie.</p>",
      },
    ],
    relatedQuestions: [
      'problemes-de-paiement-debite',
      'paiement-billet-partenaire',
    ],
  },
  {
    name: 'temps-remboursement-tictactrip',
    title:
      'J’ai annulé mon billet et je n’ai toujours pas reçu mon remboursement. Est-ce normal ?',
    meta: {
      title:
        'Combien de temps pour obtenir le remboursement Tictactrip ? [À jour]',
      description:
        "Vous venez d'annuler un billet Tictactrip et vous attendez votre remboursement ? Toutes les informations ici.",
    },
    category: ['service-apres-vente'],
    updatedDate: '08/07/2021',
    content: [
      {
        type: 'img',
        content: 'service-apres-vente_remboursement-tictactrip-temps.jpg',
        alt: 'remboursement tictactrip combien de temps',
      },

      {
        type: 'body',
        content:
          "<p>Il y a peu, vous avez obtenu par notre service client Tictactrip, une annulation et un remboursement de votre voyage. C'est une superbe nouvelle, nous sommes ravis d'avoir pu vous aider !</p><p>Cependant, le remboursement auquel nous avons procédé n'est pas encore arrivé sur votre compte bancaire ? Pas d'inquiétudes, voici les différents cas de figure !</p>",
      },

      {
        type: 'title',
        content: 'Remboursement Tictactrip - Sous combien de jours ouvrés ?',
      },

      {
        type: 'body',
        content:
          "<p>Sachez qu'à partir du moment où l'un de nos conseillers du service client Tictactrip procède au remboursement de votre voyage, il faut compter au maximum <strong>3jours ouvrés</strong> pour obtenir votre remboursement sur votre compte bancaire.</p><p>Ainsi, pas de panique si votre remboursement, fait le vendredi, n'arrive que le mercredi suivant !</p><p>Mais attention cependant, un autre type de souci peut arriver. Vérifiez ci-dessous que ce ne soit pas votre cas.</p>",
      },

      {
        type: 'title',
        content: "Remboursement Tictactrip d'un billet Ouigo",
      },

      {
        type: 'body',
        content:
          "<p>Pour votre voyage Ouigo, réservé sur Tictactrip, il y a une légère subtilité à ne pas rater pour obtenir votre remboursement.</p><p>En fait, Tictatrip vous offre la possibilité de réserver votre train TGV Ouigo en effectuant la réservation à votre place suite à votre demande. Si vous décidez d'annuler directement votre voyage auprès de Ouigo sans nous en informer, nous recevrons le remboursement de la part de Ouigo à votre place ( au nom de Mr Robain).</p><p>Pensez donc à nous en informer afin que nous puissions vous transférer les fonds rapidement.</p><p>Voilà, c'était le seul cas un petit peu litigeux. Malheureusement nous ne pouvons pallier à ce problème (notre équipe technique cherche à trouver une solution !).</p>",
      },
    ],
    relatedQuestions: [
      'politique-annulation-remboursement-billet',
      'remboursement-bon-achat-ouigo',
    ],
  },
  {
    name: 'bagage-train',
    title: 'Quels sont les bagages autorisés pour mes voyages en train ?',
    meta: {
      title:
        'Quels Bagages Train sont autorisés pour mon voyage ? - Toutes les réponses',
      description:
        'Vous êtes un peu perdus sur les politiques de bagages par compagnie de train ? Laissez-nous simplifier cela !',
    },
    category: ['recherche-reservation-billets'],
    updatedDate: '11/06/2021',
    content: [
      {
        type: 'img',
        content: 'recherche-reservation-billets_bagage-train-autorise.jpg',
        alt: 'bagage train autorisé - voyageur train valise gare',
      },

      {
        type: 'body',
        content:
          "<p>Alors, fin prêts à voyager en train ?! Comment ça, vous ne savez pas quels bagages prendre pour partir en voyage et monter à bord de votre train ?</p><p>Pas de panique, on a fait pour vous, un condensé des politiques de bagages des compagnies de train. Les réponses à vos questions sont sur cette page, c'est certain !</p>",
      },

      {
        type: 'title',
        content: 'Les bagages train - SNCF',
      },

      {
        type: 'body',
        content:
          "<p>Il est vrai qu'il est important de se poser la question des bagages SNCF acceptés pour votre voyage. Ce serait en effet embêtant de prendre trois valises de vêtements avant de se rendre compte qu'une seule est acceptée...</p><p>C'est pour cela que nous avons choisi de vous résumer l'ensemble des conditions SCNF concernant les bagages et ce, par compagnie de train.</p>",
      },

      {
        type: 'subtitle',
        content: 'Les bagages Ouigo autorisés',
      },

      {
        type: 'body',
        content:
          "<p>Avec la compagnie Ouigo, la politique bagage est simple. Chaque voyageur peut voyager avec au choix : soit deux bagages à main, soit un bagage à main et un bagage cabine. Cela est aussi valable pour les enfants et les bébés.</p><p>Un bagage à main ne doit pas excéder les mesures suivantes 36 x 27 x 15 cm (hauteur x largeur x profondeur). Quant au bagage cabine, celui-ci doit respecter 55 x 35 x 25 cm (hauteur x largeur x profondeur).</p><p>Si vous n'avez pas assez de ces deux bagages, vous pouvez en ajouter un supplémentaire pour seulement 5€. Chaque voyageur peut ajouter jusqu'à deux bagages Ouigo supplémentaires à son voyage. Pour ajouter un bagage supplémentaire avant votre voyage, rendez-vous dans l'onglet \"Mes réservations\" sur le <a href=\"https://ventes.ouigo.com/fr-FR/after-sale/connection\">site Ouigo</a> directement.</p><p>Autrement, avec Ouigo, vous avez la possibilité d'emmener avec vous votre poussette, dans la limite de 2 poussettes par réservation et par trajet.</p><p>Mais qu'en est-il des bagages spéciaux Ouigo ? </p><p>Par là on entend bien les trotinettes, ski, planche de surf, instruments de musique et bien plus. Eh bien Ouigo, est très concis. Les trottinettes, skis/surf avec housse et pour une taille inférieure à 2 mètres, les violons, guitares, skateboards et  vélos sous housse (max 120X90cm) sont autorisés à voyager avec vous.</p><p>Enfin, comme vous vous en doutez, certains objets et bagages sont interdits dans les trains Ouigo. C'est le cas notamment : <ul><li><p>des appareils électroménagers, des téléviseurs et autres objets très volumineux, des cartons, cabas, des armes, explosifs et produits dangereux ainsi que des produits illégaux.</p>",
      },

      {
        type: 'subtitle',
        content: 'Les bagages TER, bagages TGV InOui et bagages Intercités',
      },

      {
        type: 'body',
        content:
          "<p>Chez ces différentes marques de train de la SNCF, les politiques des bagages sont nettement moins contraignantes. En effet, la règle étant : voyagez uniquement avec des bagages que vous pouvez porter vous-même. Vos bagages répondent de votre responsabilité et doivent être étiquetés pour voyager.</p><p>Chez InOui, la marque de train Premium, il existe un <strong>service Mes Bagages SNCF</strong>. Il s'agit d'un service de transport de vos bagages volumineux comme un vélo, un fauteuil ou encore simplement vos valises. Vous aurez même le choix de récupérer vos bagages en point relais, à domicile ou au travail dès le lendemain ! Pour en savoir plus, rendez-vous <a href=\"https://www.sncf.com/fr/offres-voyageurs/voyager-en-train/tgv-inoui/votre-voyage/bagages-et-consignes\">ICI</a>.</p><p>Aussi, sachez que les skis et planches nautiques sont également autorisés à bord des trains TGV INOUI, TER et Intercités. C'est également le cas pour les vélos. Tous sont accetpés à condition d'être rangés sous housse. La taille maximale acceptée pour les vélos est de 120x90cm. Bien sûr, pensez à placer ces bagages volumineux aux emplacements dédiés à bord des trains.</p><p>Enfin, les objets illicites et potentiellement dangereux sont interdits dans les trains, cela va de soi. Il est question de bon sens et de civisme.</p>",
      },

      {
        type: 'subtitle',
        content: 'Les Bagages Thalys autorisés',
      },

      {
        type: 'body',
        content:
          "<p>Chez Thalys, voyager chargé, c'est tout à fait possible ! En effet, vous aurez le droit d'emporter avec vous : <ul><li><p>1 bagage à main,</p></li><li><p>et au maximum 2 valises respectant les mesures suivantes, 75 x 53 x 70 cm.</p></li></ul></p><p>Au delà de ces mesures, vos valises et bagages Thalys n'ont aucune contrainte de poids. Cependant, la règle applicable est encore une fois : n'emmenez que ce que vous pouver porter. Vos affaires devront être rangées dans les espaces bagages Thalys spécifiques de chaque extrémité des voitures. Aussi, votre bagage à main sera placé sous votre siège ou au-dessus, dans les portes-bagages dédiés à cet effet.</p><p>Également, les poussettes, sont autorisés à bord, pliées et rangées dans les espaces dédiés pour les bagages volumineux Thalys.</p><p>Enfin, votre vélo Thalys peut voyager avec vous si vous le rangez dans les espaces dédiés aux extrémités des voitures et si votre vélo est sous housse et mesure moins de 135 x 85 x 30 cm. Il en va de même pour vos équipements de ski, placés dans leur housse et mesurant au maximum 3 m de long pour 32 kg.</p>",
      },

      {
        type: 'subtitle',
        content: 'Les bagages Eurostar autorisés',
      },

      {
        type: 'body',
        content:
          "<p>Chez Eurostar, avec le billet Strandard que vous avez acheté, vous pourrez voyager avec : <ul><li><p>1 bagage à main de taille standard,</p></li><li><p>2 valises ou bagages plus volumineux, ne dépassant pas 85 cm pour le plus grand côté.</p></li></ul></p><p>Cependant, si vous avez opté poour un billet Eurostar Business Première, vous aurez droit d'emporter avec vous non pas 2 mais 3 valises ou sacs. Bien sûr, cela est possible sans frais supplémentaires, c'est compris dans votre billet !</p><p>Passons désormais aux bagages volumineux et bagages spéciaux. Par là, nous pensons à l'ensemble des poussettes, landaus, instruments de musique et vélos. Eurostar a choisi d'autoriser l'ensemble de ces bagages pour vos voyages, uniquement s'ils respectent la condition de mesure décrite précédemment : ne pas dépasser 85 cm pour le plus grand côté. Aussi, ces affaires doivent être rangées sous housse.</p><p>Enfin, sachez que si vos bagages ne respectent pas cette règle, il vous faudra l'indiquer lors de l'enregistrement de vos bagages au moment de votre réservation de billet Eurostar. Bien entendu, ce service Eurostar ne sera pas sans frais supplémentaires.</p><p>En effet, voici les prix si vous décidiez d'ajouter un bagage supplémentaire : <ul><li><p>34€ pour chaque bagage pour les équipments sportifs comme des clubs de golf et les armes de collection comme un fusil, un couteau...</p></li><li><p>34€ à 46€ pour les vélos dans leur housse.</p></li><li><p>40€ à 64€ pour les vélos non démontés.</p></li><li><p>46€ pour les bagages volumineux comme les grands instruments de musique...</p></li></ul></p>",
      },

      {
        type: 'title',
        content: 'Izy bagage autorisé',
      },

      {
        type: 'body',
        content:
          "<p>Chez Izy, lorsque vous réservez un billet de train, vous aurez de ce fait la possibilité de voyager avec :<ul><li><p>1 bagage cabine avec pour dimensions maximales :35cm x 55cm x 25cm et un poids maximal de 32kg.</p></li><li><p>À ce bagage cabine s'ajoute 1 bagage à main Izy avec comme dimensions maximales : 27cm x 36cm x 15cm, pour un poids maximum de 10 kg.</p><p>Aussi, sont considérés comme des bagages à main :<ul><li><p>les cages et autres contenant pour animaux domestiques de dimensions maximales 55 x 30 x 30 cm,</p></li><li><p>une poussette si elle est pliée</p></li><li><p>et un vélo Izy pliable et donc plié.</p></li></ul></p>",
      },

      {
        type: 'subtitle',
        content: 'Comment ajouter un bagage Izy ?',
      },

      {
        type: 'body',
        content:
          '<p><p>Aussi, il vous est possible d\'opter pour un bagage supplémentaire Izy au prix de 15€ lors de la réservation ou jusqu\'à la veille du trajet. Le jour même, vous pourrez demander à obtenir un bagage supplémentaire mais le prix sera de 30€.</p><p>Ce bagage supplémentaire ne peut excéder 32 kg et 2m de taille.</p><p>Pour ajouter un bagage Izy, il vous suffit de vous connecter sur le <a href="https://booking.izy.com/fr-FR/booking-login">site Izy</a>. Dans l\'onglet "Mes réservations Izy", il vous sera possible d\'ajouter un bagage supplémentaire à votre réservation !</p>',
      },

      {
        type: 'title',
        content: 'Les bagages Regiojet autorisés',
      },

      {
        type: 'body',
        content:
          "<p>Chez Regio Jet, vous pouvez voyager avec tous les bagages que vous souhaitez emmener avec vous, pourvu que vous puissiez vous en occuper convenablement. Bien entendu, vos bagages ne doivent pas nuire à autrui, ni au voyage en train. Le bon sens est donc la simple règle de Regiojet !</p><p>Les bagages dangereux, illégaux et illicites ne peuvent pas être emmenés à bord des trains Regiojet.</p><p>Les poussettes sont autorisées gratuitement dans les trains RegioJet et doivent voyager aux extrémités des rames, dans les emplacement dédiés. La compagnie vous invite donc à réserver une place proche de ces emplacements.</p><p>Malheureusment, il n'est pas possible de voyager avec un vélo ou un scooter à bord des trains de cette compagnie.</p>",
      },
    ],
    relatedQuestions: ['bagage-bus', 'animal-compagnie-a-bord-du-train'],
  },
  {
    name: 'pass-sanitaire-voyages',
    title:
      'Quelles sont les conditions pour voyager ? Pass sanitaire, test PCR, on vous dit tout !',
    meta: {
      title:
        'Pass Sanitaire Voyage Longue Distance - Quelles sont les conditions de voyage ? [Été 2021]',
      description:
        'Vous voulez voyager ? Découvrez les conditions de voyage. Test PCR, Pass Sanitaire, on vous dit tout !',
    },
    category: ['conditions-de-voyage-tarifs-compagnies'],
    updatedDate: '26/07/2021',
    content: [
      {
        type: 'img',
        content: 'pass-sanitaire-voyages-passeport-pass-vaccinal-masque.jpg',
        alt: 'pass-sanitaire-voyages-passeport-pass-vaccinal-masque',
      },

      {
        type: 'body',
        content:
          "<p>Partir en vacances, nous en rêvons tous depuis longtemps. Entre le Covid-19 et ses confinements, le travail et la routine quotidienne, une grande pause s'impose !</p><p>Mais au mois de juillet 2021, notre Président Mr Emmanuel Macron a mis en place le Pass Sanitaire obligatoire pour accéder aux événements, pour voyager et bien plus encore.</p><p> Qu'est-ce que le Pass Sanitaire ? Le pass sanitaire est-il le seul moyen de voyager ? Un seul test PCR suffit il ?</p><p>On répond à l'ensemble de vos question ici !</p><p>PS : les mentions de pass vaccinal, pass sanitaire international et pass sanitaire font toutes références au seul et unique Pass Sanitaire Internationnal obtenu deux semaines après la 2ème vaccination (ou 1ère injection pour les personnes ayant récemment eu la Covid-19).</p>",
      },

      {
        type: 'title',
        content: 'Le Pass Sanitaire',
      },

      {
        type: 'body',
        content:
          "<p>Vous êtes vaccinés ou êtes proches de l'être ? Sachez que le Pass Sanitaire va vous permettre (étrangement), de faire énormément de chose à partir de l'été 2021. En effet, suite aux annonces du Président de la République, de nombreux événements, voyages, et lieux publics n'accepteront que les personnes vaccinées et possédant leur pass vaccinal.</p>",
      },

      {
        type: 'subtitle',
        content: 'Le Pass Sanitaire - Voyage longue distance',
      },

      {
        type: 'body',
        content:
          "<p>Tout d'abord, sachez que le Pass Sanitaire vous sera demandé lors de vos longs voyages en France et à l'étranger.</p><p>En effet en France, tous les <strong>voyages nationaux et inter-régionaux</strong> seront soumis au contrôle du Pass Sanitaire.</p><p>Mais qu'entend-on par <strong>Pass Sanitaire voyage longue distance</strong> ?</p><p>En fait, tous vos trajets en Bus seront soumis au contrôle de Pass Sanitaire. Il en va de même pour tous les trains TGV InOui, TGV Ouigo, trains Intercités ou encore trains longue distance internationale comme Eurostar par exemple. En résumé :<ul><li><p>Vos voyages en bus Flixbus et bus Blablacar seront soumis à des <strong>contrôles de Pass Sanitaire obligatoire</strong>.</p></li><li><p>Vos voyages en trains TGV Inoui, TGV Ouigo, Intercités et trains Internationaux seront soumis aux contrôles de Pass Sanitaire International.</p></li><li><p>Enfin, nous ne l'avons pas mentionné : les covoiturage Blablacar ne seront pas soumis aux contrôles du Pass Sanitaire. Cependant, Blablacar compte ajouter une fonctionnalité permettant d'indiquer si le covoitureur est en possession d'un Pass Sanitaire ou non.</p></li></ul></p><p>Vous l'aurez compris, dans les trains Transiliens et trains TER, dans le métro et dans les transports urbains votre pass vaccinal ne sera pas contrôlé et vous pourrez vous déplacer \"librement\".</p>",
      },

      {
        type: 'subtitle',
        content: 'Le Pass Sanitaire - Événements et lieux Publics',
      },

      {
        type: 'body',
        content:
          '<p>Vous le savez, le Pass Sanitaire devient, à partir du 21 juillet 2021, obligatoire pour accèder à divers lieux publics. Mais quels sont ces lieux publics accessibles uniquement sur présentation de son Pass Sanitaire ?</p><p>Le Gouvernement français indique sur son site Service Public qu\' "à partir du 21 juillet, il [Pass Sanitaire] est nécessaire pour accéder aux lieux de loisirs et de culture qui accueillent plus de 50 personnes.".</p><p>Attention car à cela s\'ajoute : "À compter de début août, il va devenir obligatoire dans les cafés, bars, restaurants, centres commerciaux, maisons de retraite et transports de longue distance.".</p><p>Autrement dit, pour profiter au mieux de vos vacances et de vos déplacements en France et en Europe vous aurez besoin d\'un Pass Sanitaire... ou peut-être pas si vous posséder un <strong>test PCR récent</strong> ! On aborde le sujet juste en-dessous.</p>',
      },

      {
        type: 'title',
        content: 'Test PCR récent : une bonne option pour vos voyages ?',
      },

      {
        type: 'body',
        content:
          "<p>Sachez tout d'abord que les Test PCR France vont devenir payant à partir de l'automne 2021. À partir du 07 juillet 2021, ces test PCR deviennent également payants pour les personnes en séjour en France à un prix d'environ 50€.</p><p>Enfin, les tests PCR ou antigéniques prescrits par un médecin ou en situation de cas contact pourront être remboursés.</p>",
      },

      {
        type: 'subtitle',
        content: 'Test PCR - Voyage longue distance',
      },

      {
        type: 'body',
        content:
          "<p>Ce qu'il faut comprendre avant toute chose, c'est qu'à partir de début août 2021, certainement le 1er août, le Pass Sanitaire sera obligatoire et il pourra prendre trois formes : <ul><li><p>Le certificat de vaccination complété,</p></li><li><p>un Test PCR négatif ou antigénique négatif de moins de 48h.</p></li><li><p>Ou enfin un résultat de test RT-PCR positif attestant du rétablissement du Covid, c'est à dire datant d'au moins 11 jours et de moins de 6 mois.</p></li></ul></p><p>Ainsi, comme indiqué plus haut, avec un test PCR négatif ou bien un Test PCR positif effectué entre 11 jours et 6 mois avant le jour de votre voyage, vous pourrez voyager !</p><p>Pour les personnes âgées de 12 à 17ans, cette obligation sera effective à partir du 30 août 2021.</p><p>Avec votre test PCR, vous pourrez donc monter à bord de votre bus Flixbus, votre vus Blablabus ou encore vos trains TGV Inoui, Ouigo, TGV Internationaux ou trains Intercités.</p>",
      },

      {
        type: 'subtitle',
        content: 'Test PCR - Voyage longue distance',
      },

      {
        type: 'body',
        content:
          '<p>L\'accès aux lieux publics règlementés et événements publics en France sont soumis aux conditions suivantes fixées par le Gouvernement : "La preuve d\'un test négatif RT-PCR ou antigénique de moins de 48h pour l\'accès aux lieux culturels ou de loisirs et de 72h maximum pour le contrôle sanitaire aux frontières.".</p><p>Vous avez désormais l\'ensemble des cartes en main ! Pensez donc à prendre vos précautions sanitaires avant de voyager et / ou vous rendre dans des lieux publics.</p><p>Source : <a href="https://www.service-public.fr/particuliers/actualites/A14896">Service-Public.fr</a>.</p>',
      },
    ],
    relatedQuestions: [
      'compagnies-transport-annulation-remboursement-coronavirus',
      'remboursement-bon-achat-ouigo',
    ],
  },
  {
    name: 'numero-commande-tictactrip',
    title: 'Où trouver mon numéro de commande Tictactrip ?',
    meta: {
      title:
        'Tout savoir sur mon numéro de commande Tictactrip, où le trouver, à quoi il sert ? Vous saurez tout !',
    },
    category: ['service-apres-vente'],
    updatedDate: '09/09/2021',
    content: [
      {
        type: 'body',
        content:
          "<p>Votre réservation effectuée, vous voilà en possession du Saint Graal :  votre billet de train, de bus ou encore mieux d'un trajet combiné soigneusement acheté sur notre plateforme.</p><p> Vous allez enfin pouvoir vous rendre vers la destination tant voulue, pour une petite détente entre amis, une visite à la famille ou pour un contrat à négocier.</p><p> Mais pour quelconque demande vous avez besoin de votre numéro de commande Tictactrip. Une fois en bas de cette page vous comprendrez pourquoi ce numéro est si important.</p>",
      },
      {
        type: 'img',
        content: 'service-apres-vente_numero-commande-mes-billets.jpg',
        alt: 'numéro-commande-mes-billets',
      },
      {
        type: 'title',
        content: 'À quoi sert mon numéro de commande ?',
      },
      {
        type: 'body',
        content:
          "<p>Votre numéro de commande est précieux. Il est composé de <strong>16 caractères</strong> (désolés nous n'avons pas pu faire plus court). Il détermine et confirme que vous avez bien réservé sur le site de Tictactrip.</p><p>Avec ce numéro de commande, nous pouvons avoir accès à vos informations de réservation suivantes :<ul><li><p>Date</p></li><li><p>Trajet</p></li><li><p>Identité du/des passagers</p></li><li><p>Prix payé</p></li><li><p>Numéro de réservation du transporteur</p></li></ul></p><p>Si jamais vous avez besoin de nous contacter pour une demande d'après-vente, c'est grâce à ce numéro que nous pourrons vous trouver et surtout vous aider !</p>",
      },
      {
        type: 'title',
        content: 'Mais où se trouve-t-il ?',
      },
      {
        type: 'body',
        content:
          "<p>Vous trouverez votre numéro de commande à plusieurs endroits. Et oui, nous sommes des petits malins. Pour vous simplifier la tâche nous l'avons semé un peu partout comme le Petit Poucet.<br><p>Ainsi, vous le trouverez sur :<ul><li><p><strong>Le lien de confirmation de réservation</strong>, une fois que votre paiement est validé. Il est écrit tout en haut de la page après la partie <q> validation de votre commande </q></p></li><li><p><strong>Le mail de justificatif de paiement</strong>, que vous recevez une fois que la transaction a aboutie. Sur ce mail vous trouverez le numéro de commande et le montant payé.</p></li><li><p><strong>Le mail de confirmation de réservation</strong>, que notre mascotte Nodi le dinosaure vous a si gentiment envoyé. Vous le trouverez dans la section <q>commande</q> avec le détail de votre trajet.</p>",
      },
      {
        type: 'title',
        content: "Que faire si j'ai perdu mon numéro de commande ?",
      },
      {
        type: 'body',
        content:
          "<p>Catastrophe ! Vous avez supprimé votre mail ou il s'est perdu dans votre boîte de réception ?<br>Pas de panique ! Nous sommes toujours là pour vous aider.</p><p>Contacter notre <strong>service client</strong> via le formulaire de contact en appuyant sur le bouton <q>contact</q> en haut de notre page. Pour retrouver votre numéro de commande, nous aurons besoin, de l'adresse mail ayant servi à la réservation et le nom de famille de la personne qui a réservé.</p><p>Votre numéro de commande n'a plus aucun secret pour vous ! Gardez-le bien. Enfin, nous vous souhaitons un excellent voyage.</p> ",
      },
    ],
    relatedQuestions: [
      'politique-annulation-remboursement-billet',
      'echanger-mes-billets , compagnies-transport-annulation-remboursement-coronavirus',
    ],
  },
  {
    name: 'La-wifi-à-bord-des-trains-SNCF',
    title: 'La wifi à bord des trains SNCF',
    meta: {
      title: 'FAQ La-wifi-à-bord-des-trains-SNCF !',
      description:
        'Une envie de surfer sur internet pendant votre trajet SNCF ? Tictactrip vous explique comment faire !',
    },
    category: ['conditions-de-voyage-tarifs-compagnies'],
    updatedDate: '16/12/2021',
    content: [
      {
        type: 'body',
        content:
          "<p>Vous souhaitez envoyer des mails ? Naviguer sur le net ? Surfer sur vos réseaux sociaux ? Et bien bonne nouvelle, c'est désormais possible à bord des trains SNCF !</p><p> On le sait tous, il est inconcevable pour certain de ne pas avoir accès à internet. Avoir de la connexion internet est plus que primordial aujourd'hui. Et ça, la SNCF l'a bien compris. En voyageant à bord de leur train, vous avez la possibilité de bénéficier d'une wifi totalement gratuite ! </p>",
      },
      {
        type: 'img',
        content: 'wifi-dans-les-trains.jpg',
        alt: 'wifi dans les trains',
      },
      {
        type: 'subtitle',
        content: 'Comment se connecter',
      },
      {
        type: 'body',
        content:
          "<p>Se connecter au réseau wifi dans le train est un jeu d'enfant ! Si vous avez l'habitude de surfer sur le net grâce à votre box chez vous, vous saurez alors comment vous y prendre ! </p><p>Activez tout simplement le réseau wifi sur votre appareil. Ensuite, il vous suffira de cliquer sur le réseau <strong>« _SNCF_WIFI_INOUI ».</strong> </p><p>Une fois que vous avez passé cette étape, une page s'ouvrira et dans laquelle vous devrez vous identifier grâce à votre référence de dossier ou de votre Identifiant SNCF !</p><p> C'est simple et rapide ! </p>",
      },
      {
        type: 'subtitle',
        content: 'Mais comment est-ce possible ?',
      },
      {
        type: 'body',
        content:
          "<p>Vous vous demandez sûrement comment réussir  à capter un réseau wifi alors que le train roule à plus de 300 km/h ? En réalité, c'est tout simple. On vous explique tout. </p><p>Depuis de nombreuses années, la compagnie SNCF met en place des solutions pour faciliter le confort de ses passagers. Un confort qui n'est pas à négliger. </p><p>Grâce à des bornes présentes tout au long de votre trajet mais aussi grâce à des antennes intégrées, les trains réussissent à capter les réseaux 4G des opérateurs téléphoniques. </p><p>C'est ce qui vous permet alors d'avoir une wifi avec un débit important et qui est gratuite !  </p>",
      },
      {
        type: 'subtitle',
        content: 'Petits tips avant votre voyage',
      },
      {
        type: 'body',
        content:
          "<p>Il est sûr qu'être une centaine de personnes à se connecter à un réseau wifi commun réduit très fortement la vitesse de chargement des fichiers.</p> <p>Alors si vous souhaitez télécharger votre film préféré sur Netflix ou envoyer un dossier urgent et volumineux, nous vous conseillons vivement de la faire juste avant de monter à bord. Vous aurez plus de chance de bénéficier d'une meilleure connexion et surtout avoir l'esprit beaucoup plus léger.</p><p>Petit conseil : n'oubliez pas de profiter de ce débit réduit pour vous ressourcer, pour lire ou encore pout tout simplement admirer le paysage !</p>",
      },
    ],
    relatedQuestions: [
      'Y-a-t-il-une-connexion-WIFI-à-bord-de-mon-train-ou-de-mon-bus',
      'Les Services-SNCF-avant-votre-départ-de-quoi-embellir-le-début-du-voyage',
    ],
  },
  {
    name: 'Train-supprimé-procédure',
    title: 'Mon train SNCF été supprimé, que faire ?',
    meta: {
      title: 'FAQ Que faire si mon train a été supprimé ?',
      description:
        'Votre train a été supprimé suite à un mouvement social, d’une averse ou encore d’une panne technique ? Vous ne savez pas comment faire ? Ne bougez plus, vous êtes au bon endroit ! ',
    },
    category: ['service-apres-vente'],
    updatedDate: '18/03/2022',
    content: [
      {
        type: 'body',
        content:
          '<p>Comme tous les moyens de transport, certaines perturbations, parfois extérieures, peuvent impacter votre train. Pour des raisons économiques ou encore sanitaires, certaines compagnies annulent directement les trains prévus. Afin d’anticiper au maximum, vous avez la possibilité de consulter en direct le trafic ferroviaire.  </p>',
      },
      {
        type: 'img',
        content: 'mon-train-a-ete-supprime-que-faire.png',
        alt: 'mon train a été supprimé que faire ?',
      },
      {
        type: 'title',
        content: 'Que faire si vous avez réservé sur une autre plateforme ?',
      },
      {
        type: 'body',
        content:
          'Il est tout à fait possible, chez certaines compagnies, d’effectuer une demande de dédommagement en cas de train supprimé : ',
      },
      {
        type: 'subtitle',
        content: 'OuiSNCF',
      },
      {
        type: 'body',
        content:
          '<p>La SNCF vous met à disposition un chatbot, <a href="https://tout-oui.sncf.com/">Tout’Oui</a> sur son site. C’est un agent virtuel qui vous guidera et vous accompagnera dans votre démarche. </p><p>Pour ce faire, vous indiquerez l’objet de votre demande, ici un train supprimé. Puis, vous devrez saisir la date du départ ainsi que le canal d’achat (agence, téléphone, site internet,..).</p><p>Si vous disposez d’un compte SNCF, munissez-vous de vos identifiants. Dans le cas contraire, vous devrez créer un compte pour poursuivre votre demande. Une fois connecté, vous pourrez alors entrer les informations nécessaires et terminer votre réclamation.</p>',
      },
      {
        type: 'subtitle',
        content: 'TER',
      },
      {
        type: 'body',
        content:
          '<p>Si vous rencontrez un problème avec votre bus ou train TER, vous devrez vous rendre sur le site de votre TER. Attention, les démarches de réclamation sont différentes en fonction de la région de votre TER. </p><p>Pour avoir plus d’informations, nous vous invitons à vous rendre directement sur le site de la SNCF en cliquant <a href="https://www.sncf.com/fr/service-client/reclamations/ter>ici"</a></p>',
      },
      {
        type: 'subtitle',
        content: 'Ouigo',
      },
      {
        type: 'body',
        content:
          '<p>En cas d’annulation de la part de Ouigo, vous recevrez un mail vous indiquant la suppression de votre trajet. Vous devrez alors vous connecter sur  <a href="https://ventes.ouigo.com/fr-FR/after-sale/connection">Ouigo.fr</a> grâce à vos identifiants, c’est-à-dire votre adresse mail ainsi que votre numéro de réservation.</p> <p>La compagnie autorise exceptionnellement soit un échange sans frais pour un nouveau voyage ou soit un remboursement sous forme de bon d’achat recréditable. Ce sera à vous de faire le choix qui vous convient le mieux.</p>',
      },
      {
        type: 'title',
        content: ' Que faire si vous avez réservé chez Tictcatrip ?',
      },
      {
        type: 'body',
        content:
          '<p>Si vous avez réservé directement sur notre plateforme, nous nous occupons d’effectuer toutes les démarches. Bien évidemment, nous aurons besoin de votre aide. </p><p> Il faudra effectuer une demande via le support en ajoutant toutes les informations nécessaires : <ul><li><p>Numéro de réservation Tictactrip </p></li><li><p>Mail d’annulation de la compagnie</p></li><li><p>Vos billets</p></li></p>',
      },
      {
        type: 'subtitle',
        content: 'Les délais de traitement',
      },
      {
        type: 'body',
        content:
          '<p>Une fois que vous avez suivi tout le processus, vous devrez vous armer de patience. Pas d’inquiétude, nous nous occupons d’opérer toutes les démarches directement auprès de la SNCF. Lorsque nous reçevons tous les documents nécessaires, un dossier est créé et déposé auprès de la compagnie SNCF.</p><p>Les délais de traitement sont relativement longs donc pas de panique si vous n’obtenez pas de retour de notre part. Une réponse vous sera automatiquement envoyée quand nous obtiendrons un retour. </p>',
      },
      {
        type: 'subtitle',
        content: 'Serai-je remboursé intégralement ?',
      },
      {
        type: 'body',
        content:
          '<p>Avant de d’effectuer un remboursement, la SNCF devra, tout d’abord, analyser le dossier et autoriser le remboursement. Si le dossier est éligible alors vous obtiendrez un remboursement intégral de la somme versée. </p><p>Attention, dans certains cas, si la compagnie vous a proposé un transport de substitution et que vous avez décliné cette solution, vous ne pourrez prétendre à un remboursement.</p><p>De même, il se peut que la SNCF refuse le remboursement lors de travaux, retards ou intempéries selon leurs conditions. N’oubliez pas que nous sommes soumis à leurs politiques de remboursement et que nous ne pouvons vous rembourser si cela n’a pas été validé en amont.</p><p> Nous serons toujours là pour vous accompagner dans vos démarches. Notre service client reste disponible pour vous aider.</p>',
      },
    ],
    relatedQuestions: [
      'Mon-train-était-en-retard-comment-me-faire-rembourser-?',
      'Circulation-des trains-Comment-savoir-si-mon-train-est annulé-ou-pas ?',
    ],
  },
  {
    name: 'comment-annuler-ou-échanger-mon-billet',
    title: 'Comment annuler ou échanger mon billet ?',
    meta: {
      title: 'FAQ Que faire si je souhaite échanger ou annuler mon billet ?',
      description:
        'Vous avez changé d’avis ? Vous souhaitez modifier votre billet ? Vous êtes au bon endroit ! ',
    },
    category: ['service-apres-vente'],
    updatedDate: '08/06/2023',
    content: [
      {
        type: 'body',
        content: `<p>En cas d'imprévus perturbant vos voyages, il peut être nécessaire de modifier ou d'annuler vos billets.</p>
                <p>Heureusement, nous avons une bonne nouvelle à vous annoncer : vous pouvez effectuer l'annulation de votre trajet. Pour cela, il vous suffit de vous rendre sur votre espace personnel et de renseigner votre numéro de commande ainsi que votre adresse e-mail.</p> 
        `,
      },
      {
        type: 'buttonLink',
        content: 'Accéder à ma réservation',
        href: 'https://www.tictactrip.eu/login',
      },
      {
        type: 'body',
        content:
          '<p>Si vous avez besoin de modifier vos billets, consultez nos conseils ci-dessous pour les procédures spécifiques à suivre en fonction de la compagnie ou du mode de transport que vous avez choisi.</p>',
      },
      {
        type: 'img',
        content: 'comment-échanger-ou-annuler-mon-billet.jpg',
        alt: 'comment échanger ou annuler mon billet ?',
      },
      {
        type: 'title',
        content: 'Blablacar Bus',
      },
      {
        type: 'body',
        content:
          '<p>Pour annuler votre trajet Blablacar, il vous suffit de vous rendre sur votre espace personnel et de renseigner votre numéro de commande ainsi que votre adresse e-mail : <a style="color: initial" href="https://www.tictactrip.eu/login"><strong>Annuler mon trajet</strong></a>.</p>',
      },
      {
        type: 'body',
        content:
          "<p>Pour modifier votre trajet de notre partenaire Blablacar, c'est directement auprès de Blablabus. C’est assez simple (et rapide). Rendez-vous avant le départ du bus sur le site <a style='color: initial' href='https://booking.bus.blablacar.com/fr-FR/booking-login'><strong>booking.bus.blablacar</strong></a>.</p>",
      },
      {
        type: 'body',
        content: `
          <ul>
            <li>Remplir votre numéro de réservation : Vous pouvez retrouver le numéro en haut à gauche de votre billet, il est composé de 6 caractères.</li>
            <li>Remplir l'adresse mail utilisée.</li>
          </ul>
        `,
      },
      {
        type: 'body',
        content:
          'À savoir : une fois votre demande d’annulation réalisée, vous allez recevoir <strong>un bon d’achat</strong> pour Blablabus utilisable pour un prochain trajet et valable un an.',
      },
      {
        type: 'title',
        content: 'Flixbus',
      },
      {
        type: 'body',
        content:
          '<p>Pour annuler votre trajet Flixbus, il vous suffit de vous rendre sur votre espace personnel Tictactrip et de renseigner votre numéro de commande ainsi que votre adresse e-mail : <a style="color: initial" href="https://www.tictactrip.eu/login"><strong>Annuler mon trajet</strong></a>.</p>',
      },
      {
        type: 'body',
        content:
          '<p>Vous obtiendrez un bon d’achat d’une validité d’un an. Celui-ci sera utilisable uniquement le sur le site <a style="color: initial" href="http://flixbus.fr">Flixbus.fr</a>.  Attention, Flixbus applique des frais d’annulation en fonction de la date de votre départ. Plus votre départ est proche, plus les frais seront importants.</p>',
      },
      {
        type: 'body',
        content:
          '<p>Malheureusement, il n’est pas possible de modifier votre trajet Flixbus pour le moment. Nous vous invitons donc à annuler votre trajet et faire une nouvelle commande en utilisant le bon d’achat ou à contacter le service client.</p>',
      },
      {
        type: 'title',
        content: 'SNCF',
      },
      {
        type: 'body',
        content:
          '<p>Pour annuler votre trajet SNCF, il vous suffit de vous rendre sur votre espace personnel et de renseigner votre numéro de commande ainsi que votre adresse e-mail : <a style="color: initial" href="https://www.tictactrip.eu/login"><strong>Annuler mon trajet</strong></a>.</p>',
      },
      {
        type: 'body',
        content:
          "<p>Pour modifier votre trajet de notre partenaire SNCF, veuillez contacter notre service client. Il vous suffit d'indiquer la nouvelle date et l'horaire que vous avez choisi pour votre voyage. Notre équipe se fera un plaisir de vous aider à effectuer ces modifications. <a style='color: initial' href='https://www.tictactrip.eu/support'><strong>Échanger mon billet</strong></a>.</p>",
      },
      {
        type: 'title',
        content: 'OUIGO',
      },
      {
        type: 'body',
        content:
          '<p>Chez OuiGo, il n’est malheureusement pas possible d’annuler les billets. En revanche, la compagnie Ouigo, permet désormais à ses clients de modifier leurs billets.</p>',
      },
      {
        type: 'body',
        content:
          '<p>Pour accéder à votre réservation, il vous suffit de vous connecter sur <strong><a style="color: initial" href="https://ventes.ouigo.com/fr-FR/after-sale/connection">Ouigo.fr</a></strong> dans la rubrique “Mes réservations” avec votre <strong>adresse mail</strong> ainsi qu’avec votre <strong>numéro de réservation</strong>. Lorsque vous réservez un billet Ouigo, la compagnie envoie automatiquement un mail de confirmation qui contient votre numéro de réservation. Il est constitué <strong>d’une suite de 6 chiffres et lettres</strong>.</p>',
      },
      {
        type: 'body',
        content:
          '<p>Une fois, connecté, vous pourrez alors accéder à votre réservation et modifier votre billet à la date voulue. À noter que la compagnie applique des frais de service en plus de la différence tarifaire entre l’ancien et le nouveau billet.</p>',
      },
      {
        type: 'body',
        content:
          "<br/> <br/>En cas de doutes ou de questions, notre équipe est aussi  disponible du lundi au dimanche, de 9h30 à 18h30, prêts à sauver vos voyages en cas d'imprévus ! <br/>",
      },
    ],
    relatedQuestions: [
      'Politique-d-annulation-et-de-remboursement-des-billets',
      'Je-souhaite-échanger-mon billet-?',
    ],
  },
];

export default faqArticles;
